export default {
  locale: 'de',
  messages: {
    accountMy: 'Mein Konto',
    actions: 'Aktionen',
    add: 'Hinzufügen',
    addressAddNew: 'Neue Adresse hinzufügen',
    addressCity: 'Stadt',
    addressCountries: 'Länder',
    addressCountry: 'Land',
    addressDeleteConfirmTitle: 'Eine Adresse löschen',
    addressDeleteConfirmMessage: 'Möchten Sie diese Adresse wirklich löschen?',
    addressDeleteSuccess: 'Adresse erfolgreich gelöscht!',
    addressEdit: 'Adresse bearbeiten',
    addressFlags: 'Flaggen',
    addressInvoice: 'Rechnungsadresse',
    addressInvoiceDifferentAsShippingLabel: 'Weichen die Rechnungsdaten von der Lieferadresse ab?',
    addressInvoiceSelectionTitle: 'Wählen Sie Ihre Rechnungsadresse',
    addressInvoiceUsedFor: 'Wird für die Rechnung verwendet',
    addressInvoiceUse: 'Für die Rechnung verwenden',
    addressLabel: 'Bezeichnung der Adresse (z.B. Zuhause, Büro)',
    addressLegalInformation: 'Rechtliche Informationen',
    addressMy: 'Meine Adressen',
    addressName: 'Vor- und Nachname des Empfängers',
    addressNoItems: 'Sie haben noch keine Adresse gespeichert!',
    addressPhone: 'Telefon (erforderlich für die Zustellung)',
    addressPostalCode: 'Postleitzahl',
    addressRegion: 'Staat / Provinz',
    addressShipping: 'Lieferadresse',
    addressShippingSelectionTitle: 'Wählen Sie Ihre Lieferadresse',
    addressStreet1: 'Straße und Hausnummer',
    addressStreetNumberHint: 'Denken Sie an die Hausnummer: ohne sie findet der Versanddienst die Adresse oft nicht.',
    addressPostalCodeInvalid: 'Diese Postleitzahl passt nicht zum ausgewählten Land.',
    addressPhoneInvalid: 'Diese Nummer scheint falsch zu sein. Der Versanddienst nutzt sie, um Sie zu erreichen.',
    addressPhoneMobileHint: 'Eine Mobilnummer ist empfehlenswert: die Benachrichtigung kommt per SMS.',
    addressIssueTitle: 'Diese Adresse muss vor dem Versand vervollständigt werden',
    addressIssueIncomplete: 'Es fehlen Pflichtangaben.',
    addressIssuePostalCode: 'Prüfen Sie die Postleitzahl für das ausgewählte Land.',
    addressIssuePhone: 'Eine erreichbare Telefonnummer ist nötig: der Versanddienst ruft an oder schickt die Benachrichtigung.',
    addressIssueRegion: 'Wählen Sie den vom Versanddienst verlangten Staat oder die Provinz.',
    addressIssueTaxId: 'Der Zoll verlangt für dieses Ziel eine Steuernummer.',
    addressIssueComplete: 'Diese Adresse vervollständigen',
    addressStreet2: 'Adresszusatz (Wohnung, Etage, Hinterhaus...)',
    administrationTitle: 'Verwaltung',
    affiliationComment: 'Kommentar',
    affiliationCommission: 'Provision',
    affiliationCommissionMultiplePendingAlert: 'Diese Liste ist eine Schätzung: Bestellungen & Provisionen sind noch nicht endgültig verbucht!',
    affiliationCommissionPendingAlert: 'Diese Bestellung wartet auf Bestätigung',
    affiliationDeleteConfirmMessage: 'Möchten Sie diese Partnerschaft wirklich löschen?',
    affiliationInvoiceTotalTitle: 'Gesamtbetrag (inkl. MwSt.)',
    affiliationKey: 'Partner-Schlüssel',
    affiliationLegalApplyVAT: 'MwSt. anwenden?',
    affiliationLegalInformations: 'Rechtliche Informationen (Rechnung, Steuernummer...)',
    affiliationMy: 'Meine Partnerschaften',
    affiliationOptionValidityDays: 'Gültigkeit des Partnerlinks (Tage)',
    affiliationSince: 'Mitglied seit',
    affiliationViewResultsMy: 'Partner-Einnahmen ansehen',
    affiliations: 'Partnerschaften',
    alertContactError: 'Ihre Nachricht konnte nicht gesendet werden! Bitte versuchen Sie es erneut...',
    alertContactSuccess: 'Erfolgreich empfangen!',
    alertConversationNoExists: 'Dieser Chat existiert nicht!',
    alertFetchApiError: 'Der Server ist derzeit leider nicht erreichbar...',
    alertFormRequiredFieldsError: 'Bitte füllen Sie alle Pflichtfelder aus!',
    alertGenericError: 'Ein Fehler ist aufgetreten! Bitte versuchen Sie es später noch einmal...',
    alertInstitutionAlreadyExists: 'Diese Einrichtung existiert bereits!',
    alertJsonParseError: 'Der Server hat eine ungültige Antwort zurückgegeben...',
    alertOrderValid: 'Ihre Bestellung ist bereit zur Bearbeitung!',
    alertUnauthorized: 'Ihre Sitzung ist abgelaufen! Bitte melden Sie sich erneut an.',
    alertUserAlreadyExists: 'Es existiert bereits ein Konto mit dieser E-Mail-Adresse!',
    alertUserRegisterSuccess: 'Willkommen an Bord!',
    app404ErrorText: 'Wir können nicht finden, wonach Sie suchen! Kehren Sie zur Startseite oder zu Ihrem Konto zurück.',
    app404ErrorTitle: 'Falscher Weg...',
    appAccessButton: 'Zugang zu {app}',
    appAgreementAcceptButton: 'Allgemeine Geschäftsbedingungen lesen',
    appAgreementAcceptHelp: 'Sie können die Bedingungen lesen, indem Sie auf diesen Link klicken',
    appAgreementAcceptClickHint: 'Hier klicken, um zu bestätigen und zu akzeptieren',
    appAgreementAcceptLabel: 'Ich habe die Allgemeinen Geschäftsbedingungen gelesen und stimme zu',
    appApplication: 'App',
    appBackHomeButton: 'Zurück zur Startseite',
    appBackHomeTitle: 'Sie haben sich verlaufen...',
    appBugErrorText: 'Es ist ein Problem aufgetreten... ENTSCHULDIGUNG! Bitte klicken Sie auf den unten stehenden Link, um diese Seite neu zu laden...',
    appConditionsAcceptTitle: 'Allgemeine Nutzungsbedingungen',
    appConditionsCheckError: 'Bitte setzen Sie einen Haken, um zu bestätigen, dass Sie die Nutzungsbedingungen gelesen haben!',
    appConditionsCheckLabel: 'Ich habe die Allgemeinen Nutzungsbedingungen gelesen und akzeptiere sie',
    appConditionsCheckSuccess: 'Verstanden!',
    appConditionsUpdateDate: 'Aktualisiert am {date}',
    appConfig: 'Konfig',
    appConfiguration: 'Konfiguration',
    appCookieConsentPrivacyLink: 'Sehen Sie sich unsere Datenschutzrichtlinie an',
    appCookieConsentText: 'Wenn Sie weiter auf dieser Website surfen, stimmen Sie der Verwendung von Cookies für den ordnungsgemäßen Betrieb des Dienstes und für statistische Zwecke zu. Wir geben keine persönlichen Daten ohne Ihre vorherige Zustimmung weiter.',
    appCreateIndexButton: 'Datenbankindex erstellen',
    appDataPrivacyCheckButton: 'Lesen Sie unsere Datenschutzbestimmungen',
    appDatabase: 'Datenbank',
    appErrorAlertText: 'Etwas Unerwartetes ist passiert... Keine Panik! Kontaktieren Sie uns und wir werden Ihr Problem so schnell wie möglich lösen.',
    appErrorAlertTitle: 'Ein Fehler ist aufgetreten!',
    appForceUpdateApp: 'App-Update erzwingen',
    appForceUpdateAppWeb: 'Web-App-Update erzwingen',
    appHome: 'Startseite',
    appMaintenanceModeText: 'Bitte haben Sie einen Moment Geduld und versuchen Sie es gleich noch einmal...',
    appMaintenanceModeTitle: 'Wir führen gerade Wartungsarbeiten durch',
    appProcessLaunch: 'Startvorgang',
    appQuestionLink: 'Noch Fragen?',
    appRewiewsHeaderText: 'Hergestellt in Frankreich 🇫🇷 mit Liebe ❤️ - 4.6 ⭐️ ⭐️ ⭐️ ⭐️ ⭐️ +500 Trustpilot-Bewertungen',
    appShopOrderHistory: 'Bestellverfolgung',
    appStart: 'Gestalten Sie Ihr Buch',
    appVersion: 'Version',
    appVersionCurrent: 'Aktuelle App-Version: {version}',
    appWebsiteAboutUs: 'Unsere Geschichte',
    appWebsiteBlog: 'Blog',
    appWebsiteBook: 'Das Buch',
    appWebsiteConversationAndroid: 'Android-SMS drucken',
    appWebsiteConversationInstagram: 'Instagram-Nachrichten drucken',
    appWebsiteConversationIos: 'iPhone iMessages/SMS drucken',
    appWebsiteConversationMessenger: 'Messenger-Nachrichten drucken',
    appWebsiteConversationWhatsapp: 'WhatsApp-Nachrichten drucken',
    appWebsiteConversations: 'Wählen Sie Ihren Messenger',
    appWebsiteFaq: 'FAQ',
    appFooterQuestion: 'Haben Sie eine Frage?',
    appFooterTerms: 'Nutzungsbedingungen',
    appWebsitePrices: 'Preise',
    appWelcomeTitle: 'Willkommen bei {name}',
    apply: 'Anwenden',
    back: 'Zurück',
    by: 'von',
    cancel: 'Abbrechen',
    cartAddTo: 'In den Warenkorb',
    cartAuthInfo: 'Bitte geben Sie Ihre E-Mail-Adresse ein, um fortzufahren...',
    cartContinuePurchase: 'Weiter einkaufen',
    cartEmptyError: 'Ihr Warenkorb ist leer...',
    cartItemsRemoveAll: 'Alles entfernen',
    cartMy: 'Mein Warenkorb',
    cartMyEdit: 'Warenkorb bearbeiten',
    cartNextStepButton: 'Weiter zum nächsten Schritt',
    cartNoItems: 'Es befinden sich keine Artikel in Ihrem Warenkorb.',
    cartNote: 'Anmerkung',
    cartProgression: 'Fortschritt',
    cartSalesConditionsAccept: 'Mit der Bestätigung Ihrer Bestellung akzeptieren Sie unsere Verkaufsbedingungen.',
    cartSee: 'Warenkorb ansehen',
    cartShipping: 'Lieferung',
    cartShippingFeeError: 'Wir können leider nicht an diese Adresse liefern! Bitte geben Sie eine andere Adresse an.',
    cartStepConfirmationTitle: 'Bestätigung',
    cartStepInvoiceTitle: 'Rechnung',
    cartStepPaymentTitle: 'Zahlung',
    cartStepPreviewTitle: 'Warenkorb',
    cartStepShippingTitle: 'Versand',
    cartTotalShipping: 'Versandkosten',
    cartTotalSubTotal: 'Zwischensumme',
    cartTotalTax: 'MwSt.',
    cartTotalTotal: 'Gesamt',
    cartValidButton: 'Bestellung bestätigen',
    checkoutEyebrow: 'Ihre Bestellung',
    checkoutStepUpsellTitle: 'Ein Exemplar oder zwei?',
    checkoutStepUpsellTitleGroup: 'Ein Exemplar, zwei? Oder mehr?',
    checkoutStepUpsellHint: 'Behalten Sie eins, verschenken Sie eins, oder beides.',
    checkoutStepUpsellHintGroup: 'Für jeden eins: Rabatt ab dem zweiten Exemplar.',
    checkoutStepShippingTitle: 'Wohin sollen wir Ihr Buch senden?',
    checkoutStepShippingHint: 'Wir drucken es mit Sorgfalt und versenden es weltweit.',
    checkoutStepInvoiceTitle: 'Ihre Angaben',
    checkoutStepInvoiceHint: 'Für Ihre Rechnung und die Bestellverfolgung.',
    checkoutStepPaymentTitle: 'Sicher bezahlen',
    checkoutStepPaymentHint: 'Kreditkarte, Apple Pay, Google Pay: verschlüsselte Zahlung.',
    checkoutPdfReadyTitle: 'Ihr eBook ist bereit',
    checkoutPdfReadyHint: 'Kein Versand nötig, schließen Sie Ihre Bestellung ab.',
    checkoutSummaryEyebrow: 'Übersicht',
    cartReassuranceSecure: 'Sichere Zahlung',
    cartReassuranceReturn: 'Geld-zurück-Garantie',
    cartReassuranceSupport: 'Kundenservice',
    checkoutPromoEyebrow: 'Gutscheincode',
    checkoutGiftEyebrow: 'Geschenkkarte',
    checkoutGiftCodeLabel: 'Geschenkcode',
    checkoutGiftCodePlaceholder: 'Geschenkcode eingeben',
    checkoutGiftCodeHint: 'Geschenkkarte erhalten? Geben Sie Ihren Code hier ein.',
    checkoutGiftToggle: 'Haben Sie eine Geschenkkarte?',
    checkoutAddCopy: 'Ein weiteres Exemplar',
    checkoutSecondCopyKicker: 'Für Sie, oder zum Verschenken',
    checkoutSecondCopyKickerGroup: 'Für jeden eins',
    checkoutSecondCopyTitle: 'Das zusätzliche Exemplar, zum halben Preis',
    checkoutSecondCopyTitlePercent: 'Das zusätzliche Exemplar',
    checkoutSecondCopyFor: 'dieses Exemplar',
    checkoutSecondCopyForGroup: 'das 2.',
    checkoutSecondCopyChip: '2. zum halben Preis',
    checkoutSecondCopyChipPercent: '2. mit −{percent} %',
    checkoutSecondCopySet: 'Alle {count} Bände, zusammen',
    checkoutSecondCopyPerBook: 'jedes Buch',
    checkoutSecondCopySetPrice: '{price} für alle {count} Bände',
    checkoutExtraBooksChip: 'weitere Bücher zum halben Preis',
    checkoutExtraBooksChipPercent: 'weitere Bücher zu −{percent} %',
    checkoutGroupQtyHint: 'Das dritte auch: jedes weitere Buch zu −{percent} %.',
    productExtraCopyRate: 'Weitere Bücher, in % vom Preis eines Buches',
    productExtraCopyRateHelp: 'Jedes Buch ab dem zweiten Exemplar kostet diesen Prozentsatz vom Preis eines Buches. Leer: 50 %. 0: Mengenstaffel.',
    checkoutGroupPicksLabel: 'Exemplare',
    checkoutGroupAddSecond: '2.',
    checkoutGroupAddThird: '3',
    checkoutGroupAddSecondAria: 'Zweites Exemplar zum halben Preis hinzufügen',
    checkoutGroupAddThirdAria: 'Auf drei Exemplare wechseln',
    checkoutQtyGroupHint: 'Für jeden eines: der Rabatt gilt ab dem zweiten Exemplar.',
    checkoutQtyPdfSingle: '1 eBook',
    checkoutQtyMoreAriaLabel: 'Andere Menge',
    checkoutQtyVolumeBreakdown: '{copies} Exemplare × {volumes} Bände = {total} Bücher',
    checkoutOfferBookCount: '{count, plural, one {# Buch} other {# Bücher}}',
    checkoutUpsellTwoHint: 'Ideal zum Verschenken: fügen Sie ein zweites Exemplar hinzu, der Rabatt gilt automatisch.',
    checkoutEmptyTitle: 'Keine laufende Bestellung',
    checkoutEmptyHint: 'Kehren Sie zu Ihrem Buch zurück, um Ihre Ausgabe zu wählen.',
    checkoutEmptyCta: 'Meine Konversationen ansehen',
    checkoutBookAsideEyebrow: 'Ihr Buch',
    checkoutBookAsideEyebrowPlural: 'Ihre Bücher',
    checkoutBookAsideVolume: 'Band',
    checkoutBookAsideVolumes: 'Bände',
    checkoutBookAsideShelfLabel: 'Die {count} Bände Ihrer Bestellung',
    checkoutBookAsideEbook: 'eBook',
    checkoutBookAsidePaper: 'Gedrucktes Buch',
    checkToggler: 'Alles auswählen/abwählen',
    choose: 'Wählen',
    close: 'Schließen',
    cmsDeleteConfirmTitle: 'Inhalt löschen',
    cmsDeleteConfirmMessage: 'Möchten Sie diesen Inhalt wirklich löschen?',
    companyShippingEdit: 'Versand bearbeiten',
    conditions: 'Bedingungen',
    configMissingKeyAlert: 'Der Konfigurationsschlüssel fehlt!',
    configuration: 'Konfiguration',
    confirm: 'Bestätigen',
    confirmMessage: 'Bitte bestätigen Sie Ihre Aktion.',
    confirmTitle: 'Sind Sie sicher?',
    contactButton: 'Kontaktieren Sie uns',
    contactMessage: 'Nachricht',
    contactPageButton: 'Senden',
    contactPageText1: 'Brauchen Sie Hilfe? Oder Informationen? Wir sind für Sie da!',
    contactPageTitle: 'Kontakt',
    contactSend: 'Senden',
    continue: 'Weiter',
    conversationActionContinue: 'Fortfahren',
    conversationActionRestart: 'Neu beginnen',
    conversationAddTitle: 'Einen Chat hinzufügen',
    conversationAdminDeleteConfirmTitle: 'Chat löschen',
    conversationAdminDeleteConfirmMessage: 'Dieser Chat und alle zugehörigen Medien werden endgültig gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.',
    conversationArchiveError: 'Wir können Ihre Datei nicht lesen! Bitte kontaktiere uns, um das Problem zu beheben...',
    conversationBookOrderTypeBook: 'Gedrucktes Buch + Gratis eBook(s)',
    conversationBookOrderTypePdf: 'Nur eBook(s)',
    conversationBookPreview: 'Vorschau',
    conversationBookPreviewSelected: 'Vorschau von Buch Nr. {number}',
    conversationBookSelector: 'Wählen Sie das Buch zum Bearbeiten',
    conversationBookTypeLabelBook: 'Papierbuch + eBook',
    conversationBookTypeLabelPdf: 'Nur eBook',
    conversationBooks: 'Bücher',
    conversationCollectorArchiveSelectButton: 'Eine Datei hochladen',
    conversationCollectorInitWaiting: 'Wir bereiten Ihre Daten vor... Bitte haben Sie einen Moment Geduld',
    conversationCollectorUseArchive: 'Ein Backup hochladen (.zip Datei)',
        conversationCoverBookEdit: 'Umschlag gestalten',
    conversationCoverBookReset: 'Das Cover dieses Buches zurücksetzen',
    conversationCoverApplyToAllBooks: 'Dieses Cover auf alle Bände anwenden',
    conversationCoverAutoAppliedToAllBooks: 'Cover auf die anderen Bände angewendet.',
    conversationCoverApplyToAllBooksTitle: 'Dieses Cover auf alle Bände anwenden?',
    conversationCoverApplyToAllBooksMessage: 'Wählen Sie die Elemente, die auf alle anderen Bände angewendet werden sollen.',
    conversationCoverApplyOptionColor: 'Farbe',
    conversationCoverApplyOptionPhoto: 'Foto',
    conversationCoverApplyOptionTitle: 'Titel',
    conversationCoverApplyOptionSubtitle: 'Untertitel',
    conversationCoverBookSwitchAlertMessage: 'Es werden nur die Cover-Informationen für dieses spezielle Buch gespeichert.',
    conversationCoverBookSwitchAlertTitle: 'Möchten Sie das Cover für dieses Buch speichern?',
        conversationCoverColorEditTitle: 'Wählen Sie Ihr Cover',
        conversationCoverLuxEyebrow: 'Ihr Cover',
        conversationCoverLuxHint: 'Wählen Sie Modell und Farbe, dann gestalten Sie das Cover.',
        conversationParticipantsLuxEyebrow: 'Ihr Gespräch',
        conversationParticipantsLuxHint: 'Bearbeiten Sie Namen, Blasenfarben und die Position links/rechts für jeden Teilnehmer.',
        conversationParticipantsLuxSavePreview: 'Speichern · zurück zur Vorschau',
        conversationParticipantsLuxSaved: 'Gespeichert',
        conversationParticipantsSameSideHint: 'Mehrere Teilnehmer sind auf derselben Seite. Prüfen Sie die Position links/rechts.',
        conversationParticipantColorBlushClair: 'Helles Blush',
        conversationParticipantColorCielClair: 'Heller Himmel',
        conversationParticipantColorLavandeClaire: 'Helles Lavendel',
        conversationParticipantColorPruneClaire: 'Helles Pflaume',
        conversationParticipantColorPecheClaire: 'Heller Pfirsich',
        conversationParticipantColorSaugeClair: 'Heller Salbei',
        conversationParticipantColorMiel: 'Honig',
        conversationParticipantColorPerle: 'Perle',
        conversationParticipantNameError: 'Der Name ist zu lang (max. {max} Zeichen)',
        conversationParticipantPositionLeft: 'Links',
        conversationParticipantPositionRight: 'Rechts',
        conversationDatesLuxEyebrow: 'Ihre Geschichte',
        conversationDatesLuxHint: 'Wählen Sie Start- und Enddatum des Buches. Klicken Sie auf eine Nachricht, um die Auswahl zu verfeinern.',
        conversationDatesLuxNextEnd: 'Enddatum',
        conversationDatesLuxBackStart: 'Startdatum',
        conversationDatesLuxSavePreview: 'Speichern · zurück zur Vorschau',
        conversationDatesPresetsLabel: 'Schnelle Zeitraumauswahl',
        conversationDatesPreset_all: 'Gesamte Unterhaltung',
        conversationDatesPreset_year: 'Letztes Jahr',
        conversationDatesPreset_sixMonths: 'Letzte 6 Monate',
        conversationDatesSelectionCount: '{count, number} {count, plural, one {Nachricht} other {Nachrichten}}',
        conversationDatesSelectionPeriod: 'vom {start} bis {end}',
        conversationDatesStoryDuration: 'Diese Auswahl umfasst {duration}',
        conversationDatesStartCaption: 'Ihre allererste Nachricht',
        conversationDatesEndCaption: 'Ihre allerletzte Nachricht',
        conversationDatesBookMessages: '{messages, number} {messages, plural, one {Nachricht} other {Nachrichten}}, {photos, number} {photos, plural, one {Foto} other {Fotos}} und {medias, number} {medias, plural, one {Medium} other {Medien}} in Ihrer Auswahl',
        conversationDateSelectionEmpty: 'Keine Nachrichten in diesem Zeitraum. Erweitern Sie die Auswahl.',
        conversationMessagesLuxEyebrow: 'Ihr Buch',
        conversationMessagesLuxHint: 'Suchen, ausblenden oder bearbeiten Sie Nachrichten. Ihre Änderungen gelten für die Auswahl.',
        conversationMessagesLuxSavePreview: 'Speichern · zurück zur Vorschau',
        conversationMessagesLuxBackPreview: 'Vorschau ansehen',
        conversationMessagesLuxCount: '{messages, number} {messages, plural, one {Nachricht} other {Nachrichten}}, {photos, number} {photos, plural, one {Foto} other {Fotos}} und {medias, number} {medias, plural, one {Medium} other {Medien}} in Ihrer Auswahl',
        conversationMessagesFilterResults: '{count, number} {count, plural, one {Ergebnis} other {Ergebnisse}}',
        conversationMessagesOnlyHidden: 'Nur ausgeblendete',
        conversationMessagesResetFilters: 'Filter zurücksetzen',
        conversationMessagesShowHidden: 'Ausgeblendete Nachrichten anzeigen',
        conversationMessagesResetChanges: 'Alle Änderungen rückgängig machen',
        conversationMessagesResetChangesButton: 'Alles rückgängig machen',
        conversationMessagesResetChangesConfirm: 'Die Unterhaltung wird in ihren ursprünglich importierten Zustand zurückgesetzt. Alle Ihre Änderungen (ausgeblendete, bearbeitete oder hinzugefügte Nachrichten) gehen endgültig verloren. Fortfahren?',
        conversationMediaTypePhotos: 'Fotos',
        conversationMediaTypeVideos: 'Videos',
        conversationMediaTypeAudios: 'Audios',
        conversationMediaTypeLinks: 'Links',
        conversationMediaTypeOther: 'Andere',
        conversationMessagesToolSearch: 'Suchen',
        conversationMessagesToolMedias: 'Medien',
        conversationMessagesToolDates: 'Daten',
        conversationMessagesToolHidePeriod: 'Zeitraum ausblenden',
        conversationMessagesToolHidden: 'Anzeige',
        conversationMessagesToolReset: 'Änderungen',
        conversationMessagesToolResetNone: 'Keine',
        conversationMessagesToolResetCount: '{count, number} {count, plural, one {Änderung} other {Änderungen}}',
        conversationMessagesHiddenViewHint: 'Wählen Sie, welche Nachrichten in der Liste unten erscheinen.',
        conversationMessagesHiddenViewAll: 'Alle',
        conversationMessagesHiddenViewVisible: 'Nur sichtbare',
        conversationMessagesHiddenViewHidden: 'Nur ausgeblendete',
        conversationMessagesResetChangesHint: 'Setzt die Unterhaltung in ihren ursprünglich importierten Zustand zurück. Alle Ihre Änderungen (ausgeblendete, bearbeitete oder hinzugefügte Nachrichten) gehen verloren.',
        conversationMessagesToolSearchNone: 'Keine',
        conversationMessagesToolMediasAll: 'Alle Nachrichten',
        conversationMessagesToolDatesAll: 'Gesamter Zeitraum',
        conversationMessagesToolHidePeriodNone: 'Kein Zeitraum',
        conversationMessagesToolHiddenShown: 'Angezeigt',
        conversationMessagesToolHiddenMasked: 'Ausgeblendet',
        conversationMessagesBestofCuratedHint: 'Ihr Best Of ist fertig zusammengestellt: Es ist bereits bis zur maximalen Seitenzahl gefüllt. Sie können Nachrichten ausblenden und andere wieder einblenden, solange das Buch dadurch nicht länger wird.',
        conversationMessagesBestofFullError: 'Ihr Best Of ist bereits voll. Um diese Nachrichten anzuzeigen, blenden Sie zuerst rund {pages, number} {pages, plural, one {Seite} other {Seiten}} an anderer Stelle aus.',
        conversationMessagesHidePeriodHint: 'Blenden Sie alle Nachrichten zwischen zwei Daten auf einmal aus (oder wieder ein).',
        conversationMessagesHidePeriodFrom: 'Von',
        conversationMessagesHidePeriodTo: 'Bis',
        conversationMessagesHidePeriodCount: '{count, number} {count, plural, one {Nachricht} other {Nachrichten}} in diesem Zeitraum ({visible} sichtbar, {hidden} ausgeblendet)',
        conversationMessagesHidePeriodConfirmHide: '{count, number} {count, plural, one {Nachricht} other {Nachrichten}} dieses Zeitraums ausblenden?',
        conversationMessagesHidePeriodConfirmShow: '{count, number} {count, plural, one {Nachricht} other {Nachrichten}} dieses Zeitraums wieder anzeigen?',
        conversationMessagesHidePeriodHide: 'Diesen Zeitraum ausblenden',
        conversationMessagesHidePeriodShow: 'Diesen Zeitraum wieder anzeigen',
        conversationMessagesHidePeriodItem: 'Zeitraum {index}',
        conversationMessagesHidePeriodAdd: 'Zeitraum hinzufügen',
        conversationMessagesHidePeriodInvalid: 'Das Enddatum muss nach dem Startdatum liegen.',
        conversationMessagesToolHidePeriodCount: '{count, number} {count, plural, one {Zeitraum} other {Zeiträume}}',
        conversationMessagesSearchPlaceholder: 'Ein Wort, einen Namen suchen…',
        conversationCoverResumeLuxEyebrow: 'Vorwort',
        conversationCoverResumeLuxHint: 'Optional: dieser Text wird auf der Innenseite des Covers gedruckt.',
        conversationCoverBookNumber: 'Band {number}',
        conversationCoverFooterPrefaceGuide: 'Mit Zurück zur Vorschau ohne Vorwort, oder weiter zum optionalen Vorwort auf dem Innendeckel.',
        conversationCoverFooterNextPreface: 'Vorwort (optional)',
        conversationCoverFooterSkipPreface: 'Vorwort überspringen · zurück zur Vorschau',
        conversationCoverFooterBackToCover: 'Zurück zum Cover',
        conversationCoverFooterFinishPreview: 'Fertig · zurück zur Vorschau',
        conversationCoverFooterGoPreview: 'Zurück zur Vorschau',
    conversationCoverEditionTypeTitle: 'Buchausgabe',
    conversationCoverEditionTypeBookHelp: 'Bei der vollständigen Sammlung können Sie das Cover jedes Bandes einzeln anpassen.',
    conversationCoverColorSelectorHelp: 'Wählen Sie die Farbe des Covers',
    conversationCoverStyleSelectorHelp: 'Wählen Sie das Cover-Modell',
    conversationCoverStylePhoto: 'Polaroid',
    conversationCoverStyleIncipit: 'Erste Nachricht',
    conversationCoverPickMessageTitle: 'Nachricht wählen',
    conversationCoverEditQuote: 'Zeile ändern',
    conversationCoverPickMessageHint: 'Sie steht groß auf dem Umschlag.',
    conversationCoverPickMessageSearch: 'Nachricht suchen',
    conversationCoverPickMessageEmpty: 'Keine Nachricht passt.',
    conversationCoverAddQuote: 'Eine Zeile hinzufügen',
    conversationCoverHourLabel: 'Uhrzeit',
    conversationCoverDateLabel: 'Datum',
    conversationCoverGroupNameLabel: 'Gruppenname',
    conversationCoverSpanLabel: 'Daten der ersten und letzten Nachricht',
    conversationCoverApplyOptionStyle: 'Modell',
    conversationCoverApplyOptionQuote: 'Zeile',
    conversationCoverDragNDropFiles: 'Ziehen Sie ein Bild hierher (Drag & Drop)',
    conversationCoverTapToSelectPhoto: 'Tippen, um ein Foto auszuwählen',
    conversationCoverOpenFinder: 'Wählen Sie ein Bild aus',
    conversationCoverPhotoSelectorTitle: 'Wählen Sie ein Foto',
    conversationCoverPhotoEditHint: 'Klicken Sie, um das Foto zu ändern',
    conversationCoverPhotoChoose: 'Klicken Sie, um ein Foto zu wählen',
    conversationPreviewSwipeHint: 'Wischen, um umzublättern',
    conversationPreviewOpenBookHint: 'Wischen Sie über das Cover, um das Buch zu öffnen',
    conversationPreviewDiscoverBook: 'Mein Buch entdecken',
    conversationPreviewVolumesLabel: 'Ihre Sammlung: {count} Bücher',
    conversationPreviewVolumesHint: 'Tippen Sie auf ein Cover, um diesen Band zu öffnen.',
    conversationCoverResumeEditTitle: 'Schreiben Sie eine Widmung oder ein Vorwort (optional)',
    conversationCoverResumeError: 'Vorwort zu lang für eine Seite: kürze den Text oder reduziere Zeilenumbrüche.',
    conversationCoverResumeNearLimit: 'Grenze einer Seite fast erreicht ({lines}/{max} Zeilen).',
    conversationCoverResumeHelp: 'Dieses Vorwort wird auf die Innenseite des Buchdeckels (Umschlagseite 2) gedruckt.',
    conversationCoverResumePlaceholder: 'Schreiben Sie ein paar Worte, um Ihre Geschichte einzuleiten',
    conversationCoverResumeReset: 'Den Text dieses Buches zurücksetzen',
    conversationCoverTitleError: 'Titel ist zu lang (max. {max} Zeichen)',
    conversationCoverTitleHelp: 'Klicken Sie auf den Titel, um ihn zu bearbeiten',
    conversationCoverTitlePlaceholder: 'Geben Sie einen Titel ein...',
    conversationCoverDefaultTitleTwoNames: '{name1} & {name2}',
    conversationCoverDefaultTitleGroup: 'Unsere Gruppe',
    conversationCoverDefaultTitleSingle: 'Meine Nachrichten',
	conversationCoverWaitingForCustomization: 'Sie können Ihr Buchcover im nächsten Schritt personalisieren...',
    conversationCreateInfoText: 'Erstellen Sie ein neues Nachrichtenbuch, indem Sie hier auf die Icons klicken',
    conversationCreateMyBookTitle: 'Ich erstelle mein Buch',
    conversationCreateTitle: 'Ein Buch erstellen',
    conversationDateCreation: 'Erstellungsdatum',
    conversationDateDownloadedInfo: 'Das Buch wurde am {downloaded} heruntergeladen',
    conversationDateEnd: 'Ende des Chats',
    conversationDateEndInfo: 'Das Buch endet am {end}',
    conversationDateEndLabel: 'Enddatum auswählen',
    conversationDateEndMessageSelection: 'Das Buch hier beenden',
    conversationDateGeneratedInfo: 'Das Buch wurde am {generated} generiert',
    conversationDateRange: 'Vom {start} bis {end}',
    conversationDeleteConfirmation: 'Der Chat wurde gelöscht!',
    conversationDateSelectionAlert: 'Es scheint, dass Ihr Chat bei der Übertragung beschädigt wurde. Bitte versuchen Sie es erneut, bleiben Sie während der Übertragung auf der Seite und sorgen Sie für eine stabile Internetverbindung.',
    conversationDateSimulatedInfo: 'Das Buch wurde am {simulated} als Vorschau angezeigt',
    conversationDateStart: 'Beginn des Chats',
    conversationDateStartInfo: 'Das Buch beginnt am {start}',
    conversationDateStartLabel: 'Startdatum auswählen',
    conversationDateStartMessageSelection: 'Das Buch hier beginnen',
    conversationDatesEditTitle: 'Datumsauswahl',
    conversationPreviewPrefaceOptionalBadge: 'Optional',
    conversationPreviewPrefaceEmptyTitle: 'Ein Vorwort, wenn Sie möchten',
    conversationPreviewPrefaceEmptyText: 'Ein paar Worte zum Auftakt. Sie können diesen Schritt überspringen und später zurückkommen.',
    conversationPreviewPrefaceEmptyButton: 'Vorwort hinzufügen',
    conversationPreviewEndCta: 'Jetzt bestellen',
    conversationPreviewEndBodyPaused: 'Bestätigen Sie Ihre Änderungen. Die digitale Version erhalten Sie direkt danach per E-Mail, zum Durchsehen.',
    conversationPreviewEndCtaPaused: 'Änderungen bestätigen',
    conversationDemoAlert: 'Sie können nun die ersten Seiten Ihres Buches entdecken.<br></br>Sobald Sie bestellt haben, erhalten Sie die vollständige Version zur Überprüfung vor dem Druck.',
    conversationDemoEndAlert: 'Sie können den Rest Ihrer Nachrichten entdecken, nachdem Sie Ihren Kauf bestätigt haben.',
    conversationPreviewEndTitle: 'Mehr wartet auf Sie',
    conversationPreviewEndBody: 'Der Rest Ihrer Nachrichten wartet. Bestellen Sie, um Ihr Buch vollständig zu sehen.',
    conversationPreviewDemoBadge: 'MonLivreSMS',
    conversationPreviewPrefaceEmptyTitle: 'Ihr Vorwort (optional)',
    conversationPreviewPrefaceOptionalBadge: 'Optional',
    conversationPreviewPrefaceEmptyText: 'Ein paar Worte zum Auftakt. Sie können diesen Schritt überspringen und später zurückkommen.',
    conversationPreviewPrefaceEmptyButton: 'Mein Vorwort schreiben',
    conversationPreviewPrefaceEditButton: 'Vorwort bearbeiten',

    conversationDisclaimerSubtitle: 'Wählen Sie Ihr Format, um zu unserer Personalisierungs-Werkstatt zu gelangen.',
    conversationDisclaimerTitle: `{count} {count, plural,
      =0 {Nachricht}
      =1 {Nachricht}
      other {Nachrichten}
    }: eine Geschichte, die es wert ist, gelesen zu werden`,
    conversationDisclaimerSavings: 'Sie sparst {value}',
    conversationDisclaimerEBookIncluded: 'Inklusive eBook-Ausgabe',
    conversationDisclaimerGenerating: 'Ihr Buch wird generiert...',

    conversationDisclaimerPlanSingleTitle: 'Band 1',
    conversationDisclaimerPlanSingleDescription: 'Das Wesentliche',
    conversationDisclaimerPlanSingleButtonText: 'Mein Buch erstellen',
    conversationDisclaimerPlanSingleFeaturePages: 'Das Buch Ihrer Wahl (400 Seiten) geliefert',
    conversationDisclaimerPlanSingleFeatureQuality: '',
    conversationDisclaimerPlanSingleFeatureEvolutive: 'Erweiterbar: Vervollständige die Sammlung später',
    conversationDisclaimerPlanSingleFeaturePremiumPaper: 'Premium-Papier',
    conversationDisclaimerPlanSingleFeaturePremiumPrint: 'Druck auf Premium-Papier',
    conversationDisclaimerPlanSingleFeaturePdfIncluded: 'PDF-Version inklusive (Wert: {price})',
    conversationDisclaimerPlanSingleFeatureWorkshop: 'Vollständige Personalisierung inklusive',
    conversationDisclaimerPlanSingleFeatureMedia: 'Fotos, Videos & Audios inklusive',

    conversationDisclaimerPlanCollectionTitle: 'Die komplette Sammlung',
    conversationDisclaimerPlanCollectionDescription: 'Das Gesamtwerk',
    conversationDisclaimerPlanCollectionButtonText: 'Unsere ganze Geschichte bewahren',
    conversationDisclaimerPlanCollectionBadge: 'PAKET-ANGEBOT -{percentage}%',
    conversationDisclaimerPlanCollectionFeatureBox: 'Ihre {count} Bücher gedruckt & geliefert',
    conversationDisclaimerPlanCollectionFeatureDiscount: 'Sammlungs-Tarif -{percentage}% (inkl. -{amount})',
    conversationDisclaimerPlanCollectionFeatureDigital: 'Digitale Ausgabe geschenkt',
    conversationDisclaimerPlanCollectionFeatureWorkshop: 'Vollständige Personalisierung inklusive',
    conversationDisclaimerPlanCollectionFeatureMedia: 'Fotos, Videos & Audios inklusive',

    conversationDisclaimerPlanEbookTitle: 'Die eBook-Edition',
    conversationDisclaimerPlanEbookDescription: 'Das digitale Format',
    conversationDisclaimerPlanEbookButtonText: 'Als PDF speichern',
    conversationDisclaimerPlanEbookFeaturePdf: 'Sofortiges High-Definition PDF',
    conversationDisclaimerPlanEbookFeatureShare: 'Einfach zu teilen',
    conversationDisclaimerPlanEbookFeatureMessages: 'Alle Ihre {count} Nachrichten',
    conversationDisclaimerPlanEbookFeatureMedia: 'Fotos, Videos & Audios inklusive',

    conversationDisclaimerReassuranceGuaranteeTitle: 'Zufriedenheitsgarantie',
    conversationDisclaimerReassuranceGuaranteeDescription: 'Garantierte Rückerstattung auf Anfrage bis zur finalen Bestätigung.',
    conversationDisclaimerReassuranceCustomTitle: 'Freie Personalisierung',
    conversationDisclaimerReassuranceCustomDescription: 'Bearbeite Ihr Cover und die Nachrichten nach der Zahlung',
    conversationDisclaimerReassuranceSecureTitle: '100% sichere Zahlung',
    conversationDisclaimerReassuranceSecureDescription: 'Kreditkarte, Apple Pay, Google Pay',
    conversationDisclaimerReassuranceDeliveryTitle: 'Schnelle Lieferung',
    conversationDisclaimerReassuranceDeliveryDescription: 'Lieferung zu Ihnen nach Hause in 5 Werktagen',

    conversationDisclaimerReviewSuffix: 'von +{count} gedruckten Büchern',

    conversationDowloadUnableAlert: 'Sie können die Bücher aus diesem Chat nicht mehr herunterladen... Kontaktieren Sie uns, um das Problem zu lösen.',
    conversationDownloadDeadlineInfo: 'Sie können Ihre Dateien bis zum {date} herunterladen',
    conversationDownloadLink: 'Mein Buch Nr. {index} herunterladen',
    conversationDownloadFileCoverLink: 'Das Cover {name} herunterladen',
    conversationDownloadFileSourceLink: 'Die Quelldatei {name} herunterladen',
    conversationDownloadPdfButton: 'Das eBook herunterladen',
    conversationDownloadPdfWaitingMessage: 'Bitte warten Sie 5 Minuten, bevor Sie erneut herunterladen',
    conversationEditStart: 'Das Buch bearbeiten',
    conversationEditSuccess: 'Der Chat wurde bearbeitet!',
    'conversationFormatLabelA4-1': 'Chroniken Ihrer Erinnerungen',
    'conversationFormatLabelA4-2': '(A4 Album)',
    'conversationFormatLabelA5-1': 'Der kleine Schatz',
    'conversationFormatLabelA5-2': '(A5 Format)',
    conversationGeneratedSuccess: 'Herzlichen Glückwunsch! <br></br> Ihr Chat wurde erfolgreich generiert!',
        conversationGenerationAlert: 'Wir gestalten gerade Ihr Buch…',
        conversationGenerationAlert2: 'Bleiben Sie kurz bei uns : das dauert nur einen Moment.',
        conversationGenerationFailed: 'Die Gestaltung Ihres Buches wurde unterbrochen.',
        conversationGenerationFailedHint: 'Ihre Nachrichten sind sicher gespeichert. Versuchen Sie es noch einmal. Wenn es wieder passiert, schreiben Sie uns, dann sehen wir es uns gemeinsam an.',
        conversationGenerationRetry: 'Erneut versuchen',
    conversationHelpBooksText: 'Wechseln Sie zwischen Ihren Büchern, um die spezifischen Informationen jedes einzelnen zu bearbeiten',
    conversationHelpBooksTitle: 'Buchauswahl',
    conversationHelpCoverColorText: 'Sie können die Hintergrundfarbe des Covers ändern, indem Sie auf den Kreis klicken.',
    conversationHelpCoverColorTitle: 'Farbe des Covers',
    conversationHelpCoverImageText: 'Sie können jedes beliebige Bild in diesen Bereich ziehen, um es Ihrem Cover hinzuzufügen.',
    conversationHelpCoverImageTitle: 'Titelbild',
    conversationHelpCoverTitleText: 'Klicken Sie auf den Titel, um ihn zu ändern! Ihnen stehen 2 Zeilen zur Verfügung: Titel und Untertitel.',
    conversationHelpCoverTitleTitle: 'Titel des Covers',
    conversationHelpDatePreviewText: 'Wählen Sie das Startdatum Ihrer Geschichte.',
    conversationHelpDatePreviewTitle: 'Datum',
    conversationHelpDateSelectorText: 'Wenn Sie das Datum änderst, werden hier Ihre ersten und letzten Nachrichten angezeigt!',
    conversationHelpDateSelectorTitle: 'Nachrichtenvorschau',
    conversationHelpParticipantColorText: 'Sie können die Farbe der Sprechblasen für jeden Teilnehmer ändern, um ihnen eine einzigartige Note zu verleihen.',
    conversationHelpParticipantColorTitle: 'Farbe der Teilnehmer',
    conversationHelpParticipantNameText: 'Ändere den Namen des Teilnehmers, wie es Ihnen gefällt!',
    conversationHelpParticipantNameTitle: 'Name des Teilnehmers',
    conversationHelpParticipantPositionText: 'Wählen Sie, ob Sie die Nachrichten dieses Teilnehmers lieber links oder rechts anzeigen möchten.',
    conversationHelpParticipantPositionTitle: 'Position des Teilnehmers',
	conversationHelpMessagesToolsTitle: 'Werkzeuge',
	conversationHelpMessagesToolsText: 'Tippen Sie auf eine Kachel, um zu suchen, nach Medien oder Daten zu filtern oder Nachrichten auszublenden.',
	conversationHelpMessagesSearchTitle: 'Suche',
	conversationHelpMessagesSearchText: 'Geben Sie ein Wort oder einen Namen ein, um eine Nachricht schnell zu finden.',
	conversationHelpMessagesMediasTitle: 'Medien',
	conversationHelpMessagesMediasText: 'Filtere Nachrichten mit Fotos, Videos, Audios oder Links.',
	conversationHelpMessagesDatesTitle: 'Daten',
	conversationHelpMessagesDatesText: 'Behalte nur Nachrichten zwischen zwei Daten, um Sie auf einen Teil der Unterhaltung zu konzentrieren.',
	conversationHelpMessagesHidePeriodTitle: 'Zeitraum ausblenden',
	conversationHelpMessagesHidePeriodText: 'Wählen Sie zwei Daten, um einen ganzen Zeitraum auf einmal auszublenden (oder wieder anzuzeigen).',
	conversationHelpMessagesHiddenTitle: 'Anzeige',
	conversationHelpMessagesHiddenText: 'Zeige alle Nachrichten, nur sichtbare oder nur ausgeblendete.',
	conversationHelpMessagesListTitle: 'Nachricht bearbeiten',
	conversationHelpMessagesListText: 'An jeder Blase: auswählen, ausblenden, Text bearbeiten oder eine neue einfügen.',
	conversationHelpMessagesFooterTitle: 'Zurück zur Vorschau',
	conversationHelpMessagesFooterText: 'Wenn alles passt, gehen Sie zurück zur Vorschau, um Ihr aktualisiertes Buch zu sehen.',
    conversationHelpPreviewBookCoverText: 'Geben Sie ihm ein einzigartiges Cover. Klicken Sie, um es anzupassen.',
    conversationHelpPreviewBookCoverTitle: 'Buchcover',
    conversationHelpPreviewBookPreviewText: 'Sehen Sie sich eine Vorschau eines bestimmten Bandes an, indem Sie hier klicken!',
    conversationHelpPreviewBookPreviewTitle: 'Buchvorschau',
    conversationHelpPreviewBookSelectorText: 'Wählen Sie die Bände aus, die Sie drucken möchten.',
    conversationHelpPreviewBookSelectorTitle: 'Buchauswahl',
    conversationHelpPreviewBookSplitText: 'Wenn Sie dieses Kästchen ankreuzt, haben alle Ihre Bücher die gleiche Seitenzahl für eine einheitliche Sammlung.',
    conversationHelpPreviewBookSplitTitle: 'Seiten des Buches',
        conversationHelpPreviewCopyText: 'Bestellen Sie mehrere Exemplare: für Sie oder zum Verschenken. Rabatt ab dem zweiten Exemplar.',
        conversationHelpPreviewCopyTitle: 'Ein Exemplar verschenken',
        conversationHelpPreviewFormatText: 'Gedrucktes Buch oder digitales eBook: wählen Sie, was zu Ihnen passt.',
        conversationHelpPreviewFormatTitle: 'Format',
        conversationHelpPreviewRenderText: 'So sieht Ihr Buch aus. Bearbeiten Sie das Cover direkt darauf, dann blättern Sie durch die Seiten.',
        conversationHelpPreviewRenderTitle: 'Ihr Buch',
	conversationHelpPreviewMessagesText: 'Tippen Sie auf diese Karte, um den Inhalt Ihrer Nachrichten zu bearbeiten.',
	conversationHelpPreviewMessagesTitle: 'Nachrichten',
	conversationHelpPreviewDatesText: 'Tippen Sie auf diese Karte, um Start- und Enddatum Ihres Buchs zu wählen.',
	conversationHelpPreviewDatesTitle: 'Daten',
	conversationHelpPreviewParticipantsText: 'Tippen Sie auf diese Karte, um Namen und Darstellung der Teilnehmer zu ändern.',
	conversationHelpPreviewParticipantsTitle: 'Teilnehmer',
	conversationHelpPreviewCoverTitleText: 'Klicken Sie auf den Titel oder Untertitel, um sie zu bearbeiten.',
	conversationHelpPreviewCoverTitleTitle: 'Titel und Untertitel',
	conversationHelpPreviewVolumesTitle: 'Mehrere Bände',
	conversationHelpPreviewVolumesText: 'Ihr Gespräch füllt mehrere Bücher. Tippen Sie auf eine Zahl, um den Band zu wechseln und jedes Cover anzupassen.',
	conversationHelpPreviewCoverImageText: 'Tippen Sie auf den Fotobereich, um das Coverbild hinzuzufügen oder zu ändern.',
	conversationHelpPreviewCoverImageTitle: 'Foto',
	conversationHelpPreviewCoverColorText: 'Tippen Sie auf eine Farbe, um die Hintergrundfarbe des Covers zu ändern.',
	conversationHelpPreviewCoverColorTitle: 'Farbe',
        conversationHelpPreviewValidText: 'Wenn alles passt, bestätigen Sie. Ihr eBook kommt per E-Mail, Ihr Buch nach Hause.',
        conversationHelpPreviewValidTitle: 'Los geht’s!',

    conversationHighlightStartDateTitle: 'Die erste Nachricht',
    conversationHighlightStartDateDescription: 'An diesem Tag ging die erste Nachricht raus. Alles Weitere kam daraus.',
    conversationHighlightDurationTitle: 'Zusammen seit',
    conversationHighlightDurationDescription: 'All diese Tage zusammen, seit der ersten Nachricht.',
    conversationHighlightMessagesCountTitle: 'Nachrichten',
    conversationHighlightMessagesCountDescription: 'All diese Nachrichten, ausgetauscht seit dem {date}.',
    conversationHighlightImagesCountTitle: 'Fotos',
    conversationHighlightImagesCountDescription: 'Diese Fotos, behalten aus unserem Chat.',
    conversationHighlightMediasCountTitle: 'Videos und Sprachnachrichten',
    conversationHighlightMediasCountDescription: 'Um eine Stimme noch einmal zu hören und einen Moment wiederzusehen.',
    conversationHighlightSpecialDayMessagesCountTitle: 'An einem Tag',
    conversationHighlightSpecialDayMessagesCountDescription: 'Unser Rekord: so viele Nachrichten an einem einzigen Tag.',
    conversationHighlightSpecialDayTitle: 'Dieser Tag',
    conversationHighlightSpecialDayDescription: 'Der Tag, an dem wir uns am meisten geschrieben haben.',
    conversationHighlightCharsCountReferenceDiffTitle: 'Romeo und Julia',
    conversationHighlightCharsCountReferenceDiffDescription: 'So viele Male der Text von Romeo und Julia.',
    conversationHighlightCharsCountReferenceDiffRomeoJuliette: '{diff} Mal',
    conversationHighlightTypingDurationTitle: 'Schreiben',
    conversationHighlightTypingDurationDescription: 'So viele Stunden, die wir uns geschrieben haben.',
    conversationHighlightUnitDays: '{count, plural, one {Tag} other {Tage}}',
    conversationHighlightUnitMessages: '{count, plural, one {Nachricht} other {Nachrichten}}',
    conversationHighlightUnitHours: '{count, plural, one {Stunde} other {Stunden}}',
    conversationHighlightUnitTimes: 'Mal',

    conversationHighlightBadge: 'In ein paar Zahlen',
    conversationHighlightStoryKicker: 'Ihre Geschichte',
    conversationHighlightsMomentsCount: '{count, plural, one {# Bild zum Herunterladen} other {# Bilder zum Herunterladen}}',
    conversationHighlightShareFormat: 'Story-Format',
    conversationHighlightsCardFooter: 'Manche Geschichten verdienen ein Buch',
    conversationHighlightShareButton: 'Herunterladen',
    conversationHighlightShareButtonAlt: 'Konversationsstatistiken ansehen',
    conversationHighlightSubtitle: 'Die Zahlen hinter dem, was Sie sich gesagt haben.',
    conversationHighlightTitle1: 'Ihre Nachrichten',
    conversationHighlightTitle2: 'in ein paar Zahlen',
    conversationHighlightOpenStoryButton: 'Diese Story öffnen',
    conversationHighlightsAtGlanceEyebrow: 'Auf einen Blick',
    conversationHighlightsAtGlanceTitle: 'Der Umfang Ihrer Geschichte',
    conversationHighlightsNoAiNote: 'Diese Statistiken werden automatisch und ohne KI berechnet.',
    conversationHighlightsKpiMessages: 'Nachrichten',
    conversationHighlightsKpiWords: 'geschriebene Wörter',
    conversationHighlightsKpiActiveDays: 'aktive Tage',
    conversationHighlightsKpiStreak: 'Tage in Folge',
    conversationHighlightsRhythmEyebrow: 'Ihr Rhythmus',
    conversationHighlightsRhythmTitle: 'Wann Ihre Nachrichten lebendig werden',
    conversationHighlightsTopHour: 'Ihre Lieblingszeit',
    conversationHighlightsTopWeekday: 'Ihr Lieblingstag',
    conversationHighlightsNightMessages: 'Nachrichten in der Nacht',
    conversationHighlightsChartMonths: 'Jeder Monat, von der ersten bis zur letzten Nachricht',
    conversationHighlightsChartYears: 'Jedes Jahr, von der ersten bis zur letzten Nachricht',
    conversationHighlightsLessThanOneMinute: 'unter 1 Min.',
    conversationHighlightsSpanLessThanMonth: 'Weniger als ein Monat',
    conversationHighlightsSpanYears: '{count, plural, one {# Jahr} other {# Jahre}}',
    conversationHighlightsSpanMonths: '{count, plural, one {# Monat} other {# Monate}}',
    conversationHighlightsSpanYearsMonths: '{years, plural, one {# Jahr} other {# Jahre}} und {months, plural, one {# Monat} other {# Monate}}',
    conversationHighlightsSpanLabel: 'Von der ersten bis zur letzten Nachricht',
    conversationHighlightsBusiestDayLabel: 'Gesprächigster Tag',
    conversationHighlightsPhotosLabel: 'Fotos',
    conversationHighlightsMediasLabel: 'Videos und Sprachnachrichten',
    conversationHighlightsBookPagesLabel: 'Ihr Buch',
    conversationHighlightsBookPagesPrefix: 'etwa',
    conversationHighlightsBookPagesUnit: '{count, plural, one {Seite} other {Seiten}}',
    conversationHighlightsBookPagesNote: 'Schätzung aus Ihren Nachrichten und Fotos.',
    conversationHighlightsWritingHours: 'Etwa {count, plural, one {# Stunde Schreibzeit} other {# Stunden Schreibzeit}}.',
    conversationHighlightsRomeo: 'So viel Text wie {count}-mal Romeo und Julia.',
    conversationHighlightsDayClockPeak: 'Am häufigsten zwischen {start} und {end} Uhr',
    conversationHighlightsLessThanOnePercent: '< 1 %',
    conversationHighlightsWritesLonger: '{name} schreibt die längsten Nachrichten.',
    conversationHighlightsStartsMore: '{name} beginnt das Gespräch am häufigsten.',
    conversationHighlightsWordsPerMessage: '{count} Wörter / Nachricht',
    conversationHighlightsStartsShare: '{percent} % der Anfänge',
    conversationHighlightsMedianReply: 'Mittlere Antwortzeit',
    conversationHighlightsBalanceEyebrow: 'Ihre Balance',
    conversationHighlightsBalanceTitle: 'Jeder ist auf seine Weise füreinander da',
    conversationHighlightsWordsShort: 'Wörter',
    conversationHighlightsStartsShort: 'Gesprächsanfänge',
    conversationHighlightsBalanceNote: 'Ein Prozentsatz beschreibt einen Rhythmus, niemals die Bedeutung einer Person.',
    conversationHighlightsRecordsEyebrow: 'Ihre Rekorde',
    conversationHighlightsRecordsTitle: 'Die besonderen Momente',
    conversationHighlightsLongestSession: 'Längstes Gespräch',
    conversationHighlightsIntenseQuarter: 'Intensivste 15 Minuten',
    conversationHighlightsQuestions: 'Zärtliche Nachrichten',
    conversationHighlightsSignsOfInterest: 'Herzen, Küsse oder „ich liebe dich“',
    conversationHighlightsLaughs: 'Nachrichten mit Lachen',
    conversationHighlightsSharedSmiles: 'geteiltes Lächeln',
    conversationHighlightsFavoriteEmojis: 'Ihre Lieblings-Emojis',
    conversationHighlightsStoriesEyebrow: 'Zum Aufbewahren',
    conversationHighlightsStoriesTitle: 'Ihre Erinnerungskarten',
    conversationHighlightsStoriesText: 'Öffnen Sie eine Karte und laden Sie sie anschließend im Story-Format herunter.',
    conversationHighlightsDeepEyebrow: 'Und nach den Zahlen?',
    conversationHighlightsDeepTitle: 'Möchten Sie Ihre Geschichte noch tiefer ergründen?',
    conversationHighlightsDeepText: 'Sagen Sie uns, ob Sie sich eines Tages eine tiefere Analyse wünschen. Vorerst wird nichts weiter analysiert.',
    conversationHighlightsDeepThanks: 'Vielen Dank, Ihr Interesse wurde gespeichert',
    conversationHighlightsDeepButton: 'Ja, das würde mich interessieren',
    conversationHighlightsDeepNotice: 'Sie werden benachrichtigt, sobald es vorgesehen ist.',
    conversationHighlightsDeepNoticeClose: 'Alles klar',
    conversationHighlightsPrintBook: 'Ich möchte mein Buch drucken',
    conversationHighlightsPrintNow: 'Ich drucke jetzt',

    conversationImagesCount: `{count} {count, plural,
      =0 {Foto}
      =1 {Foto}
      other {Fotos}
    }`,

    conversationImportFileNotSupportedError: 'Ihre Datei ist ungültig! Bitte wählen Sie eine gültige komprimierte Datei (.zip)',
    conversationImportFileSummary: 'Ihr Name ist {name} und Sie haben {count} Chats in diesem Archiv.',
    conversationImportFileTooBigError: 'Ihre Datei ist zu groß (mehr als 4 GB). Bitte kontaktieren Sie uns, um das Problem zu lösen.',
    conversationImportProviderNext: 'Meinen Chat übertragen',
    conversationImportTutorialGoNext: 'Nächster Schritt',
    conversationImportTutorialStep: 'Schritt Nr. {step}',
    conversationImportDetailToggle: 'Detaillierte Anleitung mit Screenshots ansehen',
    conversationImportDetailCardTitle: 'Zum ersten Mal?',
    conversationImportDetailCardSubtitle: 'Illustrierte Schritt-für-Schritt-Anleitung ({count} Schritte mit Screenshots)',
    conversationImportDetailCardAction: 'Anleitung öffnen',
    conversationImportDetailTitle: 'Ausführliche Schritt-für-Schritt-Anleitung',
    conversationImportDetailStepOf: 'Schritt {current} von {total}',
    conversationImportDetailPrev: 'Zurück',
    conversationImportDetailNext: 'Weiter',
    conversationImportDetailClose: 'Schließen',
    conversationImportSelectionSummary: `Ausgewählter Chat: {name} (enthält {count} {count, plural,
        =0 {Nachricht}
        =1 {Nachricht}
        other {Nachrichten}
      })`,
    conversationImportSelectionSummary2: 'Ausgewählter Chat: {name}',
    conversationImportSelectionText: 'Schreiben Sie den Namen Ihres Freundes...',
    conversationImportSelectionTitle: 'Wählen Sie den Chat aus',
    conversationImportStepCreation: 'Erstellung der Konversation',
    conversationImportStepExtraction: 'Daten werden abgerufen',
    conversationImportStepFinal: 'Letzte Details werden abgeschlossen...',
    conversationImportStepImages: 'Ihre Bilder werden gespeichert',
    conversationImportStepMessages: 'Ihre Nachrichten werden gespeichert',
    conversationImportSuccess: 'Herzlichen Glückwunsch! <br></br>Ihr Chat wurde erfolgreich importiert!',
    conversationImportValidationWaiting: 'Validierung läuft...',
    conversationMediaAudioOpusWarning: 'Wenn Sie diese Audiodatei nicht abspielen können, verwende bitte einen anderen kompatiblen Browser (wie Google Chrome)',
    conversationMediasCount: `{count} {count, plural,
      =0 {Mediendatei}
      =1 {Mediendatei}
      other {Mediendateien}
    }`,
    conversationMerge: 'Chats zusammenführen',
    conversationMergeInfo: 'Wählen Sie die Chats aus, die Sie zusammenführen möchten, und klicken Sie dann auf den Button unter der Liste:',
    conversationMergeRequestSuccess: 'Die Chats werden bald zusammengeführt! Sie erhalten eine E-Mail, wenn der Vorgang abgeschlossen ist.',
    conversationMergeHintEyebrow: 'Gut zu wissen',
    conversationMergeHintTitle: 'Zu einer Unterhaltung zusammenführen',
    conversationMergeHintSingle: 'Mehrere Chatverläufe? Importiere jede Unterhaltung mit + und führe sie anschließend zu einer Unterhaltung zusammen.',
    conversationMergeHintReady: 'Sie können Ihre Unterhaltungen zu einer chronologischen Unterhaltung zusammenführen.',
    conversationMessages: 'Nachrichten',
    conversationMessagesCount: `{count} {count, plural,
      =0 {Nachricht}
      =1 {Nachricht}
      other {Nachrichten}
    }`,
    conversationMessagesCount2: `{count, plural,
      =0 {Nachricht}
      =1 {Nachricht}
      other {Nachrichten}
    }`,
    conversationMessagesImagesCount: `{count} {count, plural,
      =0 {Bild}
      =1 {Bild}
      other {Bilder}
    }`,
    conversationMessagesImagesCount2: `{count, plural,
      =0 {Bild}
      =1 {Bild}
      other {Bilder}
    }`,
    conversationMessagesLoadingAlert: 'Die Magie Ihrer Nachrichten wird abgerufen...',
    conversationMessagesMediasCount: `{count} {count, plural,
      =0 {Mediendatei}
      =1 {Mediendatei}
      other {Mediendateien}
    }`,
    conversationMessagesMediasCount2: `{count, plural,
      =0 {Mediendatei}
      =1 {Mediendatei}
      other {Mediendateien}
    }`,
    conversationNoData: 'Sie haben noch keine Unterhaltung importiert!',
    conversationOptionWithImagesHelp1: 'Aktuell werden Ihre Bücher MIT Ihren Bildern oder Fotos gedruckt',
    conversationOptionWithImagesHelp2: 'Aktuell werden Ihre Bücher OHNE Ihre Bilder oder Fotos gedruckt',
    conversationOptionWithImagesHelp3: 'Je nach Anzahl der Fotos kann die Übertragung etwas dauern. Bitte bleiben Sie während des Ladevorgangs auf dieser Seite — es kann bis zu 10 Minuten dauern. Sollten Sie weiterhin Probleme haben, senden Sie uns Ihre Datei über www.fromsmash.com an hello@monlivresms.com und nennen Sie den Kontakt- oder Gruppennamen. Wir finden eine Lösung.',
    conversationOptionWithImagesLabel: 'Möchten Sie die Bilder des Chats einbinden?',
    conversationOptionWithMediaHelp: 'Sie können Ihre Videos, Audios und GIFs dank der in Ihrem Buch gedruckten QR-Codes wiederentdecken. Wir schenken Ihnen die sichere Speicherung Ihrer Daten für 10 Jahre.',
    conversationOptionWithMediasLabel: 'Möchten Sie die Videos, Audios und GIFs des Chats einbinden?',
    conversationOrder: 'Bestellung',
    conversationOrderButton: 'Jetzt bestellen',
    conversationOrderButtonWithPrice: 'Jetzt bestellen · {price}',
    conversationOrderButtonWithPriceVolumes: 'Meine {count} Bücher bestellen · {price}',
    conversationOrderDiscountLabel: '¡-{discount}% Rabatt auf diesen Chat bei Bestellung von {threshold} Exemplaren oder mehr!',
    conversationOrderQuantity: 'Anzahl der Exemplare',
    conversationOrderSummaryBook: `{bookCount} {bookCount, plural,
			=1 {Band}
			other {Bände}
		} · {bookTotal} {discount, plural,
			=0 {}
			other {: {discount} % Rabatt inklusive}
		}`,
    conversationOrderSummary2: `Ihre Bestellung umfasst {bookCount} {bookCount, plural,
          =0 {Buch}
          =1 {Buch}
          other {Bücher}
        } und {pdfCount} {pdfCount, plural,
          =0 {eBook}
          =1 {eBook}
          other {eBooks}
        } {freeCount, plural,
          =0 {}
          =1 {+1 gratis eBook}
          other {+{freeCount} gratis eBooks}
        } für {pdfTotal}`,
        conversationOrderSummaryBestof: '1 Best-Of-Buch · {bestofTotal}',
        conversationOrderSummaryPdf: '1 vollständiges eBook · {pdfTotal}',
    conversationParticipantColorHelp: 'Klicken Sie hier, um die Farbe der Sprechblase zu ändern',
    conversationParticipantNameHelp: 'Klicken Sie hier, um den Namen des Teilnehmers zu bearbeiten',
    conversationParticipantPositionHelp: 'Klicken Sie, um die Position des Teilnehmers zu ändern (rechts oder links)',
    conversationParticipants: 'Teilnehmer',
    conversationParticipantsEditTitle: 'Teilnehmer bearbeiten',
    conversationPauseButton: 'Meine Bestellung pausieren',
    conversationPauseConfirmText: 'Die Generierung Ihrer Bücher wird pausiert. Sie können sie jederzeit fortsetzen.',
    conversationPreviewBookNumber: `Band {index}{index, plural,
          =0 {}
          =1 {}
          other {}
      }`,
    conversationPreviewBestofHelpButton: 'Wie funktioniert die Auswahl?',
    conversationPreviewBestofHelpText: 'Unsere Formel analysiert jeden Moment Ihrer Unterhaltung: die Häufigkeit der Nachrichten, die Qualität des Austauschs (ein echtes Hin und Her oder ein Monolog?), den Reichtum der Inhalte (Fotos, Text, Emojis). Die ersten und letzten Nachrichten werden immer aufbewahrt. Nur die Momente, die wirklich zählten, kommen ins Buch. Ihre Nachrichten bleiben privat: unsere Formel liest niemals deren Inhalt, nur die Struktur Ihrer Unterhaltung.',
    conversationPreviewBookSelection: 'Auswahl der Bände',
    conversationPreviewBooksSelectAllBooks: 'Alle physischen Bücher auswählen',
    conversationPreviewBooksSelectAllEBooks: 'Alle eBooks auswählen',
    conversationPreviewBooksUnselectAll: 'Auswahl aufheben',
        conversationPreviewBrowserWarning: 'Ihr Browser kann die Anzeige verlangsamen. Für optimale Ergebnisse empfehlen wir Google Chrome.',
    conversationPreviewFormatSelection: 'Formatauswahl',
    conversationPreviewPagesDivideEquallyLabel: 'Möchten Sie die Seiten gleichmäßig auf die Bände aufteilen?',
    conversationPreviewPagesSetMaxBookPagesLabel: 'Möchten Sie, dass Ihre Bücher maximal {max} Seiten haben?',
        conversationPreviewTitle: 'Ihre Geschichte, als Buch.',
        conversationPreviewSubtitle: 'Passen Sie Cover, Namen, Daten und Nachrichten an, bevor Sie Ihre Ausgabe wählen.',
        conversationPreviewHeroTitle: 'Ihre Worte, für immer gebunden.',
        conversationPreviewBookCaption: 'Blättern Sie durch die Seiten, um Ihr Buch zu entdecken.',
        conversationPreviewCustomizeEyebrow: 'Ganz nach Ihnen',
        conversationPreviewEditionEyebrow: 'Ihre Edition',
        conversationPreviewPricePerVolume: '{price}/Band',
    conversationPreviewCollectionPriceNote: '{count} Bände · {price}/Band',
    conversationPreviewCollectionUntilLabel: 'Welche Bände',
    conversationPreviewCollectionUntilAll: 'Vom ersten bis zum letzten Band',
    conversationPreviewCollectionUntilOpen: 'Wählen',
    conversationPreviewCollectionUntilClose: 'Schließen',
    conversationPreviewCollectionUntilPartial: '{count, plural, one {Der erste Band} other {Die ersten {count} Bände}}',
    conversationPreviewCollectionUntilSuffix: '{count, plural, one {Der letzte Band} other {Die letzten {count} Bände}}',
    conversationPreviewCollectionUntilSingle: 'Band {number}',
    conversationPreviewCollectionUntilWindow: 'Von Band {from} bis Band {to}',
    conversationPreviewCollectionUntilPeriod: 'Vom {start} bis {end}',
    conversationPreviewCollectionUntilHint: 'Die übrigen Bände bleiben im Gespräch, für eine weitere Bestellung.',
    conversationPreviewCollectionUntilAriaStart: 'Erster Band zum Drucken',
    conversationPreviewCollectionUntilAriaEnd: 'Letzter Band zum Drucken',
    conversationPreviewTypeBookTaglinePartial: '{count, plural, one {Der erste Band Ihres Gesprächs.} other {Die ersten {count} Bände Ihres Gesprächs.}}',
    conversationPreviewTypeBookTaglineSuffix: '{count, plural, one {Der letzte Band Ihres Gesprächs.} other {Die letzten {count} Bände Ihres Gesprächs.}}',
    conversationPreviewTypeBookTaglineWindowSingle: 'Band {number} Ihres Gesprächs.',
    conversationPreviewTypeBookTaglineWindow: 'Die Bände {from} bis {to} Ihres Gesprächs.',
    conversationPreviewStickyCollectionVolumes: 'Kollektion · {count} Bände',
        conversationPreviewSocialProofCount: '{count}+ Bewertungen',
        conversationPreviewSocialProofAria: 'Mit {rating} von 5 auf Trustpilot bewertet, basierend auf über {count} Bewertungen',
        conversationPreviewCustomizeTitle: 'Mein Buch anpassen',
        conversationPreviewCustomizeHint: 'Tippen Sie auf eine Karte zum Bearbeiten.',
        conversationPreviewCardsHintTitle: 'Namen, Zeitraum, Nachrichten',
        conversationPreviewCardsHintText: 'Hier ändern Sie die Namen, den Zeitraum und die Nachrichten.',
        conversationPreviewCustomizeTopics: 'Cover · Namen · Daten · Nachrichten',
        conversationPreviewEditionTitle: 'Edition wählen',
        conversationPreviewEditionHint: 'Vergleiche die Optionen und wählen Sie, was zu Ihnen passt.',
        conversationPreviewPausedEyebrow: 'Bestellung pausiert',
        conversationPreviewPausedTitle: 'Sind Ihre Änderungen fertig?',
        conversationPreviewPausedHint: 'Ihre Bestellung ist pausiert. Bearbeiten Sie Ihr Buch und bestätigen Sie dann, um die Produktion fortzusetzen.',
        conversationPreviewPausedScrollHint: 'Änderungen bestätigen',
        conversationPreviewMissingMediasBanner: 'Einige Medien (Fotos, Dateien) Ihrer Unterhaltung fehlen oder konnten nicht abgerufen werden. Bitte überprüfen Sie Ihre Nachrichten vor der Bestätigung.',
        conversationPreviewMissingMediasCta: 'Fehlende Medien ergänzen',
        bookMissingPhotoLabel: 'Foto nicht verfügbar',
        conversationMissingMediasBadge: 'Fehlende Medien',
        conversationMissingMediasCta: 'Fehlende Medien ergänzen',
        conversationResumeWithoutMediasButton: 'Ohne diese Fotos fortfahren',
        conversationResumeMissingMediasConfirmText: 'Einige Fotos fehlen noch. Ihr Buch geht ohne sie in den Druck. Ergänzen Sie die Medien nach Möglichkeit.',
        orderMissingMediasAlert: 'In einer Unterhaltung dieser Bestellung fehlen Fotos. Ergänzen Sie sie, damit die Produktion fortgesetzt werden kann.',
        missingMediasRecoveryAddPhoto: 'Foto hinzufügen',
        missingMediasRecoveryArchiveCta: 'Exportdatei ablegen',
        missingMediasRecoveryArchiveError: 'Diese Datei konnte nicht gelesen werden. Prüfen Sie, ob es sich um den Export Ihrer Messaging-App handelt.',
        missingMediasRecoveryArchiveHelp: 'Laden Sie Ihren {provider}-Export erneut hoch (zip). Nur fehlende Fotos werden hinzugefügt: Nachrichten und Änderungen bleiben unverändert.',
        missingMediasRecoveryArchiveTitle: 'Mit neuem Export ergänzen',
        missingMediasRecoveryArchiveWorking: 'Fehlende Fotos werden in Ihrer Datei gesucht…',
        missingMediasRecoveryContact: 'Schreiben Sie uns',
        missingMediasRecoveryEmpty: 'Derzeit keine fehlenden Medien erkannt.',
        missingMediasRecoveryError: 'Es ist ein Fehler aufgetreten. Bitte erneut versuchen oder uns kontaktieren.',
        missingMediasRecoveryFirstDate: 'Erstes fehlendes Medium: {date}.',
        missingMediasRecoveryIgnore: 'Ignorieren',
        missingMediasRecoveryIntro: '{count, plural, one {# Foto fehlt} other {# Fotos fehlen}} in Ihrem Buch. Sie können Ihren Export erneut hochladen oder jedes Medium unten behandeln.',
        missingMediasRecoveryListTitle: 'Medien einzeln behandeln',
        missingMediasRecoveryNoMatch: 'Keine Datei passend zu den fehlenden Medien gefunden.',
        missingMediasRecoveryRecommended: 'Empfohlen',
        missingMediasRecoveryRescan: 'Erneut prüfen',
        missingMediasRecoveryResolved: 'Alle fehlenden Medien wurden behandelt. Ihr Buch geht zurück in die Produktion.',
        missingMediasRecoverySuccessEyebrow: 'Alles erledigt',
        missingMediasRecoverySuccessTitle: 'Super, Ihre Fotos sind vollständig',
        missingMediasRecoverySuccessText: 'Alle fehlenden Medien wurden behandelt. Ihr Buch geht zurück in die Produktion.',
        missingMediasRecoverySuccessCta: 'Zurück zur Vorschau',
        conversationMissingMediasFixedSuccess: 'Super: alle fehlenden Medien sind ergänzt. Ihr Buch geht zurück in die Produktion.',
        conversationMissingMediasFixedHint: 'Sie müssen nichts weiter tun: die Produktion wird automatisch fortgesetzt.',
        missingMediasRecoverySmsStepAndroid: 'Unter Android: öffnen Sie die MonLivreSMS-App erneut und senden Sie die Unterhaltung erneut.',
        missingMediasRecoverySmsStepBackup: 'Erstellen Sie ein neues unverschlüsseltes lokales Backup (Mac/PC) und starten Sie unsere Software erneut, um die Medien dieser Unterhaltung zu senden.',
        missingMediasRecoverySmsStepIcloud: 'Auf dem iPhone: öffnen Sie die Unterhaltung in Nachrichten, tippen Sie auf den Kontakt, scrollen Sie und laden Sie iCloud-Fotos herunter.',
        missingMediasRecoverySmsTitle: 'SMS- / iPhone-Transfer',
        missingMediasRecoveryTitle: 'Fehlende Medien ({count})',
        conversationPreviewEditionMetaLabel: 'Details zur Edition',
        conversationPreviewBestofLearnMore: 'So funktioniert die Best-Of-Auswahl',
        conversationPreviewBestofHint: 'Beispielhafte Best-Of-Vorschau: Die Auswahl Ihrer besten Nachrichten erfolgt nach der Bestellung, bei der PDF-Erstellung.',
        conversationPreviewBestofHintDismiss: 'Schließen',
        conversationPreviewBestofHintLearnMore: 'Mehr erfahren',
        conversationPreviewBestofPriceNote: 'Auswahl nach der Bestellung',
        conversationPreviewTypeBestofTaglineCompare: 'Leichtere Alternative: Ihre besten Momente in 1 Band.',
        conversationPreviewMetaEbook: 'eBook inklusive',
        conversationPreviewMetaVolume: '{count} Band',
        conversationPreviewMetaVolumes: '{count} Bände',
        conversationPreviewMetaPages: '{pages} Seiten',
        conversationPreviewMetaMessages: '{count} Nachrichten',
        conversationPreviewMetaBestofPages: '~400 Seiten',
        conversationPreviewMetaBestofSelection: 'Intelligente Auswahl',
        conversationPreviewMetaPdfInstant: 'PDF sofort',
        conversationPreviewMetaPdfCredit: 'Guthaben fürs Buch',
        conversationPreviewPdfPriceNote: 'Abzug beim Wechsel zum Buch',
        conversationPreviewPdfLearnMore: 'Wie funktioniert das?',
        conversationPreviewPdfHelpText: 'Sie zahlen {ebookPrice} und erhalten Ihr PDF. Bestellen Sie später das gedruckte Buch für {bookPrice}, werden diese {ebookPrice} abgezogen: es bleiben {remainingPrice}. Das Guthaben bleibt auf Ihrem Konto.',
        conversationPreviewReassurancePdfCredit: 'Diese {price} werden abgezogen, wenn Sie zum Buch wechseln',
        conversationPreviewStickyPdfCredit: '{price} Guthaben beim Wechsel zum Buch',
        conversationPreviewEbookCreditBanner: 'Sie haben {amount} Guthaben für dieses Gespräch. Es wird automatisch abgezogen, wenn Sie das gedruckte Buch bestellen.',
        conversationPreviewEbookCreditOrderHint: '{credit} Guthaben abgezogen · Listenpreis {fullPrice}',
        conversationPreviewStickyEbookCredit: '{credit} Guthaben angerechnet',
        paymentMethodEbookCreditHint: 'E-Book-Guthaben für das gedruckte Buch',
        cartTotalsEbookCredit: 'E-Book-Guthaben',
        cartTotalsCredit: 'Guthaben',
        conversationOrderButtonEbook: 'Mein PDF erhalten',
        conversationOrderButtonEbookWithPrice: 'Mein PDF erhalten · {price}',
        conversationPreviewTypeBookTaglineSingle: 'Ihre ganze Geschichte, Seite für Seite.',
        conversationPreviewTypeBookTaglineMulti: 'Ihr gesamtes Gespräch in {count} gedruckten Büchern.',
        conversationPreviewHeroHeading: 'Buchvorschau',
        conversationPreviewHelpTourButton: 'Seitenhilfe anzeigen',
        conversationPreviewCardLabelCover: 'Cover',
        conversationPreviewCardLabelParticipants: 'Teilnehmer',
        conversationPreviewCardLabelDates: 'Daten',
        conversationPreviewCardLabelMessages: 'Nachrichten',
	conversationPreviewZoneDone: 'Bereits angesehen',
	conversationPreviewZoneHintCover: 'Farbe, Foto, Titel, Vorwort',
	conversationPreviewZoneHintParticipants: 'Namen und Farben der Sprechblasen',
	conversationPreviewZoneHintDates: 'Vom Buch abgedeckter Zeitraum',
	conversationPreviewZoneHintMessages: 'Nachrichten ausblenden oder bearbeiten',
        conversationHelpPreviewCustomizeTitle: 'Namen, Daten und Nachrichten',
        conversationHelpPreviewCustomizeText: 'Tippen Sie auf eine Karte, um Namen, Daten oder Nachrichten zu bearbeiten.',
        conversationBookNavPrev: 'Vorherige Seite',
        conversationBookNavNext: 'Nächste Seite',
        conversationBookBackToCover: 'Zurück zum Cover',
        conversationPreviewTypeBookPagesHint: ' · {pages} Seiten',
        conversationPreviewTypeBookMessagesHint: ' · {count} Nachrichten',
        conversationOrderTotal: 'Gesamt',
        conversationPreviewTypeBestofDescription: '400 Seiten, Ihre besten Momente. eBook inklusive.',
        conversationPreviewTypeBestofTitle: 'Best Of',
        conversationPreviewTypeBookDescription: '{count} Band · Komplette Geschichte. eBook inklusive.',
        conversationPreviewTypeBookDescriptionWithPrice: '{count} Bände · {unitBreakdown} · Gesamtsammlung. eBook inklusive.',
        conversationPreviewReassuranceShipping: 'Kostenloser Versand weltweit',
        conversationPreviewExpressDeliveryLead: 'Expresslieferung {where} ab dem',
        conversationPreviewExpressDeliveryDate: '{date}',
        conversationPreviewTypeBookTitle: 'Gesamtsammlung',
        conversationPreviewTypeHighlight: 'Empfohlen',
        conversationPreviewTypePdfDescription: 'Bewahren Sie Ihre Unterhaltung als PDF auf. Dieser Betrag zählt fürs Buch, wenn Sie es später möchten.',
        conversationPreviewTypePdfTitle: 'Digital',
        conversationPreviewTypeSelectionTitle: 'Wählen Sie Ihr Format',
    conversationProgress: 'Fortschritt',
    conversationProviderButton: 'Zu den Einstellungen',
    conversationProviderType: 'Typ',
    conversationRemoveButton: 'Chat löschen',
    conversationRemoveConfirmText: 'Wenn Sie Ihren Chat löschst, werden Ihre Mediendateien von unseren Servern gelöscht und können nicht wiederhergestellt werden. Sind Sie Ihnen sicher?',
    conversationRemoveConfirmTitle: 'Chat löschen',
    conversationRemoveFlagConfirmMessage: 'Möchten Sie diese Markierung vom Chat entfernen?',
    conversationRemoveSuccess: 'Chat erfolgreich gelöscht!',
    conversationRestartProcess: 'Neu starten',
    conversationResumeButton: 'Bestätigen und drucken',
    conversationResumeConfirmText: 'Ihr Chat wird als "verifiziert" markiert und geht in Kürze in die Generierungs- und Druckphase.',
    conversationValidateModificationsButton: 'Änderungen bestätigen',
    conversationValidateModificationsConfirmTitle: 'Änderungen bestätigen?',
    conversationValidateModificationsConfirmBook: 'Ihr Buch geht mit Ihren Änderungen wieder in die Produktion.',
    conversationValidateModificationsConfirmEbook: 'Ihr E-Book wird mit Ihren Änderungen neu erstellt und Ihnen erneut per E-Mail zugesendet.',
    conversationValidateModificationsConfirmMissingMedias: 'Einige Medien Ihrer Unterhaltung fehlen. Bitte überprüfen Sie diese vor der Bestätigung: Ihr Buch geht mit den aktuellen Änderungen in die Produktion.',
    conversationValidateModificationsSuccessBook: 'Ihre Änderungen wurden gespeichert. Ihr Buch geht wieder in die Produktion.',
    conversationValidateModificationsSuccessEbook: 'Ihre Änderungen wurden gespeichert. Ihr neu erstelltes E-Book wird Ihnen per E-Mail zugesendet.',
    conversationValidateModificationsBackToList: 'Zurück zu meinen Unterhaltungen',
    conversationSelectThread: 'Wählen Sie einen Chat aus',
    conversationShareCancelButton: 'Jetzt nicht',
    conversationShareConfirmButton: 'Meine Rekorde enthüllen',
    conversationShareConfirmTitle: 'Sehen Sie mal, was wir gefunden haben...',
    conversationShareConfirmText: 'Ihr Chat verbirgt unglaubliche Rekorde. Wir haben sie in maßgeschneiderte Bilder verwandelt, die Sie direkt teilen können.',
    conversationStatusConfigured: 'Wartet auf Generierung',
    conversationStatusDone: 'Abgeschlossen',
    conversationStatusOngeneration: 'Wird generiert',
    conversationStatusOnproduction: 'In Produktion',
    conversationStatusOnvalidation: 'Wartet auf Druck',
    conversationStatusPending: 'In der Warteschleife',
    conversationTypeAndroidDownloadAlt: 'Oder kopieren Sie den Link und fügen Sie ihn in Ihren bevorzugten Browser ein',
    conversationTypeAndroidDownloadButton: 'App herunterladen',
    conversationTypeAndroidIntroText1: 'Um Ihr SMS-Buch von einem Android-Telefon zu drucken, müssen Sie Ihr Smartphone (Samsung, Xiaomi, Pixel, etc.) verwenden.',
    conversationTypeAndroidIntroText2: 'Installieren Sie die MonLivreSMS-App auf Ihrem Android-Handy, indem Sie auf den folgenden Link klicken (die App ist nicht bei Google Play verfügbar):',
    conversationTypeAndroidIntroText3: 'Wählen Sie den Co-Autor Ihres Erinnerungs-Buches sowie das Start- und Enddatum Ihrer Geschichte.',
    conversationTypeAndroidIntroText4: 'Wählen Sie die Namen der Hauptpersonen Ihrer Geschichte, schreiben Sie Ihre Widmung und gestalten Sie Ihr Cover.',
    conversationTypeAndroidIntroText5: 'Um die Erstellung Ihres Buches abzuschließen, erstellen Sie ein Konto und schließen Sie Ihren Kauf über unseren sicheren Zahlungsserver ab.',
    conversationTypeInstagramFileText1: 'Instagram sendet Ihnen eine E-Mail, damit Sie die Datei herunterladen können.',
    conversationTypeInstagramFileText2: 'Laden Sie sie auf Ihr Gerät herunter.',
    conversationTypeInstagramFileText3: 'Klicken Sie auf den Button unten und wählen Sie die Datei in Ihren Downloads aus, ohne sie zu öffnen. Belasse sie im .zip-Format (Beispiel: *deinname*_*datum*.zip). Nur der von Ihnen ausgewählte Chat wird an unseren Druckservice gesendet.',
    conversationTypeInstagramProviderText1: 'Holen Sie sich eine Kopie Ihrer Instagram-Daten, indem Sie in die allgemeinen Einstellungen Ihres Kontos gehen.',
    conversationTypeInstagramProviderText2: 'Geben Sie die E-Mail-Adresse ein, die mit Ihrem Instagram-Konto verknüpft ist, und wählen Sie das JSON-Format.',
    conversationTypeInstagramProviderText3: 'Geben Sie dann Ihr Passwort ein und klicken Sie auf <strong>Download anfordern</strong>, um die Erstellung Ihres Backups bei Instagram zu starten.',
    conversationTypeIosIntroText1: 'Schließen Sie Ihr iPhone an Ihren COMPUTER an und erstellen Sie ein unverschlüsseltes Backup in iTunes. (wählen Sie "Dieser Computer", deaktivieren Sie "Lokales Backup verschlüsseln" und klicken Sie auf "Backup jetzt erstellen").',
    conversationTypeIosIntroText2: 'Laden Sie die MonLivreSMS-Software herunter, indem Sie auf den Link für das Betriebssystem Ihres Computers klicken:',
    conversationTypeIosIntroText3: '<strong>ACHTUNG, falls die Software kein Backup erkennt:</strong><br></br> - Für MAC:<br></br>Gehen Sie zu Systemeinstellungen > Datenschutz & Sicherheit > Festplattenvollzugriff und fügen Sie die MonLivreSMS-App hinzu, indem Sie das Schloss unten links entsperrst.<br></br> - Für PC:<br></br>Zu Ihrer Sicherheit blockiert Apple das Lesen Ihres Backups ohne Ihre Zustimmung.',
    conversationTypeMessengerFileText1: 'Facebook sendet Ihnen eine E-Mail, um die Datei Ihrer Chats herunterzuladen.',
    conversationTypeMessengerFileText2: 'Laden Sie sie auf Ihr Gerät herunter.',
    conversationTypeMessengerFileText3: 'Klicken Sie auf den Button unten und wählen Sie die Datei in Ihren Downloads aus. Belasse sie im .zip-Format (Beispiel: facebook-*deinname*.zip). Es wird nur der von Ihnen ausgewählte Chat verarbeitet.',
    conversationTypeMessengerProviderText1: 'Holen Sie sich eine Kopie Ihrer Facebook-Daten, indem Sie in die Kontoeinstellungen gehen.',
    conversationTypeMessengerProviderText2: 'Klicken Sie auf "Ihre Informationen herunterladen".',
    conversationTypeMessengerProviderText3: `Legen Sie dann die folgenden Optionen fest:<br></br>
              <strong>Datumsbereich</strong>: (wie Sie möchten)<br></br>
              <strong>Format</strong>: JSON<br></br>
              <strong>Medienqualität</strong>: Niedrig (reicht für den Druck aus und geht beim Übertragen viel schneller)<br></br>
              <strong>Ihre Informationen</strong>: Wählen Sie nur "Nachrichten" aus (den Rest abwählen).`,
    'conversationTypeMessengerProviderText4': 'Achtung: Stelle sicher, dass Sie das Datenformat JSON (und nicht HTML) auswählen!',
    'conversationTypeSnapchatProviderText1.1': 'Öffnen Sie die Snapchat-App auf Ihrem Gerät.',
    'conversationTypeSnapchatProviderText1.2': 'Tippen Sie auf Ihren Avatar (oder Bitmoji) oben links, um zu Ihrem Profil zu gelangen.',
    'conversationTypeSnapchatProviderText1.3': 'Tippen Sie auf das Zahnrad-Symbol oben rechts, um die Einstellungen zu öffnen.',
    'conversationTypeSnapchatProviderText2.1': 'Scrollen Sie nach unten zum Bereich "Datenschutzkontrollen".',
    'conversationTypeSnapchatProviderText2.2': 'Wählen Sie "Meine Daten".',
    'conversationTypeSnapchatProviderText3.1': 'Möglicherweise müssen Sie sich anmelden, um Ihre Identität zu bestätigen.',
    'conversationTypeSnapchatProviderText4.1': 'Auf der Seite "Meine Daten" finden Sie eine Liste der Daten, die Sie herunterladen können, einschließlich Ihrer Nachrichten.',
    'conversationTypeSnapchatProviderText4.2': 'Klicken Sie unten auf der Seite auf "Anfrage senden".',
    'conversationTypeSnapchatProviderText5.1': 'Sobald Ihre Anfrage gesendet wurde, bereitet Snapchat den Download Ihrer Daten vor.',
    'conversationTypeSnapchatProviderText5.2': 'Dies kann etwas dauern, in der Regel von ein paar Stunden bis zu einem Tag.',
    'conversationTypeSnapchatProviderText5.3': 'Sie erhalten eine E-Mail von Snapchat mit einem Link zum Herunterladen Ihrer Daten, sobald die Datei fertig ist.',
    'conversationTypeSnapchatProviderText6.1': 'Klicken Sie auf den Link in der E-Mail, um zur Download-Seite zu gelangen.',
    'conversationTypeSnapchatProviderText6.2': 'Laden Sie die ZIP-Datei herunter, die Ihre Daten enthält.',
    'conversationTypeSnapchatProviderText7.1': 'Öffnen Sie die ZIP-Datei nach dem Herunterladen nicht.',
    'conversationTypeSnapchatProviderText7.2': 'Laden Sie die komplette ZIP-Datei so wie sie ist im dafür vorgesehenen Bereich auf unserer Website hoch.',
    'conversationTypeSnapchatProviderText7.3': 'Danach können Sie den gewünschten Chat auswählen, um Ihr Buch zu erstellen.',
    conversationTypeSnapchatProviderTitle1: '1. Gehen Sie zu den Snapchat-Einstellungen:',
    conversationTypeSnapchatProviderTitle2: '2. Ihre Daten anfordern:',
    conversationTypeSnapchatProviderTitle3: '3. Authentifizierung:',
    conversationTypeSnapchatProviderTitle4: '4. Download Ihrer Daten:',
    conversationTypeSnapchatProviderTitle5: '5. Auf die E-Mail warten:',
    conversationTypeSnapchatProviderTitle6: '6. Die Datei herunterladen:',
    conversationTypeSnapchatProviderTitle7: '7. Upload zu MonLivreSMS:',
    'conversationTypeTelegramProviderText1.1': 'Installieren Sie die Telegram Desktop-Anwendung auf Ihrem PC oder Mac unter https://desktop.telegram.org/.',
    'conversationTypeTelegramProviderText1.2': 'Öffnen Sie die Telegram-App auf Ihrem Computer.',
    'conversationTypeTelegramProviderText2.1': 'Öffnen Sie in der App den Chat, den Sie in ein Buch verwandeln möchten, indem Sie auf den Namen Ihres Kontakts klicken.',
    'conversationTypeTelegramProviderText3.1': 'Klicken Sie auf die drei Punkte in der oberen rechten Ecke des Chats.',
    'conversationTypeTelegramProviderText3.2': 'Wählen Sie "Chatverlauf exportieren".',
    'conversationTypeTelegramProviderText4.1': 'Wählen Sie im Einstellungsfenster alle Dateitypen aus, die Sie einbeziehen möchten (Fotos, Videos, Sprachnachrichten usw.).',
    'conversationTypeTelegramProviderText4.2': 'Setzen Sie das Größenlimit auf das für den Export zulässige Maximum.',
    'conversationTypeTelegramProviderText4.3': 'Klicken Sie unten im Fenster auf "Exportieren".',
    'conversationTypeTelegramProviderText5.1': 'Suchen Sie den Ordner mit den exportierten Daten und komprimieren Sie ihn zu einer ZIP-Datei (Rechtsklick > Senden an > ZIP-komprimierter Ordner).',
    'conversationTypeTelegramProviderText6.1': 'Laden Sie die komplette ZIP-Datei auf unserer Website hoch.',
    conversationTypeTelegramProviderTitle1: '1. Telegram Desktop installieren:',
    conversationTypeTelegramProviderTitle2: '2. Den Chat auswählen:',
    conversationTypeTelegramProviderTitle3: '3. Den Verlauf exportieren:',
    conversationTypeTelegramProviderTitle4: '4. Export-Einstellungen:',
    conversationTypeTelegramProviderTitle5: '5. In eine ZIP-Datei komprimieren:',
    conversationTypeTelegramProviderTitle6: '6. Die Datei bei MonLivreSMS hochladen:',
    conversationTypeTitle: 'Ein Buch aus dem Chat mit {name} erstellen',
    conversationTypeWhatsappFileText1: 'Ihren WhatsApp-Chat abrufen',
    conversationTypeWhatsappFileText2: 'Klicken Sie auf "Datei anhängen"',
    conversationTypeWhatsappFileText3: 'Laden Sie Ihren Chat hoch',
    conversationTypeWhatsappFileText4: 'Wenn die Datei nicht im ".zip"-Format ist, komprimieren Sie sie zuerst.',
    conversationTypeWhatsappFileText5: 'Wenn Sie nur den Text Ihres Chats möchten (ohne Fotos), laden Sie ausschließlich die .txt-Datei hoch.',
    conversationTypeWhatsappProviderText1: 'Exportiere eine Kopie Ihres WhatsApp-Chats',
    conversationTypeWhatsappProviderText2: '<strong>Von einem Android:</strong><br></br>Öffnen Sie die WhatsApp-App<br></br>Gehen Sie in den gewünschten Chat<br></br>Tippen Sie auf "Weitere Optionen" (die drei Punkte oben rechts)',
    conversationTypeWhatsappProviderText3: '<strong>Von iOS (iPhone):</strong><br></br>Öffnen Sie die WhatsApp-App<br></br>Gehen Sie in den gewünschten Chat<br></br>Tippen Sie oben auf den Namen des Kontakts oder der Gruppe<br></br>Scrollen Sie ganz nach unten und wählen Sie "Chat exportieren"',
    conversations: 'Chats',
    conversationsMy: 'Meine Chats',
    conversationsLuxEyebrow: 'Ihre Geschichten',
    conversationsLuxHint: 'Finden Sie Ihre Unterhaltungen und verwandeln Sie sie in ein schönes Buch.',
    ordersLuxEyebrow: 'Ihr Atelier',
    ordersLuxHint: 'Finden Sie Ihre Bücher und folgen Sie ihrer Reise, vom Atelier bis zu Ihnen nach Hause.',
    ordersLuxDetailTitle: 'Ihr Buch',
    ordersLuxDetailHint: 'Folgen Sie Ihrem Buch, vom Atelier bis zu Ihrer Tür.',
    ordersLuxViewFollow: 'Mein Buch verfolgen',
    ordersLuxEmptyTitle: 'Ihre erste Geschichte wartet auf Sie.',
    ordersLuxEmptyHint: 'Verwandeln Sie ein Gespräch in ein Buch, das Sie immer wieder öffnen möchten.',
    ordersLuxStepReceived: 'Eingegangen',
    ordersLuxStepAtelier: 'Atelier',
    ordersLuxStepPrint: 'Druck',
    ordersLuxStepShipped: 'Unterwegs',
    ordersLuxStepHome: 'Bei Ihnen',
    ordersLuxStoryPendingpayment: 'Ihre Bestellung wartet auf die Zahlung, bevor sie ins Atelier kommt.',
    ordersLuxStoryPending: 'Wir haben Ihre Bestellung erhalten. Das Atelier kümmert sich bereits darum.',
    ordersLuxStoryOnpreparation: 'Ihr Buch nimmt Gestalt an. Jede Seite wird mit Sorgfalt vorbereitet.',
    ordersLuxStoryOnfabrication: 'Ihr Buch wird gedruckt. Bald verlässt es das Atelier.',
    ordersLuxStoryShipped: 'Ihr Buch ist unterwegs. Es reist zu Ihnen nach Hause.',
    ordersLuxStoryComplete: 'Ihr Buch ist angekommen. Es wartet nur noch auf Ihre Hände.',
    ordersLuxStoryCanceled: 'Diese Bestellung wurde storniert. Ihre Erinnerungen bleiben sicher bei uns.',
    userProfileLuxEyebrow: 'Ihr Bereich',
    userProfileLuxHint: 'Verwalten Sie Ihre Angaben, Anmeldungen und Einstellungen.',
    userProfileValueEmpty: 'Nicht angegeben',
    userProfileNotLinked: 'Nicht verknüpft',
    userProfileNewsletterOn: 'Sie erhalten bereits unsere Neuigkeiten und Angebote.',
    userProfilePasswordOn: 'Festgelegt',
    addressesLuxEyebrow: 'Ihr Bereich',
    addressesLuxHint: 'Finden Sie Ihre Liefer- und Rechnungsadressen.',
    addressesLuxEditHint: 'Diese Adresse kann für Lieferung oder Rechnung verwendet werden.',
    conversationsNewApp: 'Neue Chats in der App',
    conversationsOldApp: 'Alte Chats in der App',
    dashboardTitle: 'Dashboard',
    date: 'Datum',
    dateActivated: 'Aktivierungsdatum',
    dateCreated: 'Erstellungsdatum',
    dateLastCguAccept: 'Datum der letzten AGB-Zustimmung',
    dateLastEdit: 'Datum der letzten Änderung',
    dateLastLogin: 'Datum der letzten Anmeldung',
    dateSelect: 'Ein Datum auswählen',
    dateSelectPlaceholder: 'Klicken Sie hier, um ein Datum auszuwählen...',
    days: 'Tag(e)',
    daysCount: `{count} {count, plural,
        =0 {Tag}
        =1 {Tag}
        other {Tage}
    }`,
    delete: 'Löschen',
    deleteRequestError: 'Fehler beim Löschen!',
    deleteRequestSuccess: 'Erfolgreich gelöscht!',
    description: 'Beschreibung',
    detailsInformation: 'Details',
    domain: 'Domain',
    download: 'Herunterladen',
    edit: 'Bearbeiten',
    editViewAdvanced: 'Erweiterte Bearbeitung',
    editViewSimplified: 'Vereinfachte Bearbeitung',
    elementNoItems: 'Kein Element',
    elementsCount: `{count} {count, plural,
              =0 {Element}
              =1 {Element}
              other {Elemente}
          }`,
    example: 'Beispiel',
    examples: 'Beispiele',
    file: 'Datei',
    fileDeleteError: 'Diese Datei kann nicht gelöscht werden',
    fileDeleteSuccess: 'Datei gelöscht!',
    fileSelected: 'Ausgewählte Datei: {file}',
    fileSwitch: 'Datei ändern',
    fileUploadError: 'Diese Datei kann nicht hochgeladen werden!',
    fileUploadProcessStartOnSave: 'Der Datei-Upload beginnt beim Speichern.',
    fileUploadRestrictionTypeError: 'Ungültiges Dateiformat! Erlaubt: {types}',
    fileUploadSuccess: 'Datei erfolgreich hochgeladen!',
    files: 'Dateien',
    filtersTitle: 'Filter',
    finish: 'Beenden',
    flags: 'Flaggen',
    free: 'Gratis',
    generalInformation: 'Allgemeine Informationen',
    help: 'Hilfe',
    hours: 'Stunden',
    hoursCount: `{count} {count, plural,
        =0 {Stunde}
        =1 {Stunde}
        other {Stunden}
    }`,
    imageDeleteError: 'Dieses Bild kann nicht gelöscht werden!',
    imageDeleteSuccess: 'Bild gelöscht!',
    imageUploadError: 'Dieses Bild kann nicht hochgeladen werden',
    imageUploadRestrictionSize: 'Das Bild darf eine maximale Größe von {format} haben',
    imageUploadRestrictionType: 'Das Bild muss im Format {types} sein',
    imageUploadRestrictionTypeError: 'Nicht akzeptiertes Bildformat! Erlaubt: {types}',
    import: 'Importieren',
    importModelDownloadButton: 'Vorlage herunterladen',
    importRequestError: 'Während des Imports ist ein Fehler aufgetreten!',
    importRequestSomeFailAlert: 'Ein oder mehrere Elemente konnten nicht importiert werden!',
    importRequestSuccess: 'Daten erfolgreich importiert!',
    importerFileButton: 'Daten importieren',
    importerFileHelp: 'Sie können eine CSV-Datei mit Ihrem Tabellenkalkulationsprogramm (Excel, OpenOffice, ...) erstellen',
    importerFileInfo: 'Wählen Sie eine CSV-Datei (Werte durch Kommata getrennt)',
    importerNoItemsAlert: 'Keine Elemente zum Importieren vorhanden',
    importerTitle: 'Datenimport',
    information: 'Informationen',
    informationsDetails: 'Details',
    informationsGeneral: 'Allgemeine Informationen',
    invoicePrint: 'Rechnung drucken',
    invoicesPrint: 'Rechnungen drucken',
    isActive: 'Aktiv?',
    isPublic: 'Öffentlich?',
    isUnlimited: 'Unbegrenzt?',
    label: 'Name/Label',
    language: 'Sprache',
    languageAR: 'Arabisch',
    languageBN: 'Bengalisch',
    languageDE: 'Deutsch',
    languageEN: 'Englisch',
    languageES: 'Spanisch',
    languageFR: 'Französisch',
    languageHI: 'Hindi',
    languageIT: 'Italienisch',
    languageJA: 'Japanisch',
    languagePT: 'Portugiesisch',
    languageRU: 'Russisch',
    languageZH: 'Chinesisch',
    learnMoreButton: 'Mehr erfahren',
    limitLabel: 'Art des Limits',
    limitTextForm1: 'muss ein/eine ... haben',
    listTitle: 'Liste',
    loading: 'Wird geladen...',
    logo: 'Logo',
    minutes: 'Minute(n)',
    name: 'Name',
    next: 'Weiter',
    no: 'Nein',
    of: 'von',
    options: 'Optionen',
    order: 'Bestellung',
    orderAdd: 'Eine Bestellung hinzufügen',
    orderAddTitle: 'Eine Bestellung anlegen',
    orderAddressPrivacyInfo: ' Ihre Adresse wird nicht öffentlich sein! Nur die anderen Teilnehmer dieser Bestellung können sie sehen.',
    orderAddressShippingValid: 'Lieferadresse bestätigen',
    orderBilling: 'Rechnungsstellung',
    orderConfirmationPaymentError: 'Es ist ein Fehler aufgetreten... Bitte kontaktiere uns!',
    orderConfirmationPaymentWaiting: 'Bitte warten... Wir verarbeiten Ihre Zahlung, um Ihre Bestellung zu bestätigen.',
    orderConfirmationPendingText: 'Ihre Bestellung wartet auf die Zahlung, um abgeschlossen zu werden! Klicken Sie auf den untenstehenden Link, um Ihren Einkauf durch die Zahlung abzuschließen.',
    orderConfirmationPendingText2: 'ACHTUNG: Wenn Sie mit Kreditkarte bezahlst, kann die Zahlungsbestätigung einige Minuten dauern. Bitte warten Sie, während wir die Sicherheitsprüfungen durchführen.',
    orderConfirmationPendingTitle: 'Bestellung wartet auf Zahlung!',
    orderConfirmationSocialText: 'Folgen Sie uns auf Ihren Lieblings-Netzwerken, um keine Neuigkeiten, neuen Produkte und exklusiven Aktionen zu verpassen...',
    orderConfirmationSocialTitle: 'Lassen Sieen Sie uns in Kontakt bleiben!',
    orderConfirmationText: ' Ihre Bestellung wurde erfolgreich registriert und geht nun in die Vorbereitung. Sie erhalten eine E-Mail, sobald sie versendet wurde.',
    orderConfirmationTitle: 'Bestellung erhalten!',
    orderContent: 'Inhalt der Bestellung',
    orderDetails: 'Details',
    orderId: 'ID',
    orderInfoCommentAlertTitle: 'Wichtige Nachricht',
    orderInvoice: 'Rechnung',
    orderInvoicePrintButton: 'Die Rechnung drucken',
    orderItemsEmpty: 'Es befindet sich kein Artikel in Ihrer Bestellung',
    orderItemViewBook: 'Mein Buch ansehen',
    orderItemsTotal: 'Gesamtzahl der Artikel:',
    orderMassStatusConfirmMessage: 'Status von {count} Bestellung(en) aktualisieren?',
    orderNoItems: 'Sie haben noch keine Bestellung aufgegeben!',
    orderNoteCustomer: 'Kundennotiz',
    orderPaymentChooseMethodLabel: 'Wählen Sie eine Zahlungsmethode',
    orderPaymentFinishTitle: 'Ihre Zahlung abschließen',
    orderPaymentValidButton: 'Zahlung bestätigen',
    orderPayments: 'Zahlungen',
    orderProcessInvitationText: 'Laden Sie Ihre Freunde ein, das Feld auszufüllen',
    orderProcessInvitationTextBefore1: 'Directos.eu ist ein Gruppenkauf-Service für Privatpersonen, der es Ihnen ermöglicht, Produkte direkt bei den Herstellern zu kaufen. Sie sparst sowohl beim Produktpreis ALS AUCH bei den Versandkosten!',
    orderProcessInvitationTextBefore2: 'Keine Sorge! Wir haben die Lösung:',
    orderProductAdd: 'Ein Produkt hinzufügen ',
    orderRefunds: 'Rückerstattungen',
    orderShipping: 'Versand',
    orderShippingAdd: 'Versand hinzufügen',
    orderShippingFee: 'Versandkosten',
    orderShippingRemoveConfirmMessage: 'Möchten Sie diese Lieferung wirklich aus der Bestellung entfernen?',
    orderShippingTrackingTitle: 'Verfolge Ihre Bestellung',
    orderShippingTrackingButton: 'Sendung verfolgen',
    orderShippingTrackingHint: 'Die Sendungsverfolgung kann beim Transporteur einige Stunden dauern.',
    orderShippings: 'Lieferungen',
    orderStatus: 'Status',
    orderStatusCanceled: 'Storniert',
    orderStatusComplete: 'Abgeschlossen',
    orderStatusOnpreparation: 'In Vorbereitung',
    orderStatusOnprogress: 'In Bearbeitung',
    orderStatusPending: 'In der Warteschleife',
    orderStatusPendingpayment: 'Wartet auf Zahlung',
    orderStatusShipped: 'Versandt',
    orderSubtotalDiscount: 'Rabatt',
    orderSubtotalExclTax: 'Zwischensumme (exkl. MwSt.)',
    orderSubtotalInclTax: 'Zwischensumme (inkl. MwSt.)',
    orderTax: 'MwSt.',
    orderThanks: 'Vielen Dank für Ihre Bestellung',
    attributionPaidLine: 'Die Zahlung ist durch',
    attributionSkip: 'Meine Bestellung ansehen',
    attributionSourceTitle: 'Was hat Ihnen Lust auf dieses Buch gemacht?',
    attributionSourceLead: 'Ihre Bestellung läuft bereits. Eine Antwort genügt, dann sehen wir, was Sie angesprochen hat.',
    attributionSearchTitle: 'Kannten Sie MonLivreSMS schon, bevor Sie gesucht haben?',
    attributionSearchLead: 'Ein Name, den Sie schon einmal gehört hatten, oder etwas ganz Neues.',
    attributionOccasionTitle: 'Für welchen Anlass ist dieses Buch?',
    attributionOccasionLead: 'Der Anlass, an den Sie denken.',
    attributionOtherPlaceholder: 'Ein paar Worte, wenn Sie möchten',
    attributionOtherContinue: 'Weiter',
    attributionSaveError: 'Diese Antwort konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
    attributionOpt_bouche_a_oreille: 'Jemand Nahes hat mir davon erzählt',
    attributionOpt_vu_objet: 'Ich habe das Buch bei jemandem gesehen',
    attributionOpt_receveur_devenu_client: 'Ich habe eines geschenkt bekommen, jetzt bin ich dran',
    attributionOpt_recherche: 'Bei einer Suche auf Google',
    attributionOpt_instagram: 'Instagram',
    attributionOpt_tiktok: 'TikTok',
    attributionOpt_facebook: 'Facebook',
    attributionOpt_pinterest: 'Pinterest',
    attributionOpt_qvema: 'Qui veut être mon associé',
    attributionOpt_medias: 'Ein Artikel, eine Sendung oder ein Podcast',
    attributionOpt_client_existant: 'Ich hatte hier schon bestellt',
    attributionOpt_autre: 'Etwas anderes',
    attributionOpt_decouverte_pure: 'Eher ein Zufall',
    attributionOpt_pre_bao: 'Jemand Nahes hatte mir davon erzählt',
    attributionOpt_pre_tv: 'Ich hatte es im Fernsehen gesehen',
    attributionOpt_pre_social: 'Ich hatte es in sozialen Netzwerken gesehen',
    attributionOpt_pre_inconnu: 'Ich weiß es nicht mehr',
    attributionOpt_anniv_couple: 'Der Jahrestag unseres Kennenlernens',
    attributionOpt_noel: 'Weihnachten',
    attributionOpt_saint_valentin: 'Valentinstag',
    attributionOpt_anniversaire: 'Ein Geburtstag',
    attributionOpt_deuil: 'Die Nachrichten von jemandem, den ich verloren habe',
    attributionOpt_naissance: 'Eine Geburt',
    attributionOpt_distance: 'Jemand geht fort, oder lebt weit weg',
    attributionOpt_pour_soi: 'Für mich, nicht zum Verschenken',
    attributionOpt_autre_occasion: 'Ein anderer Moment',
    bookIntentTitle: 'Wofür ist dieses Buch?',
    bookIntentLead: 'Eine Antwort, dann geht es los.',
    bookIntentSkip: 'Überspringen',
    bookIntentOpt_anniv_couple: 'Der Jahrestag unseres Kennenlernens',
    bookIntentOpt_anniversaire: 'Der Geburtstag von jemandem',
    bookIntentOpt_noel: 'Weihnachten',
    bookIntentOpt_saint_valentin: 'Valentinstag',
    bookIntentOpt_souvenir: 'Jemand, der nicht mehr da ist',
    bookIntentOpt_plus_tard: 'Ein späteres Datum',
    bookIntentOpt_autre: 'Etwas anderes',
    bookIntentDate_anniv_couple: 'Welches Datum ist es?',
    bookIntentDateLead_anniv_couple: 'Der Tag, an dem Sie sich kennengelernt haben, oder der Tag, den Sie zu zweit feiern.',
    bookIntentDate_anniversaire: 'An welchem Tag ist der Geburtstag?',
    bookIntentDateLead_anniversaire: 'Der Geburtstag der Person, der Sie das Buch schenken.',
    bookIntentDate_plus_tard: 'Um welches Datum geht es?',
    bookIntentDateLead_plus_tard: 'Der Tag, den Sie im Kopf haben.',
    bookIntentDateDefer: 'Das Datum gebe ich später an',
    bookIntentDateBack: 'Zurück',
    bookIntentDateContinue: 'Weiter',
    bookIntentSaveError: 'Die Antwort konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
    inboxPromptTitle: 'Für Ihr Buch',
    inboxPromptSignup: 'Wir haben Ihnen gerade eine E-Mail geschickt, « {subject} ». Das ist der Anfang Ihres Buches, keine Werbung. {provider} legt sie manchmal beiseite. Markieren Sie sie als « {mark} ». Mit dieser Geste kommt der Rest richtig bei Ihnen an, mit dem, was Sie brauchen, um es wirklich gut zu machen.',
    inboxPromptTransfer: 'Wir haben Ihnen gerade eine E-Mail geschickt, « {subject} ». Das ist der Link zu Ihrer Unterhaltung, keine Werbung. {provider} legt sie manchmal beiseite. Markieren Sie sie als « {mark} ». Mit dieser Geste haben Sie alles zur Hand, um das Buch zu machen, das Sie möchten.',
    inboxPromptMarkGmail: 'Kein Spam',
    inboxPromptMarkYahoo: 'Kein Spam',
    inboxPromptButton: 'Ich bestätige in {provider}',
    inboxPromptClose: 'Schließen',
    inboxPromptConfirm: 'Wir haben Ihnen gerade eine E-Mail geschickt, « {subject} ». Sie öffnet Ihr Konto. {provider} legt sie manchmal beiseite. Markieren Sie sie als « {mark} ». Mit dieser Geste kommt der Rest bei Ihnen an.',
    emailConfirmPageTitle: 'Bestätigen Sie Ihre Adresse',
    emailConfirmTitle: 'Sehen Sie in Ihre E-Mails',
    emailConfirmLead: 'Wir haben Ihnen gerade eine E-Mail geschickt, um Ihr Konto zu öffnen. Der Button darin bestätigt Ihre Adresse.',
    emailConfirmResend: 'E-Mail erneut senden',
    emailConfirmResent: 'Die E-Mail ist wieder unterwegs.',
    emailConfirmExpired: 'Dieser Link ist abgelaufen. Bitten Sie in Ihrem Konto um einen neuen.',
    emailConfirmInvalid: 'Dieser Link gehört zu keinem Konto.',
    emailConfirmWorking: 'Konto wird geöffnet…',
    orderTotal: 'GESAMT',
    orderTotalTTC: 'Gesamt (inkl. MwSt.)',
    orderTotalTax: 'MwSt. {rate}%',
    orderTotalToPay: 'Zu zahlender Gesamtbetrag: {total}€',
    orderTotals: 'Summen',
    orderUserRegisterAlert: 'Sie müssen Ihre E-Mail-Adresse angeben, damit wir Sie kontaktieren können, falls es ein Problem mit Ihrer Bestellung gibt.',
    orderView: 'Die Bestellung ansehen',
    orderWeight: 'Gewicht',
    orderitemAddProductTitle: 'Artikeldaten ändern',
    orders: 'Bestellungen',
    ordersContactTitle: 'Bezgl. einer Bestellung kontaktieren',
    ordersMy: 'Meine Bestellungen',
    ordersMyViewButton: 'Meine Bestellungen ansehen',
    packingInformation: 'Verpackungsinformationen',
    parcelGroupInfo: ' Den Versand nach Anzahl der Pakete gruppieren',
    parcelGroupLabel: 'Paketgruppe',
    parcelGroupWeightInfo: 'Kg pro Paket',
    parcelGroupWeightLabel: 'Den Versand nach Gewicht gruppieren',
    paymentCardInputLabel: 'Geben Sie Ihre Kartendaten ein, um die Bestellung zu bestätigen.',
    paymentMethodCreditbalanceDescription1: 'Wird automatisch vom Gesamtbetrag abgezogen',
    paymentMethodCreditbalanceDescription2: 'Noch zu zahlen',
    paymentMethodCreditbalancePay: 'Mit meinem Guthaben bestätigen',
    paymentMethodCreditbalanceTitle: 'Guthaben bereits angerechnet',
    paymentFailError: 'Ihre Zahlung ist fehlgeschlagen! Bitte versuchen Sie es erneut.',
    paymentMethod: 'Zahlungsmethode',
    paymentMethodBancontactLabel: 'Bancontact',
    paymentMethodBankcheckLabel: 'Bankscheck',
    paymentMethodBanktransferLabel: 'Banküberweisung',
    paymentMethodCardLabel: 'Kreditkarte',
    paymentMethodCreditcardLabel: 'Kreditkarte',
    paymentMethodCreditDescription1: 'Dieser Betrag wird automatisch vom ausstehenden Betrag Ihres Warenkorbs abgezogen.',
    paymentMethodGiropayLabel: 'Giropay',
    paymentMethodIdealLabel: 'iDEAL',
    paymentMethodPhoneLabel: 'Telefon',
    paymentMethodCreditPay: 'Mit meinen Credits bezahlen',
    paymentMethodCreditTitle: 'Sie haben bereits einen Teil Ihrer Bestellung bezahlt:',
    paymentValidButton: 'Meine Zahlung bestätigen',
    previous: 'Zurück',
    priceInformation: 'Preisinformationen',
    priceRoundAlertTooltip: 'Dieser Preis kann aufgrund der Währungsumrechnung leicht gerundet sein.',
    printButton: 'Drucken',
    process: 'Prozess',
    productAnnexes: 'Anhänge',
    productAnnexesNewProductError: 'Bitte speichere Ihr neues Produkt, bevor Sie Anhänge hinzufügst!',
    productAttributes: 'Attribute',
    productConversationTypeMissingAlert: 'Es ist kein Produkt mit dem ausgewählten Typ verknüpft. Bitte kontaktiere uns, um das Problem zu lösen!',
    productCostHT: 'Kosten (exkl. MwSt.)',
    productDescription: 'Beschreibung',
    productEdit: 'Das Produkt bearbeiten',
    productImages: 'Bilder',
    productImagesNewProductError: 'Bitte speichere Ihr neues Produkt, bevor Sie Bilder hinzufügst!',
    productIsActive: 'Aktiv?',
    productName: ' Name',
    productPictureDelete: 'Das Bild löschen',
    productPriceHT: 'Preis (exkl. MwSt.)',
    productPriceTTC: 'Preis (inkl. MwSt.)',
    productReference: 'Referenz',
    productSlug: 'Slug',
    productSpecialPriceQuantityDiscountInfo: 'Spare {percent}% bei Ihrem Einkauf, indem Sie {quantity} Kopien hinzufügst!',
    productTaxCalculate: 'Berechnen',
    productTaxRate: 'MwSt.-Satz',
    productTaxRateFormHelp: 'Für 19% MwSt. gib 0.19 ein',
    productUseForConversationBook: 'Verfügbar für gedruckte Bücher?',
    productUseForConversationEBook: 'Verfügbar für eBooks (digital)?',
    productUseForCredit: 'Für Benutzer-Credits verwenden?',
    products: 'Produkte',
    productsView: 'Die Produkte ansehen',
    quantity: 'Menge',
    refresh: 'Aktualisieren',
    refundCreateTitle: 'Eine Rückerstattung erstellen',
    refundCreateConfirmMessage: 'Möchten Sie diese Rückerstattung wirklich erstellen?',
    remove: 'Entfernen',
    retry: 'Erneut versuchen',
    save: 'Speichern',
    saveBeforeAlert: 'Bitte speichere zuerst die Änderungen...',
    saveRequestError: 'Fehler beim Speichern!',
    saveRequestSuccess: 'Erfolgreich gespeichert!',
    saving: 'Wird gespeichert...',
    searchFor: 'Suchen',
    seconds: 'Sekunde(n)',
    select: 'Auswählen',
    selectAll: 'Alles auswählen',
    selectFile: 'Eine Datei auswählen',
    selectImage: 'Wählen Sie ein Bild aus',
    selectOptions: 'Eine Option auswählen',
    selectUnAll: 'Auswahl aufheben',
    seoTitle: 'Drucke Ihre SMS und WhatsApp-Chats als Buch',
    shippingAddressEdit: 'Lieferadresse bearbeiten',
    shippingAddressMissingError: 'Sie haben keine Lieferadresse angegeben.',
    shippingCalculation: 'Berechnung',
    shippingCalculationInfo: 'Wenn die Berechnung in eine Schleife gerät, ist es besser, das inklusive Maximum zu verwenden.',
    shippingCarrier: 'Versanddienstleister',
    shippingChronopostPickupError: 'Wir konnten die Paketshops nicht laden! Bitte überprüfen Sie das Land und die Postleitzahl, bevor Sie es erneut versuchen.',
    shippingChronopostPickupNoResult: 'Wir haben keinen Abholort in der Nähe gefunden. Bitte suche mit einer anderen Adresse oder Postleitzahl.',
    shippingChronopostPickupOpeningHours: 'Öffnungszeiten',
    shippingChronopostPickupOpeningHoursView: 'Öffnungszeiten ansehen',
    shippingChronopostPickupViewList: 'Als Liste anzeigen',
    shippingChronopostPickupViewMap: 'Auf der Karte ansehen',
	shippingPickupError: 'Der Paketshop-Auswahldialog konnte nicht geöffnet werden. Bitte versuchen Sie es später erneut.',
	shippingPickupChange: 'Paketshop ändern',
	shippingPickupChoose: 'Paketshop auswählen',
    shippingCountrySelect: 'Lieferland',
    shippingDeleteConfirmMessage: 'Möchten Sie diese Versandart wirklich löschen?',
    shippingDeliveryEstimationDate1: 'Voraussichtliches Lieferdatum: {date}',
    shippingDeliveryEstimationDate2: 'Voraussichtliches Lieferdatum: zwischen dem {date1} und dem {date2}',
    shippingDeliveryEstimationText: 'Dies ist nur eine Schätzung der Versandkosten. Ihren genauen Lieferort können Sie im nächsten Schritt auswählen.',
    shippingSurchargeCorsica: 'Dieser Preis enthält einen Korsika-Zuschlag von {price}.',
    shippingSurchargeOverseas: 'Dieser Preis enthält einen Überseegebiete-Zuschlag von {price}.',
    shippingSurchargeRemote: 'Dieser Preis enthält einen Zuschlag von {price} für schwer erreichbare Gebiete.',
    shippingDeliveryTime: 'Lieferzeit (in Tagen)',
    shippingDeliveryTimeInfo: 'Lieferung in {days} Werktagen',
    shippingDescription: 'Beschreibung',
    shippingExcludeDepartmentInfo: 'Trenne die auszuschließenden Postleitzahlen mit einem Komma (,). Sie können "*" als Platzhalter verwenden.',
    shippingExcludeDepartmentLabel: 'Postleitzahlen ausschließen',
    shippingExtraFeeCalculation: 'Berechnung zusätzlicher Versandkosten',
    shippingExtraFeeLabel: 'Label für zusätzliche Versandkosten',
    shippingExtraFees: 'Zusätzliche Kosten',
    shippingFeeCalculatorTitle: 'Berechne Ihre Versandkosten',
    shippingFeeFreeDelivery: 'Kostenloser Versand!',
    shippingFeeNotFoundError: '',
    shippingFeeWithBookResult: 'Bestellen Sie jetzt und erhalten Sie Ihr eBook sofort, und Ihre gedruckten Bücher in {countryName} zwischen dem {deliveryDateFrom} und dem {deliveryDateTo}.',
    shippingFeeWithoutBookResult: 'Bestellen Sie jetzt und erhalten Sie Ihr eBook sofort per E-Mail.',
    shippingFreeStep: 'Schwelle für kostenlosen Versand',
    shippingFreeTreshold: 'Betrag für kostenlosen Versand',
    shippingFreeInfo: 'Kostenloser Versand ab {value}',
    shippingIdentifier: 'Versand-Kennung',
    shippingIsPriceTTC: 'Ist der Versandpreis inkl. MwSt.?',
    shippingLabelGenerateButton: 'Versandetikett erstellen',
    shippingLabelGenerateButton2: 'Versandetikett neu erstellen',
    packingCheckTitle: 'Die Bücher dieser Bestellung',
    packingCheckHint: 'Halten Sie jeweils ein Buch mit dem Rücken zur Kamera. Wenn die Zahl steigt, legen Sie es aus dem Bild und nehmen Sie das nächste.',
    packingCheckProgress: '{seen} / {expected}',
    packingCheckForeign: 'Dieses Buch gehört zur Bestellung {code}. Nehmen Sie es aus dem Paket.',
    packingCheckReady: 'Stimmt. Das sind die Bücher dieser Bestellung. Sie können das Etikett drucken.',
    packingCheckOverflow: 'Es wurden zu viele Bücher gelesen. Bitte von vorn beginnen.',
    packingCheckRestart: 'Neu beginnen',
    packingCheckCameraStart: 'Kamera öffnen',
    packingCheckCameraDenied: 'Die Kamera ist blockiert. Erlauben Sie sie, oder lesen Sie den QR-Code mit dem Scanner.',
    packingCheckLocked: 'Scannen Sie alle Bücher, bevor Sie das Etikett drucken.',
    packingCheckWedgeLabel: 'Oder den QR-Code mit dem Scanner lesen',
    packingCheckLoading: 'Die Bücher dieser Bestellung werden geladen.',
    prepBooksCardTitle: 'Bücher',
    prepBooksCount: '{count, plural, one {# Buch} other {# Bücher}}',
    prepBooksPageEyebrow: 'Vorbereitung',
    prepBooksPageTitle: 'Bestellung {code}',
    prepBooksPageHint: 'Die Bücher, die in dieses Paket kommen.',
    prepModeClient: 'Kundenansicht',
    prepModePreparation: 'Vorbereitungsansicht',
    shippingLegacyChronopostPaused: 'Diese Bestellung läuft noch über das frühere Chronopost. Stellen Sie die Versandart über Bearbeiten auf ein Sendcloud-Angebot um und erstellen Sie danach das Etikett.',
    shippingMethodCalculating: 'Versandoptionen werden berechnet...',
    shippingMethodConditions: 'Versandbedingungen',
    shippingMethodMissingAlert: 'Wir haben keinen verfügbaren Versanddienstleister für Ihren Warenkorb gefunden. Bitte ändere die Adresse oder wählen Sie einen anderen Anbieter.',
    shippingMethodNotAvailable: 'Es sind keine Lieferoptionen für Ihre Adresse verfügbar...',
    shippingRatesError: 'Die Berechnung der Versandkosten wurde unterbrochen. Versuchen Sie es gleich noch einmal. Wenn es wieder passiert, schreiben Sie uns, dann sehen wir es uns gemeinsam an.',
    shippingMethodPricing: 'Tarif',
    shippingMethodPricingSystem: 'Preissystem',
    shippingMethodSearch: 'Versandoptionen werden gesucht...',
    shippingMethodSelectTitle: 'Wählen Sie Ihre Versandmethode',
    shippingGroupRelay: 'Paketshop',
    shippingGroupHome: 'Lieferung nach Hause',
    shippingTierClassic: 'Standardlieferung',
    shippingTierExpress: 'Express-Lieferung',
    shippingTierClassicDesc: 'Standard-Lieferzeit',
    shippingTierExpressDesc: 'Die schnellste Option',
    shippingTierPriceRelayFree: 'Gratis im Paketshop',
    shippingTierPriceRelayFrom: 'Ab {price} im Paketshop',
    shippingTierPriceHomeFrom: '{price} nach Hause',
    shippingChangeTier: 'Liefergeschwindigkeit ändern',
    shippingTierModeTitle: 'Wählen Sie Ihre Lieferart',
    shippingStepOf: 'Schritt {current} von {total}',
    shippingStepSpeedTitle: 'Wann möchten Sie beliefert werden?',
    shippingStepModeTitle: 'Wohin möchten Sie beliefert werden?',
    shippingMethodTrackingInfo: 'Informationen zur Sendungsverfolgung',
    shippingMethods: 'Versandmethoden',
    shippingOrder: 'Versandauftrag',
    shippingProvider: 'Logistikdienstleister',
    shippingStep: 'Schritt',
    shippingStepInfo: 'Dieser Schritt MUSS der linke Parameter sein! Der obere Parameter ist die Standard-Postleitzahl.',
    shippingStepLimitInfo: 'Ist die linke Bedingung das Minimum/Maximum?',
    shippingTaxRate: 'MwSt.-Satz für den Versand',
    shippingTitle: 'Lieferung',
    shippingTrackingNumber: 'Sendungsnummer',
    shippingTrackingParcelUrl: 'URL zur Paketverfolgung',
    status: 'Status',
    stepTitle: 'Schritt {step}',
    submit: 'Absenden',
    suborderitemAddProductTitle: 'Ein Produkt hinzufügen',
    switchLanguage: 'Sprache ändern',
    tableMassActions: 'Massenaktionen',
    tableRefreshSuccessAlert: 'Erfolgreich synchronisiert!',
    tableRefreshSuccessError: 'Synchronisierungsfehler!',
    tableSelection: `{count} {count, plural,
			  =0 {ausgewählt}
			  =1 {ausgewählt}
			  other {ausgewählt}
		  }`,
    tag: 'Tag',
    tagFillPlaceholder: 'Geben Sie ein Stichwort ein...',
    tags: 'Tags',
    taskDescription: 'Beschreibung',
    taskEditTitle: 'Aufgabe bearbeiten',
    taskPriority: 'Priorität',
    taxRate: 'MwSt.',
    the: 'der/die/das',
    time: 'Uhrzeit',
    timezone: 'Zeitzone',
    title: 'Titel',
    toleranceLabel: 'Toleranz',
    total: 'Gesamt',
    type: 'Typ',
    unit: 'Einheit',
    user: 'Benutzer',
    userAccountCreditsTitle: 'Mein Guthaben',
    userAccountDataProtection: 'Datenschutz',
    userAccountDataProtectionText1: 'Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Deshalb verpflichten wir uns, sie sicher aufzubewahren, und speichern sie nur so lange, wie es für die Erbringung unseres Dienstes unbedingt erforderlich ist.',
    userAccountDataProtectionText2: 'Wir fragen nur nach den absolut notwendigen Informationen. Wir werden Ihre Daten niemals an Dritte weitergeben oder sie ohne Ihre ausdrückliche Zustimmung für kommerzielle Zwecke verwenden.',
    userAccountDataProtectionText3: 'Wenn Sie Ihre Daten herunterladen oder Ihr Recht auf Vergessenwerden ausüben möchten, kontaktiere uns bitte unter {email}.',
    userAccountDelete: 'Mein Konto löschen',
    userAccountDeleteActiveSuborder: 'Sie können Ihr Konto nicht löschen, solange Sie noch offene Bestellungen hast!',
    userAccountDeleteBlockText: 'Sie können Ihr Konto derzeit nicht löschen!',
    userAccountDeleteButton: 'Mein Konto dauerhaft löschen',
    userAccountDeleteConfirmMessage: 'Sind Sie absolut sicher, dass Sie Ihr Konto für immer löschen möchten?',
    userAccountDeleteConfirmTitle: 'Mein Konto löschen',
    userAccountDeleteError: 'Wir konnten Ihr Konto nicht löschen!',
    userAccountDeleteSuccess: 'Ihr Konto wurde gelöscht! Wir hoffen, Sie bald wiederzusehen!',
    userAccountDeleteText: 'Wenn Sie Ihr Konto löschst, verlierst Sie den Zugriff auf Ihren gesamten Verlauf und Ihre gespeicherten Bücher. Wir werden alle Ihre persönlichen Daten sicher von unseren Servern löschen. Diese Aktion ist unwiderruflich!',
    userAccountEdit: 'Meine Daten ändern',
    userAccountEditSuccess: 'Profil erfolgreich aktualisiert',
    userAccountExistError: 'Es existiert kein Konto, das mit dieser E-Mail-Adresse verknüpft ist!',
    userAccountExistTitle: 'Haben Sie bereits ein Konto bei uns?',
    userAccountGeneral: 'Allgemein',
    userAccountHistory: 'Verlauf',
    userAccountInfo: 'Ihre Daten sind geschützt und bleiben streng vertraulich.',
    userAccountInfoMyTitle: 'Meine persönlichen Daten',
    userAccountMy: 'Mein Konto',
    userAccountPersonnalInformation: 'Meine persönlichen Informationen',
    userAccountPreferencesInformation: 'Meine Präferenzen',
    userAccountResetError: 'Fehler beim Versuch, das Konto wiederherzustellen!',
    userAccountResetSuccess: 'Konto erfolgreich wiederhergestellt!',
    userActivityOnLine: 'Online',
    userAdd: 'Einen Benutzer hinzufügen',
    userAddNew: 'Einen neuen Benutzer hinzufügen',
    userBridgeError: 'Die Anmeldung über die App ist fehlgeschlagen. Bitte versuchen Sie es erneut.',
    userBridgeInvalid: 'Dieser Anmeldelink ist nicht mehr gültig. Starten Sie die Anmeldung erneut in der App.',
    userBridgePending: 'Anmeldung läuft…',
    userBridgeSuccess: 'Sie bist angemeldet! Sie können jetzt zur App zurückkehren.',
    userChangePasswordSuccess: 'Passwort aktualisiert!',
    userConfirmationCode: 'Bestätigungscode per E-Mail erhalten',
    userConfirmationCodeCheckButton: 'Ich habe den Code bereits, um mein Passwort zurückzusetzen',
    userConfirmationCodeError: 'Bitte geben Sie den Bestätigungscode ein, den wir Ihnen per E-Mail geschickt haben!',
    userConnectionInfo: 'Melden Sie sich an, um Ihre Bestellung zu bestätigen und Ihr Buch zu speichern!',
    userCredits: 'Credits',
        userCreditsBalancePositive: 'Sie haben {amount} Guthaben: wird automatisch im nächsten Schritt angewendet.',
    userCreditsPrepaymentInviteTitle: 'Vorauszahlung Ihres Buches',
    userDeleteConfirmTitle: 'Benutzer löschen',
    userDeleteConfirmMessage: 'Möchten Sie diesen Benutzer wirklich löschen?',
    userDeleteConfirmation: 'Der Benutzer {user} wurde gelöscht!',
    userEdit: '{user} bearbeiten',
    userEdit2: 'Den Benutzer bearbeiten',
    userEditPassword: 'Mein Passwort ändern',
    userEmail: 'E-Mail-Adresse',
    userEmailError: 'Die E-Mail-Adresse ist ungültig!',
    userEmailFillInfo: 'Geben Sie Ihre E-Mail ein',
    userEmailFormInfo: 'Schreiben Sie Ihre E-Mail, um fortzufahren',
    userEmailFormInfo2: 'Wir verwenden Ihre E-Mail, um Ihr Konto sicher zu erstellen und Ihnen das Tracking Ihrer Bestellung zu senden.',
    userLoginCodeTitle: 'Sie haben bereits ein Konto',
    userLoginCodeIntro: 'Wir haben gerade einen 6-stelligen Code an {email} gesendet. Geben Sie ihn hier ein, um fortzufahren.',
    userLoginCodeLabel: 'Code aus der E-Mail',
    userLoginCodeSubmit: 'Bestätigen',
    userLoginCodeInvalid: 'Dieser Code stimmt nicht. Prüfen Sie die zuletzt erhaltene E-Mail.',
    userLoginCodeExpired: 'Dieser Code ist nicht mehr gültig. Fordern Sie direkt darunter einen neuen an.',
    userLoginCodeError: 'Hoppla, das hat nicht geklappt. Bitte versuchen Sie es gleich noch einmal.',
    userLoginCodeLinkHint: 'Dieselbe E-Mail enthält auch einen Anmeldelink.',
    userLoginCodeResend: 'Neuen Code senden',
    userLoginCodeResendIn: 'Neuen Code senden in {seconds} s',
    userLoginCodeResent: 'Erneut gesendet. Schauen Sie auch in Ihren Spam-Ordner.',
    userLoginCodeChangeEmail: 'Andere E-Mail-Adresse verwenden',
    userLoginCodeCartSuccess: 'Sie sind angemeldet. Sie können Ihre Bestellung jetzt abschließen.',
    userEnvironmentTestNoTest: 'Dieser Benutzer hat keinen Umgebungstest durchgeführt!',
    userFillPlaceholder: 'Geben Sie den Namen eines Benutzers ein...',
    userFirstName: 'Vorname',
    userForgotPassword: 'Haben Sie Ihr Passwort vergessen?',
    userForgotPasswordRetryDateError: 'Sie können noch keinen neuen Code anfordern. Bitte überprüfen Sie Ihren Posteingang (und den Spam-Ordner), um ihn zu finden.',
    userFormInfo: 'Vervollständige Ihr Profil',
    userGenderLabel: 'Geschlecht',
    userIsActive: 'Aktiv?',
    userLastName: 'Nachname',
    userLogin: 'Anmelden',
    userLoginAction: 'Eintreten',
    userLoginEmailSelected: 'Anmeldung mit der E-Mail: {email}',
    userLoginError: 'Falsche Daten! Bitte versuchen Sie es erneut...',
    userLoginFirstButton: 'Sind Sie zum ersten Mal hier?',
    userLoginFirstText: 'Überprüfe Ihren Posteingang: Wir haben Ihnen ein temporäres Passwort geschickt. Nutzen Sie es für Ihre erste Anmeldung. Sie können es später ganz einfach in Ihrem Profil ändern.',
    userLoginBenefit1: 'Ihr SMS-Fotobuch in wenigen Klicks',
    userLoginBenefit2: 'Schnelle Lieferung nach Hause',
    userLoginBenefit3: '100% sicheres Bezahlen',
    userLoginIntro: 'Bitte identifiziere Sie, um auf Ihre Bücher und Ihren persönlichen Bereich zuzugreifen.',
    userLoginWelcomeSubtitle: 'Verwandeln Sie Ihre SMS in ein schönes gedrucktes Fotobuch.',
    userLoginWelcomeTitle: 'Willkommen!',
    userLoginNoConnexion: 'Keine Verbindung',
    userLoginTitle: 'Anmelden',
    userLogout: 'Abmelden',
    userName: 'Name',
    userNewPassword: 'Neues Passwort',
    userNewsletterSubscribeButton: 'Zum Newsletter anmelden',
    userNewsletterText1: 'Erhalte Geschenkideen, exklusive Rabatte und unsere neuesten Nachrichten direkt in Ihr Postfach.',
    userOldPassword: 'Ihr aktuelles Passwort',
    userOptions: 'Benutzeroptionen',
    userPassword: 'Passwort',
    userPasswordConfirmation: 'Bestätigen Sie Ihr Passwort',
    userPasswordConfirmationError: 'Die Passwörter stimmen nicht überein! Versuchen Sie es noch einmal.',
    userPasswordConfirmationRestriction: 'Beide Passwörter müssen exakt gleich sein.',
    userPasswordEdit: 'Mein Passwort ändern',
    userPasswordSet: 'Ein Passwort festlegen',
    userPasswordSetSuccess: 'Passwort gespeichert.',
    userSocialConnectionsTitle: 'Anmeldeverfahren',
    userSocialContinueApple: 'Weiter mit Apple',
    userSocialContinueGoogle: 'Weiter mit Google',
    userSocialDivider: 'oder',
    userSocialError: 'Die Anmeldung ist fehlgeschlagen. Bitte versuchen Sie es erneut.',
    userSocialErrorNoEmail: 'Ihr Apple-Konto hat keine E-Mail-Adresse übermittelt. Nutzen Sie eine andere Anmeldung.',
    userSocialErrorUnavailable: 'Diese Anmeldung ist noch nicht verfügbar.',
    userSocialLinkApple: 'Apple verknüpfen',
    userSocialLinkGoogle: 'Google verknüpfen',
    userSocialLinkSuccess: 'Konto verknüpft.',
    userSocialLinked: 'Verknüpft',
    userSocialUnlinkApple: 'Apple trennen',
    userSocialUnlinkConfirm: 'Diese Anmeldung von Ihrem Konto trennen?',
    userSocialUnlinkGoogle: 'Google trennen',
    userSocialUnlinkLastError: 'Legen Sie ein Passwort fest, bevor Sie Ihre letzte Anmeldung trennst.',
    userSocialUnlinkSuccess: 'Konto getrennt.',
    userPasswordError: 'Bitte geben Sie ein korrektes Passwort ein!',
    userPasswordResetText: 'Geben Sie Ihr neues Passwort ein. Bestätigen Sie es und klicken Sie auf den Button unten, um es zu speichern.',
    userPasswordRestriction: 'Ihr Passwort muss aus Sicherheitsgründen mindestens 6 Zeichen lang sein und 1 Zahl sowie 1 Sonderzeichen (@&!()$*€%) enthalten!',
    userPasswordRestrictionAlt: 'Ihr Passwort muss mindestens 6 Zeichen lang sein!',
    userPasswordTemporaryCheckButton: 'Ich habe mein temporäres Passwort bereits erhalten',
    userPhone: 'Handynummer',
    userPhoneError: 'Die Telefonnummer ist ungültig!',
    userProfileMy: 'Mein Profil',
    userReInitPassword: 'Mein Passwort zurücksetzen',
    userRecoverFromOldAppCheckButton: 'Ich habe die E-Mail zur Wiederherstellung meines Passworts erhalten',
    userRecoverFromOldAppText: 'Wir haben Ihr Konto gerade auf unsere neue Plattform migriert! Überprüfe Ihre E-Mail, um Ihr Passwort wiederherzustellen und Ihren neuen persönlichen Bereich zu aktivieren.',
    userRegister: 'Mein Konto erstellen',
    userRegisterError: 'Wir konnten Ihr Konto nicht erstellen! Bitte überprüfen Sie Ihre E-Mail und versuchen Sie es erneut...',
    userRegisterSuccess: 'Herzlichen Glückwunsch! Wir haben Ihr Konto sicher erstellt. Sie haben soeben eine E-Mail mit Ihrem temporären Passwort erhalten!',
    userRegisterSuccessEmailNotice: 'Eine Bestätigungs-E-Mail wurde soeben an {email} gesendet.',
    userRegisterSuccessEyebrow: 'Willkommen',
    userRegisterSuccessPageTitle: 'Willkommen!',
    userRegisterSuccessSourcesHint: 'Wählen Sie die App, in der Ihre Nachrichten gespeichert sind.',
    userRegisterSuccessSourcesTitle: 'Wo möchten Sie beginnen?',
    userRegisterSuccessStep1Desc: 'Dort finden Sie die Zusammenfassung Ihrer Registrierung.',
    userRegisterSuccessStep1Title: 'Posteingang prüfen',
    userRegisterSuccessStep2Desc: 'WhatsApp, Messenger, Instagram, iOS oder Android: wählen Sie Ihre Quelle.',
    userRegisterSuccessStep2Title: 'Nachrichten importieren',
    userRegisterSuccessStep3Desc: 'Cover, Farben, Fotos: gestalten Sie jedes Detail nach Ihrem Geschmack.',
    userRegisterSuccessStep3Title: 'Ihr Buch erstellen',
    userRegisterSuccessStepsEyebrow: 'Ihr Weg',
    userRegisterSuccessText: 'Ihr Konto ist bereit. In wenigen Schritten verwandelst Sie Ihre Nachrichten in ein Buch zum Bewahren.',
    userRegisterSuccessTitle: 'Ihre Geschichte beginnt hier',
    userRegisterSuccessTitleNamed: 'Willkommen, {firstName}!',
    userResetPasswordAccountButton: 'Das Passwort des Kontos zurücksetzen',
    userResetPasswordAskSuccess: 'Überprüfe Ihren Posteingang! Wir haben Ihnen einen Link geschickt, um Ihr neues Passwort zu erstellen.',
    userResetPasswordButton: 'Mein Passwort zurücksetzen',
    userResetPasswordError: 'Wir konnten Ihr Passwort nicht zurücksetzen! Bitte versuchen Sie es später noch einmal...',
    userResetPasswordInfo: 'Sie erhalten einen sicheren Link per E-Mail, um Ihr Passwort zurückzusetzen.',
    userResetPasswordInfo2: 'Erstelle Ihr neues Passwort, indem Sie die Felder unten ausfüllst:',
    userResetPasswordSuccess: 'Ihr Passwort wurde erfolgreich aktualisiert!',
    userRole: 'Rolle',
    userRoleAdmin: 'Administrator',
    userRoleCustomer: 'Kunde',
    userSearchLabel: 'Schreiben Sie eine E-Mail oder den Namen eines Benutzers',
    userSendNewAccountEmail: 'E-Mail "Neues Konto" an diesen Benutzer senden',
    userSendNewAccountEmailSuccess: 'Der Benutzer wurde benachrichtigt!',
    userSwitch: 'Benutzer wechseln',
    userValidForgotPasswordError: 'Wir konnten Ihnen den Wiederherstellungscode nicht senden!',
    userValidForgotPasswordSuccess: 'Überprüfe Ihre E-Mail! Nutzen Sie den Bestätigungscode, den wir Ihnen geschickt haben, um Ihr neues Passwort zu erstellen.',
    users: 'Benutzer',
    usersList: 'Benutzerliste',
    valid: 'Bestätigen',
    view: 'Ansehen',
    voucher: 'Gutscheincode',
    voucherApplyButton: 'Rabatt anwenden',
    voucherApplyComplete: 'Sie können bei dieser Bestellung keine weiteren Gutscheincodes mehr ansammeln!',
    voucherApplyFormLabel: 'Gutscheincode',
    voucherApplyValidError: 'Ups! Dieser Gutschein ist für Ihre aktuelle Bestellung nicht gültig.',
    voucherCode: 'Code',
    voucherCodePlaceholder: 'Schreiben Sie hier Ihren Gutscheincode',
    voucherDeleteConfirmMessage: 'Möchten Sie diesen Gutschein wirklich löschen?',
    voucherEdit: 'Den Gutschein bearbeiten',
    voucherIsAuto: 'Automatisch?',
    voucherIsCumulative: 'Kombinierbar?',
    voucherIsPublic: 'Ist er öffentlich?',
    voucherNotExistsError: 'Dieser Rabattcode existiert nicht oder ist abgelaufen!',
    voucherPriority: 'Priorität',
    voucherProductOffer: 'Angeboten',
    voucherRemoveAllButton: 'Alle Rabatte entfernen',
    vouchers: 'Gutscheincodes',
    weight: 'Gewicht',
    yes: 'Ja',
    you: 'Sie',
    yourself: 'Sie',
    userNewsletterTitle: 'Newsletter',
    userNewsletterSubscribeText: 'Wir senden Ihnen unsere Neuigkeiten, exklusive Aktionen und unsere Lieblingsbücher.',
    userNewsletterUnSubscribeButton: 'Vom Newsletter abmelden',
    'userOrdersView': 'Die Bestellungen dieses Benutzers ansehen',
    'userCanCustomizeMessages': 'Kann die Nachrichten personalisieren?',
    'userLogAsUser': 'Als dieser Benutzer anmelden',
    'shippingMethodProviderData': 'Informationen des Transportunternehmens',
    'productUseForCustomization': 'Für die Personalisierung verwenden?',
    'conversationBookFormat': 'Buchformat',
    'conversationMessageSelect': 'Diese Nachricht auswählen',
    'conversationMessagesEditTitle': 'Die Werkstatt: Personalisiere Ihre Nachrichten',
    'conversationMessageSelectorDateFrom': 'Nachrichten auswählen, die gesendet wurden nach dem',
    'conversationMessageSelectorDateTo': 'Nachrichten auswählen, die gesendet wurden vor dem',
    'conversationTextSearch': 'Ein Wort im Chat suchen',
    'conversationOnlyMedias': 'Nur Fotos/Videos anzeigen',
    'conversationMessagesSelectVisible': 'Diese Seite auswählen',
    'conversationMessagesSelectAllFiltered': 'Alle auswählen ({count, number})',
    'unselect': 'Auswahl aufheben',
    'conversationMessagesEditHideSelected': 'Die ausgewählten Nachrichten aus dem Buch ausblenden',
    'conversationMessagesEditShowSelected': 'Die ausgewählten Nachrichten wieder einblenden',
    'conversationMessagesEditTooManySelected': 'Sie haben zu viele Nachrichten auf einmal ausgewählt!',
    'conversationNoMessages': 'Keine Nachricht',
    'conversationMessageEdit': 'Den Text der Nachricht bearbeiten',
    'conversationMessageAdd': 'Eine Nachricht hinzufügen',
    'conversationMessageInsert': 'Hier eine Nachricht einfügen',
    'conversationMessageEditSelect': 'Diese Nachricht auswählen',
    'conversationMessageEditUnselect': 'Diese Nachricht abwählen',
    'conversationMessageSetUnVisibleButton': 'Diese Nachricht im gedruckten Buch ausblenden',
    'conversationMessageHiddenAlert': 'Diese Nachricht wurde ausgeblendet und wird nicht in Ihrem gedruckten Buch erscheinen.',
    'conversationMessageSetVisibleButton': 'Nachricht wieder einblenden',
    'conversationMessagesEditEnableButton': 'Die Nachrichtenpersonalisierung aktivieren',
    'conversationMessagesEditEnableButton2': 'Personalisierung freischalten für {price}',
    'conversationMessagesEditDisableAlert': 'Um den genauen Inhalt Ihrer Nachrichten ändern, ausblenden oder bearbeiten zu können, müssen Sie diese Premium-Option aktivieren (Einmalzahlung).',
    'conversationMessageDateHint': 'Ändern Sie Datum und Uhrzeit, um diese Nachricht an die gewünschte Stelle in der Unterhaltung zu setzen.',
    'conversationMessageSender': 'Absender',
    'conversationMessageSenderPlaceholder': 'Absender wählen',
    'conversationMessageSenderRequiredHint': 'Wählen Sie, wer diese Nachricht sendet, um sie speichern zu können.',
    'conversationMessageAnnotation': 'Anmerkung',
    'conversationMessageAnnotationNoMedia': 'Eine Anmerkung kann kein Foto, Video oder Audio enthalten.',
    'conversationMessageText': 'Text',
    'conversationMessageTextPlaceholder': 'Text eingeben',
    'conversationMessageAttachments': 'Dateianhänge (Fotos/Videos)',
    'conversationMessageMediaLabel': 'Foto, Video oder Audio',
    'conversationMessageMediaDragDrop': 'Foto, Video oder Audiodatei hier ablegen',
    'conversationMessageMediaTapSelect': 'Tippen, um Foto, Video oder Audio auszuwählen',
    'conversationMessageMediaOpenFinder': 'Datei auswählen',
    'conversationMessageMediaPickSenderFirst': 'Wählen Sie zuerst einen Absender, um ein Foto, Video oder Audio hinzuzufügen.',
    'conversationMessageHiddenLabel': 'Diese Nachricht aus dem Buch ausblenden?',
    'conversationGenerate': 'Die Layouts der Bücher generieren',
    'conversationVerify': 'Überprüfung erzwingen',
    'conversationLaunchButton': 'In die Druckerei senden',
    'conversationViewButton': 'Meinen Chat ansehen',
    'reset': 'Zurücksetzen',
    'cms': 'CMS',
    'cmsLinkColor': 'Farbe des Buttons',
    'cmsLinkNeedObfuscate': 'Verschleierung benötigt?',
    'cmsImageUseForMobile': 'Wird für die mobile Version verwendet?',
    'contentEditPage': 'Die Seite bearbeiten',
    'cmsRedirectionAdd': 'Eine Weiterleitung hinzufügen',
    'cmsContentEdit': 'Den Inhalt bearbeiten',
    'cmsPageIsActive': 'Seite aktiv?',
    'cmsContentTypeLabel': 'Inhaltstyp',
    'cmsContentModelLabel': 'Design-Modell',
    'cmsContentTitle': 'Titel der Seite',
    'cmsContentSlug': 'Slug (URL)',
    'cmsPanelIsTemplate': 'In der globalen Vorlage enthalten?',
    'cmsPageSeoTitle': 'SEO Titel (Google)',
    'cmsPageSeoDescription': 'SEO Meta-Beschreibung',
    'cmsPageSeoKeywords': 'SEO Keywords',
    'cmsPageSeoHideOnSitemap': 'Vor Suchmaschinen verbergen (Sitemap)',
    'cmsPageSeoUseCustomTitleSuffix': 'Ein benutzerdefiniertes Titel-Suffix verwenden',
    'cmsPageSeoTitleSuffix': 'Titel-Suffix',
    'affiliation': 'Partnerprogramm',
    'affiliationInvoiceTotalAdminTitle': 'Zu zahlender Gesamtbetrag (inkl. MwSt.)',

    conversationImportLuxEyebrow: 'Ihre Geschichte',
    conversationImportLuxTagline: 'Ein einzigartiges Geschenk von Ihnen: das niemand sonst machen könnte.',
    conversationImportLuxPrivacy: 'Ihre Nachrichten bleiben vertraulich: nur die von Ihnen gewählte Unterhaltung wird verwendet.',
    conversationImportProgressExport: 'Exportieren',
    conversationImportProgressUpload: 'Hochladen',
    conversationImportProgressCustomize: 'Gestalten',
    conversationImportUploadSuccess: 'Archiv erhalten: wählen Sie Ihre Unterhaltung im nächsten Schritt',
    conversationImportUploadSuccessSingle: 'Datei erhalten: weiter zum Personalisieren Ihres Buches',
    conversationImportContinueSingle: 'Weiter',
    conversationImportSelectionTitleSingle: 'Ihre Unterhaltung',
    conversationImportSelectionHintSingle: 'Eine Unterhaltung in Ihrer Datei gefunden.',
    conversationImportSelectionHintMultiple: 'Wählen Sie die Unterhaltung für Ihr Buch: nutzen Sie die Suche zum Filtern.',
    conversationImportSelectionListCount: '{shown} von {total} Unterhaltungen',
    conversationImportSelectionNoMatch: 'Keine Unterhaltung entspricht Ihrer Suche.',
    conversationImportStepPickThread: 'Unterhaltung wählen',
    conversationImportStepMedia: 'Foto-Optionen',
    conversationImportStepTerms: 'AGB akzeptieren',
    conversationImportExtrasLockedHint: 'Wählen Sie oben eine Unterhaltung, um diese Optionen freizuschalten.',
    conversationImportPickThreadBeforeTerms: 'Sie müssen oben noch eine Unterhaltung auswählen, bevor Sie fortfahren können.',
    conversationImportChangeThread: 'Unterhaltung ändern',
    conversationImportSelectionConfirmedHint: 'Perfekt: Sie können Ihr Buch unten jetzt anpassen.',

    conversationImportOptionsTitle: 'Fotos & Erinnerungen',
    conversationImportOptionsHint: 'Alles ist standardmäßig aktiviert: deaktiviere nur, was Sie nicht möchten.',
    conversationImportOptionsImagesLabel: 'Fotos & Bilder',
    conversationImportOptionsImagesDesc: 'Fotos aus Ihrer Unterhaltung werden im Buch gedruckt.',
    conversationImportOptionsMediasLabel: 'Videos, Audio & GIFs',
    conversationImportOptionsMediasDesc: 'Zugänglich über im Buch gedruckte QR-Codes (10 Jahre Speicherung inklusive).',
    conversationImportOptionsTransferNote: 'Der Transfer kann je nach Anzahl der Fotos einige Minuten dauern: bleiben Sie auf dieser Seite.',
    conversationImportOptionsNoMedia: 'Ihre Datei enthält keine Fotos oder Medien: Ihr Buch enthält nur die Nachrichten.',
    conversationImportAgreementRead: 'Allgemeine Geschäftsbedingungen lesen',
    conversationImportCreateBook: 'Mein Buch erstellen',
    conversationImportSelectToContinue: 'Wählen Sie eine Unterhaltung aus, um fortzufahren.',
    conversationImportAcceptTermsToContinue: 'Aktivieren Sie das Kontrollkästchen der AGB, um fortzufahren.',
    conversationImportTransferEyebrow: 'Fast fertig',
    conversationImportTransferTitle: 'Wir bereiten Ihr Buch vor',
    conversationImportTransferSubtitle: 'Einen Moment Geduld: Ihre Geschichte nimmt Form an.',
    conversationImportTransferStay: 'Bleiben Sie auf dieser Seite, bis der Transfer abgeschlossen ist.',
    conversationImportStepMedias: 'Videos & Audio werden übertragen',
    conversationImportTransferStatMessages: 'Nachrichten',
    conversationImportTransferStatPhotos: 'Fotos',
    conversationImportTransferStatMedias: 'Videos & Audio',
    conversationImportTransferEyebrow: 'Fast geschafft',
    conversationImportTransferTitle: 'Wir bereiten Ihr Buch vor',
    conversationImportTransferSubtitle: 'Einen Moment Geduld: Ihre Geschichte nimmt Form an.',
    conversationImportTransferStay: 'Bleiben Sie auf dieser Seite, bis der Transfer abgeschlossen ist.',
    conversationImportResumeTitle: 'Eine vorherige Übertragung wurde unterbrochen.',
    conversationImportResumeTextFile: 'Wählen Sie dieselbe Datei ({name}) erneut aus, um dort fortzufahren, wo sie gestoppt wurde.',
    conversationImportResumeText: 'Wählen Sie dieselbe Datei erneut aus, um dort fortzufahren, wo sie gestoppt wurde.',
    conversationImportResumeButton: 'Übertragung fortsetzen',
    conversationImportResumeDiscard: 'Neu beginnen',
    conversationImportDuplicateTitle: 'Diese Unterhaltung ist bereits auf Ihrem Konto',
    conversationImportDuplicateEyebrow: 'Identische Unterhaltung',
    conversationImportDuplicateLead: 'Wir haben eine identische Unterhaltung gefunden. Sie können die vorhandene öffnen, um einen doppelten Transfer zu vermeiden.',
    conversationImportDuplicateQuestion: 'Was möchten Sie tun?',
    conversationImportDuplicateUseExisting: 'Vorhandene Unterhaltung verwenden',
    conversationImportDuplicateImportAnyway: 'Erneut importieren',
    conversationImportDropHint: 'Legen Sie Ihre .zip-Datei hier ab, oder',
    conversationImportDropFormats: 'Vollständiges .zip empfohlen: nicht öffnen (Fotos & Medien enthalten)',
    conversationImportJsonOnlyHint: 'Nur JSON-Datei: Fotos und Medien werden nicht einbezogen. Für ein illustriertes Buch laden Sie das komplette .zip ohne es zu öffnen hoch. Falls Ihr Browser das Archiv bereits entpackt hat, komprimieren Sie den Ordner « messages » als .zip.',

    conversationInstagramImportIntro: '3 Schritte, um Ihre Instagram-Nachrichten zu exportieren:',
    conversationInstagramImportDemoTitle: 'Instagram-Nachrichten exportieren',
    conversationInstagramImportDemoExportMeta: 'Auf Gerät exportieren · JSON',
    conversationInstagramImportDemoDownloadsAvailable: 'Verfügbare Downloads',
    conversationInstagramImportDemoStartExport: 'Export starten',
    conversationInstagramImportDemoCustomizeMessages: 'Nur Nachrichten',
    conversationInstagramImportDemoCustomize: 'Informationen anpassen',
    conversationInstagramImportDemoConfirmTitle: 'Export bestätigen',
    conversationInstagramImportDemoSave: 'Speichern',
    conversationInstagramImportDemoMessagesTip: 'Optional, aber schneller: alles löschen, dann nur Nachrichten.',
    conversationInstagramImportDemoDataPayments: 'Zahlungen',
    conversationInstagramImportDemoDataComments: 'Kommentare',
    conversationInstagramImportDemoClearAll: 'Alles löschen',
    conversationInstagramImportDemoActivitySection: 'Ihre Instagram-Aktivität',
    conversationInstagramImportDemoPickSpecific: 'Bestimmte Informationen zum Export wählen',
    conversationInstagramImportDemoExportExternal: 'Auf externen Dienst exportieren',
    conversationInstagramImportDemoExportDevice: 'Auf Gerät exportieren',
    conversationInstagramImportDemoChooseDestination: 'Exportziel wählen',
    conversationInstagramImportDemoProfileAccount: 'Ihr Konto · Instagram',
    conversationInstagramImportDemoProfileName: 'Ihr Kontoname',
    conversationInstagramImportDemoAccountShort: 'Ihr Konto',
    conversationInstagramImportDemoProfiles: 'Profile',
    conversationInstagramImportDemoChooseProfile: 'Profil wählen',
    conversationInstagramImportDemoPastActivity: 'Vergangene Aktivität',
    conversationInstagramImportDemoCurrentActivity: 'Aktuelle Aktivität',
    conversationInstagramImportDemoCreateExport: 'Export erstellen',
    conversationInstagramImportDemoExportIntro: 'Erstelle eine Kopie Ihrer Informationen zum Herunterladen auf Ihr Gerät.',
    conversationInstagramImportDemoExportTitle: 'Ihre Informationen exportieren',
    conversationInstagramImportDemoCaptionStart: 'Tippen Sie auf Export starten',
    conversationInstagramImportDemoCaptionDevice: 'Tippen Sie auf Auf Gerät exportieren',
    conversationInstagramImportDemoCaptionProfile: 'Wählen Sie Ihr Instagram-Profil',
    conversationInstagramImportDemoCaptionCreate: 'Tippen Sie auf Export erstellen',
    conversationInstagramImportDemoCaptionMessages: 'Tipp: Alles löschen, dann nur Nachrichten (schneller)',
    conversationInstagramImportDemoCaptionJson: 'JSON-Format wählen, dann Speichern',
    conversationInstagramImportDemoCaptionDrop: 'Laden Sie die .zip herunter und legen Sie sie unten ab',
    conversationInstagramImportDemoPlatform: 'Instagram',
    conversationInstagramImportDemoDataMessages: 'Nachrichten',
    conversationInstagramImportDemoFormat: 'Format',
    conversationInstagramImportDemoMediaQuality: 'Medienqualität',
    conversationInstagramImportDemoQualityLow: 'Niedrig',
    conversationInstagramImportDemoJsonNotice: 'JSON ist für Ihr Buch erforderlich. HTML funktioniert nicht.',
    conversationInstagramImportDemoReadyHint: 'Legen Sie die vollständige .zip unten ungeöffnet ab. Die Unterhaltung wählen Sie danach.',
    conversationInstagramImportCta: 'Instagram-Einstellungen öffnen',
    conversationInstagramImportStep1: 'Tippen Sie auf <b>Export erstellen</b>, wählen Sie Ihr <b>Instagram</b>-Profil, dann <b>Auf Gerät exportieren</b>.',
    conversationInstagramImportStep2: 'Tipp für schnelleren Export: <b>Alles löschen</b>, nur <b>Nachrichten</b> ankreuzen. Format <b>JSON</b> und <b>Niedrige</b> Medienqualität wählen.',
    conversationInstagramImportStep3: 'Tippen Sie auf <b>Export starten</b>, warten Sie auf die E-Mail (10 Min. bis 24 Std.), laden Sie die <b>.zip</b> herunter und legen Sie sie unten <b>ungeöffnet</b> ab: die Unterhaltung wählen Sie <b>danach</b>.',
    conversationInstagramImportAlert: 'Format <b>JSON</b> erforderlich (nicht HTML). Tipp: nur <b>Nachrichten</b> exportieren geht schneller, ist aber nicht Pflicht.',
    conversationInstagramImportDetailTitle: 'Instagram-Export: detaillierte Anleitung',
    conversationInstagramImportDetailIntro: 'Folgen Sie jedem Schritt anhand der Screenshots unten. Der Button oben öffnet direkt die Exportseite.',
    conversationInstagramImportDetailSkipApp: 'Ich habe die Seite über den Button geöffnet: weiter bei Schritt 5',
    conversationInstagramImportDetailStep1: 'Öffnen Sie die <b>Instagram</b>-App und gehen Sie über die drei Punkte oben rechts zu den <b>Einstellungen</b>.',
    conversationInstagramImportDetailStep2: 'Wählen Sie <b>Konten-Center</b>.',
    conversationInstagramImportDetailStep3: 'Tippen Sie auf <b>Ihre Informationen und Berechtigungen</b>.',
    conversationInstagramImportDetailStep4: 'Wählen Sie <b>Ihre Informationen exportieren</b>.',
    conversationInstagramImportDetailStep5: 'Gehen Sie zu <b>Informationen herunterladen oder übertragen</b>. Wenn Sie den Button oben genutzt haben, sind Sie bereits auf dieser Seite.',
    conversationInstagramImportDetailStep6: 'Wählen Sie <b>Instagram</b>. Dieser Schritt erscheint bei manchen Konten nicht.',
    conversationInstagramImportDetailStep7: 'Wählen Sie <b>Einige Ihrer Informationen</b>.',
    conversationInstagramImportDetailStep8: 'Scrollen Sie zu <b>Nachrichten</b>, aktivieren Sie es und tippen Sie auf <b>Weiter</b>.',
    conversationInstagramImportDetailStep9: 'Tippen Sie auf <b>Auf Gerät herunterladen</b>.',
    conversationInstagramImportDetailStep10: 'Wählen Sie den gewünschten Zeitraum, das Format <b>JSON</b> und eine <b>niedrige</b> Medienqualität für einen schnelleren Download.',
    conversationInstagramImportDetailStep11: 'Ihr Archiv ist in <b>10 Minuten bis 24 Stunden</b> bereit. Sie erhalten eine E-Mail, sobald es verfügbar ist: Sie finden es auch im Konten-Center.',
    conversationInstagramImportDetailStep12: 'Laden Sie die vollständige <b>.zip</b>-Datei auf Ihr Gerät herunter und legen Sie sie unten ab <b>ohne sie zu öffnen</b>. Nur die Unterhaltung, die Sie danach auswählen, wird für Ihr Buch verwendet.',

    conversationKakaotalkImportIntro: 'Alles beginnt auf Ihrem Handy. Geben Sie an, ob Sie iPhone oder Android nutzen:',
    conversationKakaotalkImportPlatformIphone: 'iPhone',
    conversationKakaotalkImportPlatformAndroid: 'Android',
    conversationKakaotalkImportIphoneStep1: 'Öffnen Sie auf Ihrem iPhone <b>KakaoTalk</b> und die Unterhaltung, die in Ihr Buch soll.',
    conversationKakaotalkImportIphoneStep2: 'Tippen Sie oben rechts auf das <b>Menü</b> (☰) und dann unten im Bereich auf das <b>Einstellungen</b>-Symbol.',
    conversationKakaotalkImportIphoneStep3: 'Tippen Sie auf <b>Chatverlauf exportieren</b> und wählen Sie <b>Nur Textnachrichten senden</b>.',
    conversationKakaotalkImportIphoneStep4: 'Speichern Sie die <b>.txt</b>-Datei (Dateien, E-Mail, AirDrop) und legen Sie sie unten ab <b>ohne sie zu bearbeiten</b>.',
    conversationKakaotalkImportAndroidStep1: 'Öffnen Sie auf Ihrem Handy <b>KakaoTalk</b> und die Unterhaltung, die in Ihr Buch soll.',
    conversationKakaotalkImportAndroidStep2: 'Tippen Sie oben rechts auf das <b>Menü</b> (☰) und dann unten im Bereich auf das <b>Einstellungen</b>-Symbol.',
    conversationKakaotalkImportAndroidStep3: 'Tippen Sie auf <b>Chatverlauf exportieren</b> und wählen Sie <b>Nur Text senden</b>.',
    conversationKakaotalkImportAndroidStep4: 'Speichern Sie die <b>.txt</b>-Datei (Dateien, Google Drive, E-Mail) und legen Sie sie unten ab <b>ohne sie zu bearbeiten</b>.',
    conversationKakaotalkImportAlert: 'Eine Unterhaltung pro Export. Die andere Option speichert auch Ihre Fotos, aber KakaoTalk verknüpft sie nicht mit den Nachrichten: wählen Sie nur Text, Fotos erscheinen als einfaches Wort.',
    conversationKakaotalkImportDesktopNote: 'Am Computer (Windows oder Mac): öffnen Sie das Menü der Unterhaltung und dann <b>Chat speichern</b>. Die entstandene <b>.txt</b>-Datei funktioniert hier ebenfalls.',
    conversationLineImportIntro: 'Alles beginnt auf Ihrem Handy. Geben Sie an, ob Sie iPhone oder Android nutzen:',
    conversationLineImportPlatformIphone: 'iPhone',
    conversationLineImportPlatformAndroid: 'Android',
    conversationLineImportIphoneStep1: 'Öffnen Sie auf Ihrem iPhone <b>LINE</b> und die Unterhaltung, die in Ihr Buch soll.',
    conversationLineImportIphoneStep2: 'Oben im Chat tippen Sie auf das <b>Menü</b> (☰) → <b>Einstellungen</b>.',
    conversationLineImportIphoneStep3: 'Tippen Sie auf <b>Chatverlauf exportieren</b> und wählen Sie, wie die Datei gesendet wird (Dateien, E-Mail, AirDrop).',
    conversationLineImportIphoneStep4: 'Speichern Sie die <b>.txt</b>-Datei und legen Sie sie unten ab <b>ohne sie zu bearbeiten</b>.',
    conversationLineImportAndroidStep1: 'Öffnen Sie auf Ihrem Handy <b>LINE</b> und die Unterhaltung, die in Ihr Buch soll.',
    conversationLineImportAndroidStep2: 'Oben im Chat tippen Sie auf das <b>Menü</b> (☰) → <b>Einstellungen</b>.',
    conversationLineImportAndroidStep3: 'Tippen Sie auf <b>Chatverlauf exportieren</b> und wählen Sie, wie die Datei gesendet wird (Dateien, Google Drive, E-Mail).',
    conversationLineImportAndroidStep4: 'Speichern Sie die <b>.txt</b>-Datei und legen Sie sie unten ab <b>ohne sie zu bearbeiten</b>.',
    conversationLineImportAlert: 'Eine Unterhaltung pro Export. Es werden nur die aktuell sichtbaren Nachrichten gespeichert, und LINE exportiert weder Fotos noch Sticker als Bilder.',
    conversationLineImportDesktopNote: 'Am Computer (Windows oder Mac): öffnen Sie <b>Chats</b>, doppelklicken Sie auf die Unterhaltung und nutzen Sie oben das <b>Menü</b> → <b>Chat speichern</b>. Diesen Export gibt es nicht bei LINE für Chrome.',

    conversationLinkedinImportIntro: '3 Schritte, um Ihre LinkedIn-Unterhaltungen zu exportieren:',
    conversationLinkedinImportCta: 'LinkedIn-Exportseite öffnen',
    conversationLinkedinImportStep1: 'Öffnen Sie die Seite oben in einem <b>Webbrowser</b> (Computer oder Handy). Sonst: <b>Ich</b> → <b>Einstellungen und Datenschutz</b> → <b>Datenschutz</b> → <b>Kopie Ihrer Daten erhalten</b>.',
    conversationLinkedinImportStep2: 'Fordern Sie ein Archiv mit Ihren <b>Nachrichten</b> an: aktivieren Sie die Datei <b>Nachrichten</b> oder wählen Sie das vollständige Archiv, dann klicken Sie auf <b>Archiv anfordern</b>.',
    conversationLinkedinImportStep3: 'Laden Sie das <b>.zip</b> aus der LinkedIn-E-Mail herunter (10 Min. bis 24 Std.) und legen Sie es unten ab <b>ohne es zu öffnen</b>: die Unterhaltung wählen Sie <b>danach</b> aus.',
    conversationLinkedinImportAlert: 'Diesen Export gibt es in der LinkedIn-App nicht: nutzen Sie einen Browser. Das Archiv muss die Datei <b>messages.csv</b> enthalten (LinkedIn exportiert weder Fotos noch Anhänge).',

    conversationSnapchatImportIntro: '3 Schritte, um Ihre Snapchat-Unterhaltungen zu exportieren:',
    conversationSnapchatImportCta: 'Snapchat Meine Daten öffnen',
    conversationSnapchatImportStep1: 'In der App: Avatar → Einstellungen (Zahnrad) → <b>Datenschutz</b> → <b>Meine Daten</b>. Sie können auch den Link oben nutzen.',
    conversationSnapchatImportStep2: 'Melden Sie sich ggf. an, tippen Sie dann unten auf <b>Anfrage senden</b>: Snapchat schickt Ihnen eine E-Mail, wenn das Archiv fertig ist (einige Stunden bis 1 Tag).',
    conversationSnapchatImportStep3: 'Laden Sie das <b>.zip</b> aus der E-Mail herunter und legen Sie es unten ab <b>ohne es zu öffnen</b>: die Unterhaltung wählen Sie <b>danach</b> aus.',
    conversationSnapchatImportAlert: 'Vollständiges <b>.zip</b>-Archiv erforderlich: nicht öffnen. Ihre Nachrichten werden im Buch gedruckt (Snapchat-Exporte enthalten keine druckbaren Fotos).',
    conversationSnapchatPlaceholderMedia: '[Medien]',
    conversationSnapchatPlaceholderNote: '[Sprachnotiz]',
    conversationSnapchatPlaceholderSticker: '[Sticker]',
    conversationSnapchatPlaceholderSnap: '[Snap]',
    conversationSnapchatPlaceholderAudio: '[Audio]',
    conversationSnapchatStatusParticipantAdded: 'Ein Mitglied wurde zur Gruppe hinzugefügt',
    conversationSnapchatStatusNameChanged: 'Der Gruppenname hat sich geändert',
    conversationSnapchatStatusConversationCreated: 'Unterhaltung erstellt',
    conversationSnapchatStatusGeneric: 'Snapchat-Benachrichtigung',
    conversationSnapchatImportPartialContent: '{withText} Nachrichten mit Text von {total}. Snapchat exportiert den Inhalt nicht gespeicherter Nachrichten nicht.',
    conversationSnapchatImportDetailTitle: 'Snapchat-Export: detaillierte Anleitung',
    conversationSnapchatImportDetailIntro: 'Folgen Sie jedem Schritt anhand der Screenshots unten. Sie können auch den Button oben nutzen, um Meine Daten direkt zu öffnen und bei Schritt 4 zu beginnen.',
    conversationSnapchatImportDetailSkipApp: 'Ich habe die Seite über den Button geöffnet: weiter bei Schritt 4',
    conversationSnapchatImportDetailStep1: 'Öffnen Sie <b>Snapchat</b> und tippen Sie auf Ihr Profilbild.',
    conversationSnapchatImportDetailStep2: 'Tippen Sie auf das <b>Zahnrad</b>, um die Einstellungen zu öffnen.',
    conversationSnapchatImportDetailStep3: 'Scrollen Sie zu <b>Kontoaktionen</b> und tippen Sie auf <b>Meine Daten</b>. Sie können auch den Button oben nutzen.',
    conversationSnapchatImportDetailStep4: 'Aktivieren Sie <b>Chatverlauf</b>, wählen Sie die Formate <b>JSON</b> und <b>HTML</b>, dann tippen Sie auf <b>Weiter</b>.',
    conversationSnapchatImportDetailStep5: 'Wählen Sie den gewünschten Zeitraum, bestätigen Sie Ihre E-Mail-Adresse und tippen Sie auf <b>Senden</b>.',
    conversationSnapchatImportDetailStep6: 'Snapchat sendet Ihnen eine E-Mail, sobald der Export fertig ist: das kann einige Stunden bis zu einigen Tagen dauern.',
    conversationSnapchatImportDetailStep7: 'Wenn Sie die E-Mail erhalten, klicken Sie auf den Link, um auf Ihre Daten zuzugreifen.',
    conversationSnapchatImportDetailStep8: 'Tippen Sie in Snapchat auf <b>Export anzeigen</b>, dann auf <b>Herunterladen</b>.',
    conversationSnapchatImportDetailStep9: 'Laden Sie die vollständige <b>.zip</b>-Datei auf Ihr Gerät herunter und legen Sie sie unten ab <b>ohne sie zu öffnen</b>. Nur der Chat, den Sie danach auswählen, wird für Ihr Buch verwendet.',

    conversationTelegramImportIntro: '4 Schritte, um eine Telegram-Unterhaltung zu exportieren:',
    conversationTelegramImportCta: 'Telegram Desktop herunterladen',
    conversationTelegramImportStep1: 'Auf dem PC installieren Sie <b>Telegram Desktop</b>. Auf dem Mac nicht die App-Store-App « Telegram » verwenden: <b>Telegram Desktop</b> über den Link oben laden (im App Store heißt sie Telegram Lite). Öffnen Sie danach die Unterhaltung, die Sie zum Buch machen möchten.',
    conversationTelegramImportStep2: 'Klicken Sie auf die <b>drei Punkte</b> oben rechts → <b>Chatverlauf exportieren</b>.',
    conversationTelegramImportStep3: 'Aktivieren Sie <b>Fotos, Videos und Dateien</b>, wählen Sie das Format <b>JSON</b> (HTML geht auch), klicken Sie auf <b>Exportieren</b> und warten Sie, bis der Download fertig ist.',
    conversationTelegramImportStep4: 'Komprimieren Sie den exportierten Ordner als <b>.zip</b> (Rechtsklick → komprimieren), legen Sie ihn unten ab <b>ohne ihn zu öffnen</b>: die Optionen bestätigen Sie <b>danach</b>.',
    conversationTelegramImportAlert: 'Eine Unterhaltung auf einmal. Schließen Sie <b>Medien</b> beim Export ein für ein illustriertes Buch: laden Sie das vollständige <b>.zip</b> unverändert hoch.',
    conversationTelegramImportDetailTitle: 'Telegram-Export: detaillierte Anleitung',
    conversationTelegramImportDetailIntro: 'Folgen Sie jedem Schritt anhand der Screenshots unten. Nutzen Sie den Button oben, um Telegram Desktop herunterzuladen, oder beginnen Sie bei Schritt 2, wenn es bereits installiert ist.',
    conversationTelegramImportDetailSkipApp: 'Telegram Desktop ist schon installiert: weiter bei Schritt 2',
    conversationTelegramImportDetailStep1: 'Auf dem PC ist <b>Telegram Desktop</b> die richtige App. Auf dem Mac laden Sie <b>Telegram Desktop</b> über den Link oben: die App-Store-App « Telegram » kann keinen Chat exportieren. Im App Store heißt das richtige Programm <b>Telegram Lite</b>.',
    conversationTelegramImportDetailStep2: 'Öffnen Sie die <b>Unterhaltung</b>, die Sie in ein Buch verwandeln möchten.',
    conversationTelegramImportDetailStep3: 'Klicken Sie auf die <b>drei Punkte</b> oben rechts, dann auf <b>Chatverlauf exportieren</b>.',
    conversationTelegramImportDetailStep4: 'Aktivieren Sie <b>alle Dateitypen</b> (Fotos, Videos, Sprachnachrichten usw.), setzen Sie die maximale Dateigröße auf <b>1500 MB</b> und wählen Sie das Format <b>JSON</b>. Wenn keine Formatauswahl erscheint, funktioniert auch ein HTML-Export.',
    conversationTelegramImportDetailStep5: 'Klicken Sie unten rechts auf <b>Exportieren</b>, um den Export zu starten.',
    conversationTelegramImportDetailStep6: 'Tippen Sie auf Ihrem Telefon auf <b>Erlauben</b>, falls gefragt. Komprimieren Sie den exportierten Ordner als <b>.zip</b> und legen Sie ihn unten ab <b>ohne ihn zu öffnen</b>: die Optionen bestätigen Sie danach.',

    conversationImportDetectedPlatform: 'Diese Schritte gelten für {platform}. Die anderen Möglichkeiten bleiben verfügbar.',
    conversationWhatsappImportIntro: 'Alles beginnt auf dem Handy. Geben Sie an, ob Sie iPhone oder Android nutzen:',
    conversationWhatsappImportPlatformIphone: 'iPhone',
    conversationWhatsappImportPlatformAndroid: 'Android',
    conversationWhatsappImportIphoneStep1: 'Öffnen Sie den Chat, tippen Sie oben auf den <b>Namen</b>, dann auf <b>Chat exportieren</b>.',
    conversationWhatsappImportIphoneStep2: 'Wählen Sie <b>Medien anhängen</b> für Fotos im Buch (oder <b>Ohne Medien</b> nur für Text).',
    conversationWhatsappImportIphoneStep3: 'Speichern Sie in <b>Dateien</b> und legen Sie die <b>.zip</b> unten ab <b>ohne sie zu öffnen</b>.',
    conversationWhatsappImportIphoneStep4: '<b>Mit Medien</b> für Fotos im Buch, <b>ohne Medien</b> nur Nachrichten: Datei auf Computer oder Handy speichern und unten ablegen <b>ohne zu öffnen</b>.',
    conversationWhatsappImportAndroidStep1: 'Öffnen Sie den Chat, tippen Sie auf <b>⋮</b> → <b>Mehr</b> → <b>Chat exportieren</b>.',
    conversationWhatsappImportAndroidStep2: 'Wählen Sie <b>Medien einschließen</b> für Fotos im Buch (oder <b>Ohne Medien</b> nur Text).',
    conversationWhatsappImportAndroidStep3: 'Speichern oder teilen Sie die Datei und legen Sie die <b>.zip</b> unten <b>ungeöffnet</b> ab.',
    conversationWhatsappImportAndroidStep4: 'Speichern Sie die Datei (Dateien, Google Drive oder E-Mail), übertragen Sie sie auf Computer oder Handy und legen Sie sie unten <b>ungeöffnet</b> ab.',
    conversationWhatsappImportAlert: 'Ein Chat pro Export. Bevorzuge <b>Medien anhängen</b> für ein illustriertes Buch. Bleiben Sie auf dieser Seite bis der Transfer fertig ist.',
    conversationWhatsappImportAlertAndroid: 'Ein Chat pro Export. Bevorzuge <b>Medien einschließen</b>. Auf manchen Handys geht nur E-Mail: wählen Sie dann <b>Ohne Medien</b>. Bleiben Sie auf dieser Seite bis zum Ende.',
    conversationWhatsappImportIphoneDetailTitle: 'WhatsApp-Export auf iPhone: detaillierte Anleitung',
    conversationWhatsappImportIphoneDetailIntro: 'Folgen Sie jedem Schritt auf Ihrem iPhone anhand der Screenshots unten, übertragen Sie die Datei dann auf Computer oder Handy, bevor Sie sie hier ablegen.',
    conversationWhatsappImportIphoneDetailStep1: 'Öffnen Sie <b>WhatsApp</b> und den Chat, den Sie in ein Buch verwandeln möchten.',
    conversationWhatsappImportIphoneDetailStep2: 'Tippen Sie oben auf den <b>Namen des Kontakts</b> oder der Gruppe.',
    conversationWhatsappImportIphoneDetailStep3: 'Scrollen Sie ganz nach unten, bis Sie <b>Chat exportieren</b> sehen.',
    conversationWhatsappImportIphoneDetailStep4: 'Tippen Sie auf <b>Chat exportieren</b>.',
    conversationWhatsappImportIphoneDetailStep5: 'Wählen Sie <b>Mit Medien</b> für ein illustriertes Buch oder <b>Ohne Medien</b> nur für Nachrichten.',
    conversationWhatsappImportIphoneDetailStep6: 'Speichern Sie die Datei auf Computer oder Handy (z. B. in Dateien), dann legen Sie sie unten ab <b>ohne sie zu öffnen</b>.',
    conversationWhatsappImportAndroidDetailTitle: 'WhatsApp-Export auf Android: detaillierte Anleitung',
    conversationWhatsappImportAndroidDetailIntro: 'Folgen Sie jedem Schritt auf Ihrem Android anhand der Screenshots unten, übertragen Sie die Datei dann auf Computer oder Handy, bevor Sie sie hier ablegen.',
    conversationWhatsappImportAndroidDetailStep1: 'Öffnen Sie <b>WhatsApp</b> und den Chat, den Sie als Buch haben möchten.',
    conversationWhatsappImportAndroidDetailStep2: 'Tippen Sie auf <b>⋮</b> (oben rechts) → <b>Mehr</b> → <b>Chat exportieren</b>.',
    conversationWhatsappImportAndroidDetailStep3: 'Wählen Sie <b>Medien einschließen</b> für Fotos, oder <b>Ohne Medien</b> nur für Nachrichten.',
    conversationWhatsappImportAndroidDetailStep4: 'Speichern Sie die Datei (Dateien, Google Drive oder E-Mail), übertragen Sie sie auf Computer oder Handy und legen Sie sie unten <b>ungeöffnet</b> ab.',
    conversationWhatsappImportDemoTitle: 'WhatsApp-Chat exportieren',
    conversationWhatsappImportDemoIndividual: 'Einzelchat',
    conversationWhatsappImportDemoGroup: 'Gruppenchat',
    conversationWhatsappImportDemoCaptionOpen: 'Öffnen Sie den Chat in WhatsApp',
    conversationWhatsappImportDemoCaptionTapName: 'Tippen Sie oben auf den Namen',
    conversationWhatsappImportDemoCaptionExport: 'Scrollen Sie nach unten und tippen Sie auf Chat exportieren',
    conversationWhatsappImportDemoCaptionMedia: 'Wählen Sie Medien anhängen für Fotos im Buch',
    conversationWhatsappImportDemoCaptionSave: 'Speichern Sie in Dateien und laden Sie sie unten hoch',
    conversationWhatsappImportDemoExportLabel: 'Chat exportieren',
    conversationWhatsappImportDemoMediaNotice: 'Attach Media creates a larger archive, ideal for an illustrated book.',
    conversationWhatsappImportDemoAttachMedia: 'Medien anhängen',
    conversationWhatsappImportDemoWithoutMedia: 'Ohne Medien',
    conversationWhatsappImportDemoSaveFiles: 'In Dateien speichern',
    conversationWhatsappImportDemoA11y: 'Animierte Anleitung: Chat öffnen, Namen tippen, exportieren, Medien anhängen, in Dateien speichern.',
    conversationWhatsappImportDemoCaptionExportGroup: 'Öffnen Sie das ⋯-Menü und tippen Sie auf Chat exportieren',
    conversationWhatsappImportDemoContactName: 'Léa',
    conversationWhatsappImportDemoContactMom: 'Mama',
    conversationWhatsappImportDemoGroupName: 'Wochenende',
    conversationWhatsappImportDemoGroupWork: 'Work: design',
    conversationWhatsappImportDemoChats: 'Chats',
    conversationWhatsappImportDemoHeaderSubContact: 'tap here for contact info',
    conversationWhatsappImportDemoHeaderSubGroup: 'tap here for group info',
    conversationWhatsappImportDemoGroupsInCommon: 'Groups in common',
    conversationWhatsappImportDemoSeeAll: 'See all ›',
    conversationWhatsappImportDemoAddFavorite: 'Add to Favorites',
    conversationWhatsappImportDemoAddList: 'Add to a list',
    conversationWhatsappImportDemoClearChat: 'Chat leeren',
    conversationWhatsappImportDemoBlock: 'Block',
    conversationWhatsappImportDemoParticipants: '{count} participants',
    conversationWhatsappImportDemoAudio: 'Audio',
    conversationWhatsappImportDemoVideo: 'Video',
    conversationWhatsappImportDemoAdd: 'Add',
    conversationWhatsappImportDemoSearch: 'Search',
    conversationWhatsappImportDemoMemberYou: 'You',
    conversationWhatsappImportDemoMemberAlex: 'Alex',
    conversationWhatsappImportDemoMemberCamille: 'Camille',
    conversationWhatsappImportDemoEditGroup: 'Edit group info',
    conversationWhatsappImportDemoEditDescription: 'Edit description',
    conversationWhatsappImportAndroidDemoIncludeMedia: 'Medien einschließen',
    conversationWhatsappImportAndroidDemoWithoutMedia: 'Ohne Medien',
    conversationWhatsappImportAndroidDemoMediaNotice: 'Medien einschließen für ein illustriertes Buch. Ohne Medien ist leichter.',
    conversationWhatsappImportAndroidDemoClear: 'Chat leeren',
    conversationWhatsappImportAndroidDemoExport: 'Chat exportieren',
    conversationWhatsappImportAndroidDemoReport: 'Melden',
    conversationWhatsappImportAndroidDemoMore: 'Mehr',
    conversationWhatsappImportAndroidDemoWallpaper: 'Hintergrund',
    conversationWhatsappImportAndroidDemoMute: 'Mitteilungen stummschalten',
    conversationWhatsappImportAndroidDemoOnline: 'online',
    conversationWhatsappImportAndroidDemoCaptionSave: 'Speichern oder teilen Sie die Datei und legen Sie sie unten ab.',
    conversationWhatsappImportAndroidDemoCaptionMedia: 'Wählen Sie Medien einschließen für Fotos im Buch',
    conversationWhatsappImportAndroidDemoCaptionExport: 'Tippen Sie auf Mehr, dann Chat exportieren',
    conversationWhatsappImportAndroidDemoCaptionMenu: 'Tippen Sie oben rechts auf das Menü',
    conversationWhatsappImportAndroidDemoCaptionOpen: 'Öffnen Sie den Chat in WhatsApp',
    conversationWhatsappImportAndroidDemoTitle: 'WhatsApp-Chat auf Android exportieren',
    conversationWhatsappImportAndroidDemoShareHint: 'Legen Sie die .zip danach unten ungeöffnet ab.',
    conversationWhatsappImportAndroidDemoFiles: 'Dateien',
    conversationWhatsappImportAndroidDemoShareVia: 'Senden an…',

    conversationMessengerImportIntro: 'Beginnen Sie mit <b>Nach 2023</b>: verschlüsselte Chats, auf Messenger.com. Wechseln Sie zu <b>Vor 2023</b>, wenn Ihrer dort fehlt.',
    conversationMessengerImportContext: 'Ein Chat, der vor 2023 begann, kann nach dem Einschalten der Verschlüsselung weitergehen. Messenger teilt ihn dann in zwei Archive. Importieren Sie beide und führen Sie sie in Ihrer Unterhaltungsliste zusammen.',
    conversationMessengerImportPlatformClassic: 'Vor 2023',
    conversationMessengerImportPlatformEncrypted: 'Nach 2023',
    conversationMessengerImportClassicCta: 'Meta zum Exportieren öffnen',
    conversationMessengerClassicImportDemoReadyHint: 'Legen Sie die vollständige .zip unten ungeöffnet ab. Die Unterhaltung wählen Sie danach.',
    conversationMessengerClassicImportDemoExportMeta: 'Auf Gerät exportieren · JSON',
    conversationMessengerClassicImportDemoDownloadsAvailable: 'Verfügbare Downloads',
    conversationMessengerClassicImportDemoStartExport: 'Export starten',
    conversationMessengerClassicImportDemoQualityLow: 'Niedrig',
    conversationMessengerClassicImportDemoMediaQuality: 'Medienqualität',
    conversationMessengerClassicImportDemoCustomizeMessages: 'Nur Nachrichten',
    conversationMessengerClassicImportDemoCustomize: 'Informationen anpassen',
    conversationMessengerClassicImportDemoConfirmTitle: 'Export bestätigen',
    conversationMessengerClassicImportDemoJsonNotice: 'JSON ist für Ihr Buch erforderlich. HTML funktioniert nicht.',
    conversationMessengerClassicImportDemoFormat: 'Format',
    conversationMessengerClassicImportDemoSave: 'Speichern',
    conversationMessengerClassicImportDemoMessagesTip: 'Optional, aber schneller: alles löschen, dann nur Nachrichten.',
    conversationMessengerClassicImportDemoDataMessages: 'Nachrichten',
    conversationMessengerClassicImportDemoDataPayments: 'Zahlungen',
    conversationMessengerClassicImportDemoDataComments: 'Kommentare',
    conversationMessengerClassicImportDemoClearAll: 'Alles löschen',
    conversationMessengerClassicImportDemoPickSpecific: 'Bestimmte Informationen zum Export wählen',
    conversationMessengerClassicImportDemoExportExternal: 'Auf externen Dienst exportieren',
    conversationMessengerClassicImportDemoExportDevice: 'Auf Gerät exportieren',
    conversationMessengerClassicImportDemoChooseDestination: 'Exportziel wählen',
    conversationMessengerClassicImportDemoAccountShort: 'Ihr Konto',
    conversationMessengerClassicImportDemoProfileName: 'Ihr Kontoname',
    conversationMessengerClassicImportDemoProfiles: 'Profile',
    conversationMessengerClassicImportDemoChooseProfile: 'Profil wählen',
    conversationMessengerClassicImportDemoPastActivity: 'Vergangene Aktivität',
    conversationMessengerClassicImportDemoCurrentActivity: 'Aktuelle Aktivität',
    conversationMessengerClassicImportDemoCreateExport: 'Export erstellen',
    conversationMessengerClassicImportDemoExportIntro: 'Erstelle eine Kopie Ihrer Informationen zum Herunterladen auf Ihr Gerät.',
    conversationMessengerClassicImportDemoExportTitle: 'Ihre Informationen exportieren',
    conversationMessengerClassicImportDemoCaptionDrop: 'Laden Sie die .zip herunter und legen Sie sie unten ab',
    conversationMessengerClassicImportDemoCaptionStart: 'Tippen Sie auf Export starten',
    conversationMessengerClassicImportDemoCaptionJson: 'JSON-Format wählen, dann Speichern',
    conversationMessengerClassicImportDemoCaptionMessages: 'Tipp: Alles löschen, dann nur Nachrichten (schneller)',
    conversationMessengerClassicImportDemoCaptionDevice: 'Tippen Sie auf Auf Gerät exportieren',
    conversationMessengerClassicImportDemoCaptionCreate: 'Tippen Sie auf Export erstellen',
    conversationMessengerClassicImportDemoActivitySection: 'Ihre Facebook-Aktivität',
    conversationMessengerClassicImportDemoProfileAccount: 'Ihr Konto · Facebook',
    conversationMessengerClassicImportDemoPlatform: 'Facebook',
    conversationMessengerClassicImportDemoCaptionProfile: 'Wählen Sie Ihr Facebook-Profil',
    conversationMessengerClassicImportDemoTitle: 'Messenger-Chats von vor 2023 exportieren',
    conversationMessengerEncryptedImportDemoTitle: 'Messenger-Chats von nach 2023 exportieren',
    conversationImportDemoBadgeMeta: 'Beispiel: auf Meta nachmachen, mit der Schaltfläche oben',
    conversationMessengerEncryptedImportDemoBadge: 'Beispiel: auf Messenger.com nachmachen, mit der Schaltfläche oben',
    conversationMessengerEncryptedImportDemoCaptionLogin: 'Öffnen Sie Messenger.com am Computer und melden Sie sich an',
    conversationMessengerEncryptedImportDemoCaptionSettings: 'Klicken Sie unten links auf das Zahnrad',
    conversationMessengerEncryptedImportDemoCaptionPrivacy: 'Öffnen Sie Privatsphäre und Sicherheit',
    conversationMessengerEncryptedImportDemoCaptionEncrypted: 'Wählen Sie Ende-zu-Ende-verschlüsselte Chats',
    conversationMessengerEncryptedImportDemoCaptionStorage: 'Öffnen Sie Nachrichtenspeicher',
    conversationMessengerEncryptedImportDemoCaptionDownloadData: 'Klicken Sie auf Daten des Nachrichtenspeichers herunterladen',
    conversationMessengerEncryptedImportDemoCaptionRange: 'Lassen Sie Media aktiviert und wählen Sie den Zeitraum All time',
    conversationMessengerEncryptedImportDemoCaptionDrop: 'Klicken Sie auf Datei herunterladen und legen Sie die .zip unten ab',
    conversationMessengerEncryptedImportDemoLandingTitle: 'Ein Ort für interessante Gespräche',
    conversationMessengerEncryptedImportDemoLandingText: 'Mit Messenger bleiben Sie mit den Menschen in Kontakt, die Ihnen wichtig sind.',
    conversationMessengerEncryptedImportDemoContinueAs: 'Weiter als Ihr Name',
    conversationMessengerEncryptedImportDemoSwitchAccount: 'Konto wechseln',
    conversationMessengerEncryptedImportDemoChats: 'Chats',
    conversationMessengerEncryptedImportDemoSearch: 'In Messenger suchen',
    conversationMessengerEncryptedImportDemoContactName: 'Ihr Kontakt',
    conversationMessengerEncryptedImportDemoContactStatus: 'Jetzt aktiv',
    conversationMessengerEncryptedImportDemoLockBadge: 'Ende-zu-Ende-verschlüsselt',
    conversationMessengerEncryptedImportDemoMenuPreferences: 'Einstellungen',
    conversationMessengerEncryptedImportDemoMenuProfileName: 'Profilnamen ändern',
    conversationMessengerEncryptedImportDemoMenuRestricted: 'Eingeschränkte Konten',
    conversationMessengerEncryptedImportDemoMenuAccessibility: 'Barrierefreiheit',
    conversationMessengerEncryptedImportDemoMenuHelp: 'Hilfe',
    conversationMessengerEncryptedImportDemoPrivacyTitle: 'Privatsphäre und Sicherheit',
    conversationMessengerEncryptedImportDemoPrivacyReceipts: 'Lesebestätigungen',
    conversationMessengerEncryptedImportDemoPrivacyReported: 'Gemeldete Chats',
    conversationMessengerEncryptedImportDemoPrivacyKeys: 'Schlüssel im Chat überprüfen',
    conversationMessengerEncryptedImportDemoEncryptedTitle: 'Ende-zu-Ende-verschlüsselte Chats',
    conversationMessengerEncryptedImportDemoEncryptedHint: 'Verwalten Sie die Einstellungen Ihrer Ende-zu-Ende-verschlüsselten Chats',
    conversationMessengerEncryptedImportDemoEncryptedAlerts: 'Sicherheitshinweise',
    conversationMessengerEncryptedImportDemoEncryptedPreviews: 'Vorschauen',
    conversationMessengerEncryptedImportDemoStorageTitle: 'Nachrichtenspeicher',
    conversationMessengerEncryptedImportDemoStorageHint: 'Verwalten Sie, wie Sie Ihren Chatverlauf speichern und darauf zugreifen',
    conversationMessengerEncryptedImportDemoStorageIntro: 'Ihre Ende-zu-Ende-verschlüsselten Nachrichten werden sicher in Ihrem Backup gespeichert.',
    conversationMessengerEncryptedImportDemoStoragePin: 'PIN-Code zurücksetzen',
    conversationMessengerEncryptedImportDemoStorageMethods: 'Sicherheitsmethoden verwalten',
    conversationMessengerEncryptedImportDemoStorageRemember: 'Diesen Browser merken',
    conversationMessengerEncryptedImportDemoStorageDownload: 'Daten des Nachrichtenspeichers herunterladen',
    conversationMessengerEncryptedImportDemoStorageDownloadHint: 'Laden Sie alle Ihre Ende-zu-Ende-verschlüsselten Nachrichten und Anhänge herunter.',
    conversationMessengerEncryptedImportDemoStorageAutoImport: 'Automatische Importe deaktivieren',
    conversationMessengerEncryptedImportDemoDownloadTitle: 'Ihre Daten herunterladen',
    conversationMessengerEncryptedImportDemoDownloadIntro: 'Sie können jederzeit eine Kopie aller Ihrer Ende-zu-Ende-verschlüsselten Nachrichten und Anhänge herunterladen.',
    conversationMessengerEncryptedImportDemoMediaTip: 'Lassen Sie Media aktiviert, sonst enthält Ihr Buch keine Fotos.',
    conversationMessengerEncryptedImportDemoFileNotice: 'Die Vorbereitung der Datei kann einige Minuten dauern.',
    conversationMessengerEncryptedImportDemoDownloadFile: 'Datei herunterladen',
    conversationMessengerEncryptedImportDemoReadyHint: 'Legen Sie die komplette .zip unten ab, ohne sie zu öffnen. Die Konversation wählen Sie danach aus.',
    conversationMessengerImportEncryptedCta: 'Messenger.com zum Exportieren öffnen',
    conversationMessengerImportClassicStep1: 'Tippen Sie auf <b>Export erstellen</b>, wählen Sie Ihr <b>Facebook</b>-Profil, dann <b>Auf Gerät exportieren</b>.',
    conversationMessengerImportClassicStep2: 'Tipp für schnelleren Export: <b>Alles löschen</b>, nur <b>Nachrichten</b> ankreuzen. Format <b>JSON</b> und <b>Niedrige</b> Medienqualität wählen.',
    conversationMessengerImportClassicStep3: 'Tippen Sie auf <b>Export starten</b>, warten Sie auf die E-Mail (10 Min. bis 24 Std.), laden Sie die <b>.zip</b> herunter und legen Sie sie unten <b>ungeöffnet</b> ab: die Unterhaltung wählen Sie <b>danach</b>.',
    conversationMessengerImportClassicAlert: 'Unterhaltung fehlt? Wechseln Sie zu <b>Nach 2023</b>. Format <b>JSON</b> erforderlich (nicht HTML). Tipp: nur <b>Nachrichten</b> exportieren geht schneller, ist aber nicht Pflicht.',
    conversationMessengerImportEncryptedStep1: 'Öffnen Sie <b>Messenger.com</b> am Computer, melden Sie sich an und klicken Sie unten links auf das <b>Zahnrad</b>.',
    conversationMessengerImportEncryptedStep2: 'Gehen Sie zu <b>Privatsphäre und Sicherheit</b>, dann <b>Ende-zu-Ende-verschlüsselte Chats</b>, dann <b>Nachrichtenspeicher</b>.',
    conversationMessengerImportEncryptedStep3: 'Klicken Sie auf <b>Daten des Nachrichtenspeichers herunterladen</b>. Lassen Sie <b>Media</b> aktiviert und wählen Sie den Zeitraum <b>All time</b>.',
    conversationMessengerImportEncryptedStep4: 'Klicken Sie auf <b>Datei herunterladen</b> und legen Sie die <b>.zip</b> unten ab, <b>ohne sie zu öffnen</b>: die Konversation wählen Sie <b>nach</b> dem Upload aus.',
    conversationMessengerImportEncryptedAlert: 'Lassen Sie <b>Media</b> aktiviert, sonst enthält Ihr Buch keine Fotos. Chat fehlt? Wechseln Sie zu <b>Vor 2023</b>.',
    conversationMessengerImportClassicDetailTitle: 'Export vor 2023: detaillierte Anleitung',
    conversationMessengerImportClassicDetailIntro: 'Folgen Sie jedem Schritt anhand der Screenshots unten. Der Button oben öffnet direkt die Exportseite.',
    conversationMessengerImportClassicDetailSkipApp: 'Ich habe die Seite über den Button geöffnet: weiter bei Schritt 5',
    conversationMessengerImportClassicDetailStep1: 'Öffnen Sie die <b>Messenger</b>-App und gehen Sie über die drei Punkte zu den <b>Einstellungen</b>.',
    conversationMessengerImportClassicDetailStep2: 'Tippen Sie auf das <b>Zahnrad</b>.',
    conversationMessengerImportClassicDetailStep3: 'Wählen Sie <b>Konten-Center</b>.',
    conversationMessengerImportClassicDetailStep4: 'Tippen Sie auf <b>Ihre Informationen und Berechtigungen</b>.',
    conversationMessengerImportClassicDetailStep5: 'Wählen Sie <b>Ihre Informationen herunterladen</b>.',
    conversationMessengerImportClassicDetailStep6: 'Gehen Sie zu <b>Informationen herunterladen oder übertragen</b>. Wenn Sie den Button oben genutzt haben, sind Sie bereits auf dieser Seite.',
    conversationMessengerImportClassicDetailStep7: 'Wählen Sie <b>Facebook</b>. Dieser Schritt erscheint bei manchen Konten nicht.',
    conversationMessengerImportClassicDetailStep8: 'Wählen Sie <b>Einige Ihrer Informationen</b>.',
    conversationMessengerImportClassicDetailStep9: 'Aktivieren Sie nur <b>Nachrichten</b>, dann tippen Sie auf <b>Weiter</b>.',
    conversationMessengerImportClassicDetailStep10: 'Tippen Sie auf <b>Auf Gerät herunterladen</b>.',
    conversationMessengerImportClassicDetailStep11: 'Wählen Sie den gewünschten Zeitraum, das Format <b>JSON</b> und eine <b>niedrige</b> Qualität. Ihr Archiv ist in <b>10 Minuten bis 24 Stunden</b> bereit: Sie erhalten eine E-Mail.',
    conversationMessengerImportClassicDetailStep12: 'Laden Sie die vollständige <b>.zip</b>-Datei auf Ihr Gerät herunter und legen Sie sie unten ab <b>ohne sie zu öffnen</b>. Nur der Chat, den Sie danach auswählen, wird für Ihr Buch verwendet.',
    conversationMessengerImportEncryptedDetailTitle: 'Export nach 2023: detaillierte Anleitung',
    conversationMessengerImportEncryptedDetailIntro: 'Folgen Sie jedem Schritt anhand der Screenshots unten. Sie können auch den Button oben nutzen, um Messenger.com zu öffnen und bei Schritt 2 zu beginnen.',
    conversationMessengerImportEncryptedDetailSkipApp: 'Ich bin schon auf Messenger.com: weiter bei Schritt 2',
    conversationMessengerImportEncryptedDetailStep1: 'Öffnen Sie auf dem Computer <b>Messenger.com</b> und klicken Sie unten links auf Ihr Profilbild.',
    conversationMessengerImportEncryptedDetailStep2: 'Klicken Sie auf <b>Datenschutz und Sicherheit</b>.',
    conversationMessengerImportEncryptedDetailStep3: 'Klicken Sie auf <b>Ende-zu-Ende-verschlüsselte Chats</b>.',
    conversationMessengerImportEncryptedDetailStep4: 'Klicken Sie auf <b>Sicherer Speicher</b>.',
    conversationMessengerImportEncryptedDetailStep5: 'Klicken Sie auf <b>Daten aus sicherem Speicher herunterladen</b>.',
    conversationMessengerImportEncryptedDetailStep6: 'Klicken Sie auf <b>Datei herunterladen</b>.',
    conversationMessengerImportEncryptedDetailStep7: 'Geben Sie Ihr Facebook-Passwort ein und klicken Sie auf <b>Bestätigen</b>.',
    conversationMessengerImportEncryptedDetailStep8: 'Klicken Sie auf <b>Herunterladen</b>. Die Vorbereitung kann einige Minuten dauern.',
    conversationMessengerImportEncryptedDetailStep9: 'Laden Sie die vollständige <b>.zip</b>-Datei auf Ihren Computer herunter und legen Sie sie unten ab <b>ohne sie zu öffnen</b>. Nur der Chat, den Sie danach auswählen, wird für Ihr Buch verwendet.',
    conversationMessengerImportMissingTip: 'Chat nicht in der Liste? Gehen Sie zurück und versuchen Sie den Export <b>Nach 2023</b>.',
    conversationMessengerImportEmptyTitle: 'Keine Unterhaltung in diesem Archiv gefunden',

    conversationSmsImportTagline: 'Keine Datei hier hochladen: alles läuft über unsere Software oder App.',
    conversationSmsImportIntro: 'Kein Datei-Upload auf dieser Seite. Alles läuft über unsere Software (iPhone) oder App (Android). Wählen Sie Ihre Konfiguration:',
    conversationSmsImportContext: 'Unsere Android-App ist <b>nicht bei Google Play</b>: SMS-Zugriff ist dort eingeschränkt. Zum Öffnen bitten Android und Play Protect um eine Bestätigung.',
    conversationSmsImportPlatformIphoneMac: 'iPhone + Mac',
    conversationSmsImportPlatformIphonePc: 'iPhone + PC',
    conversationSmsImportPlatformAndroid: 'Android',
    conversationSmsImportMacCta: 'Mac-Software herunterladen',
    conversationSmsImportPcCta: 'PC-Software herunterladen',
    conversationSmsImportAndroidCta: 'Android-App herunterladen',
    conversationSmsImportMacStep1: 'Laden Sie die Mac-Software herunter.',
    conversationSmsImportMacStep2: 'Installieren Sie sie und <b>lassen Sie sich führen</b>: die Software zeigt Ihnen die nächsten Schritte.',
    conversationSmsImportMacStep3: 'Wählen Sie die <b>Unterhaltung</b> für Ihr Konto und bleiben Sie bis zum Ende des Transfers auf dem Bildschirm.',
    conversationSmsImportMacStep4: 'Software unten installieren, <b>Vollständigen Festplattenzugriff</b> in Systemeinstellungen → Datenschutz gewähren, dann Unterhaltung zum Konto senden.',
    conversationSmsImportMacHelp: 'Falls die Software kein Backup findet: Systemeinstellungen → Datenschutz & Sicherheit → <b>Festplattenvollzugriff</b> → MonLivreSMS hinzufügen (Schloss unten links entsperren).',
    conversationSmsImportMacAlert: 'Kein Upload hier: der Transfer startet in der Software, die Sie auf dem Bildschirm führt.',
    conversationSmsImportPcStep1: 'Laden Sie die PC-Software herunter.',
    conversationSmsImportPcHelp: 'In iTunes <b>Lokales Backup verschlüsseln</b> deaktivieren, bevor Sie auf <b>Jetzt sichern</b> klicken. Visuelle Hilfe oben.',
    conversationSmsImportHelpToggle: 'Ausführlichere Hilfe nötig?',
    conversationSmsImportPcStep2: 'Installieren Sie sie und <b>lassen Sie sich führen</b>: die Software zeigt Ihnen die nächsten Schritte.',
    conversationSmsImportPcStep3: 'Wählen Sie die <b>Unterhaltung</b> für Ihr Konto und bleiben Sie bis zum Ende des Transfers auf dem Bildschirm.',
    conversationSmsImportPcStep4: 'Software unten installieren, starten (bei Windows-Warnung zulassen), dann Unterhaltung zum Konto senden.',
    conversationSmsImportPcAlert: 'Kein Upload hier: der Transfer startet in der Software, die Sie auf dem Bildschirm führt.',
    conversationSmsImportAndroidStep1: 'Laden Sie unsere <b>App außerhalb des Stores</b> unten herunter: SMS-Zugriff ist bei Google Play nicht erlaubt.',
    conversationSmsImportAndroidStep2: 'Öffnen Sie die heruntergeladene Datei. Wenn Android die Installation nicht zulässt, tippen Sie auf <b>Einstellungen</b>, aktivieren Sie <b>Installation aus dieser Quelle</b> und gehen Sie zurück.',
    conversationSmsImportAndroidStep3: 'Wenn <b>Play Protect</b> erscheint, tippen Sie auf <b>Weitere Details</b> und dann auf <b>Trotzdem installieren</b>. Tippen Sie danach auf <b>Installieren</b> und auf <b>Öffnen</b>.',
    conversationSmsImportAndroidStep4: 'Erlauben Sie in der App den Zugriff auf <b>SMS</b> und <b>Kontakte</b>.',
    conversationSmsImportAndroidStep5: 'Wählen Sie die <b>Unterhaltung</b> und bestätigen Sie. Bleiben Sie auf dem Bildschirm, bis die Übertragung fertig ist: Die Nachrichten gehen direkt auf Ihr Konto.',
    conversationSmsImportAndroidAlert: 'Keine Datei hier ablegen. Auf dem Transfer-Bildschirm in der App bleiben, damit alle Fotos erfasst werden.',
    conversationSmsImportFooter: 'Nach dem Transfer gestalten Sie Ihr Buch auf dieser Seite: die App leitet Sie automatisch weiter.',
	conversationSmsImportAndroidDetailIntro: 'Folgen Sie jedem Schritt auf Ihrem Android-Telefon. Die App ist <b>nicht im Google Play Store</b>. Android und danach Play Protect bitten um eine Bestätigung, bevor sie sich öffnet: Das ist normal.',
	conversationSmsImportAndroidDetailSkipApp: 'App bereits heruntergeladen: weiter bei Schritt 2',
	conversationSmsImportAndroidDetailStep1: 'Laden Sie unsere SMS-Export-App außerhalb von Google Play herunter (Schaltfläche unten): SMS-Zugriff ist im Play Store nicht erlaubt.',
	conversationSmsImportAndroidDetailStep2: 'Tippen Sie nach dem Download auf <b>Öffnen</b>.',
	conversationSmsImportAndroidDetailStep3: 'Tippen Sie auf <b>Einstellungen</b>, um die Installation zu erlauben.',
	conversationSmsImportAndroidDetailStep4: 'Aktivieren Sie <b>Installation aus dieser Quelle</b> und gehen Sie zurück zur Installation.',
	conversationSmsImportAndroidDetailStep5: 'Wenn <b>Play Protect</b> erscheint, tippen Sie auf <b>Weitere Details</b> und dann auf <b>Trotzdem installieren</b>. Installieren Sie die App, öffnen Sie sie und erlauben Sie den Zugriff auf SMS und Kontakte.',
	conversationSmsImportAndroidDetailStep6: 'Wählen Sie die gewünschte <b>Unterhaltung</b>.',
	conversationSmsImportAndroidDetailStep7: 'Bestätigen Sie: bleiben Sie bis zum Ende auf dem Übertragungsbildschirm, damit alle Fotos übertragen werden. Sie werden automatisch zur Buchpersonalisierung weitergeleitet.',
	conversationSmsImportAndroidDetailTitle: 'SMS-Export Android: ausführliche Anleitung',
	conversationSmsImportMacDetailIntro: 'Laden Sie die Software herunter und lassen Sie sich auf dem Bildschirm führen. Die Screenshots unten helfen vor allem bei der Installation.',
	conversationSmsImportMacDetailSkipSoftware: 'Software bereits heruntergeladen: weiter bei Schritt 8',
	conversationSmsImportMacDetailStep1: 'Verbinden Sie Ihr iPhone per USB-Kabel mit Ihrem Mac.',
	conversationSmsImportMacDetailStep10: 'Öffnen Sie <b>Systemeinstellungen</b> → <b>Datenschutz & Sicherheit</b>.',
	conversationSmsImportMacDetailStep11: 'Scrollen Sie nach unten und klicken Sie auf <b>Trotzdem öffnen</b>.',
	conversationSmsImportMacDetailStep12: 'Klicken Sie in der Sicherheitsabfrage auf <b>Erlauben</b>.',
	conversationSmsImportMacDetailStep13: 'Klicken Sie auf <b>Öffnen</b>.',
	conversationSmsImportMacDetailStep14: 'Klicken Sie auf <b>Weiter</b>.',
	conversationSmsImportMacDetailStep15: 'Klicken Sie erneut auf <b>Weiter</b>.',
	conversationSmsImportMacDetailStep16: 'Klicken Sie auf <b>Installieren</b>.',
	conversationSmsImportMacDetailStep17: 'Klicken Sie in der Sicherheitsabfrage erneut auf <b>Erlauben</b>.',
	conversationSmsImportMacDetailStep18: 'Klicken Sie auf <b>Schließen</b>, um den Assistenten zu beenden.',
	conversationSmsImportMacDetailStep19: 'Öffnen Sie <b>Finder</b> → <b>Programme</b> und starten Sie <b>MonLivreSMS</b>.',
	conversationSmsImportMacDetailStep2: 'Für Fotos im Buch: Öffnen Sie <b>Nachrichten</b>, wählen Sie die Unterhaltung und tippen Sie auf den <b>Kontaktnamen</b>.',
	conversationSmsImportMacDetailStep20: 'Klicken Sie oben links auf das <b>Apfelmenü</b> → <b>Systemeinstellungen</b>.',
	conversationSmsImportMacDetailStep21: 'Öffnen Sie <b>Datenschutz & Sicherheit</b> → <b>Vollständiger Festplattenzugriff</b>.',
	conversationSmsImportMacDetailStep22: 'Ziehen Sie das MonLivreSMS-Symbol in die Liste (lange klicken) und aktivieren Sie <b>Vollständiger Festplattenzugriff</b>.',
	conversationSmsImportMacDetailStep23: 'Klicken Sie zur Bestätigung auf <b>Öffnen</b>.',
	conversationSmsImportMacDetailStep24: 'Klicken Sie erneut auf <b>Öffnen</b>, falls eine zweite Bestätigung erscheint.',
	conversationSmsImportMacDetailStep25: 'Wählen Sie die <b>Unterhaltung</b> zum Export: Texte und Fotos werden an Ihr Konto gesendet. Bleiben Sie bis zum Ende auf dem Übertragungsbildschirm, mit stabiler Internetverbindung.',
	conversationSmsImportMacDetailStep3: 'Scrollen Sie ganz nach unten auf der Kontaktkarte.',
	conversationSmsImportMacDetailStep4: 'Tippen Sie auf <b>Herunterladen</b>, um alle iCloud-Fotos auf das iPhone zu importieren.',
	conversationSmsImportMacDetailStep5: 'Öffnen Sie den <b>Finder</b>, wählen Sie Ihr iPhone in der Seitenleiste, deaktivieren Sie <b>Lokale Sicherung verschlüsseln</b> und aktivieren Sie <b>Alle Daten auf diesem Mac sichern</b>.',
	conversationSmsImportMacDetailStep6: 'Klicken Sie auf <b>Jetzt sichern</b> und warten Sie, bis die Sicherung abgeschlossen ist.',
	conversationSmsImportMacDetailStep7: 'Laden Sie die MonLivreSMS-Software für Mac herunter (Schaltfläche unten auf dieser Seite).',
	conversationSmsImportMacDetailStep8: 'Doppelklicken Sie auf den heruntergeladenen Ordner <b>MonLivreSMS</b>.',
	conversationSmsImportMacDetailStep9: 'Klicken Sie auf <b>OK</b>, um die Installation zu starten.',
	conversationSmsImportMacDetailTitle: 'SMS-Export iPhone + Mac: ausführliche Anleitung',
	conversationSmsImportPcDetailIntro: 'Laden Sie die Software herunter und lassen Sie sich auf dem Bildschirm führen. Die Screenshots unten helfen vor allem bei der Installation.',
	conversationSmsImportPcDetailSkipSoftware: 'Software bereits heruntergeladen: weiter bei Schritt 3',
	conversationSmsImportPcDetailStep1: 'Verbinden Sie Ihr iPhone per USB-Kabel mit Ihrem PC.',
	conversationSmsImportPcDetailStep2: 'Laden Sie die MonLivreSMS-Software für PC herunter (Schaltfläche unten auf dieser Seite).',
	conversationSmsImportPcDetailStep3: 'Installieren Sie <link>iTunes</link>, falls noch nicht vorhanden.',
	conversationSmsImportPcDetailStep4: 'Starten Sie iTunes.',
	conversationSmsImportPcDetailStep5: 'Melden Sie sich mit Ihrer <b>Apple-ID</b> an und bestätigen Sie auf dem iPhone, falls nötig.',
	conversationSmsImportPcDetailStep6: 'Sobald das iPhone erkannt wird, klicken Sie auf <b>Weiter</b>.',
	conversationSmsImportPcDetailStep7: 'Unter <b>Übersicht</b> deaktivieren Sie <b>Lokale Sicherung verschlüsseln</b> und klicken auf <b>Jetzt sichern</b> (auf diesem Computer, nicht iCloud).',
	conversationSmsImportPcDetailStep8: 'Nach der Sicherung öffnen Sie den MonLivreSMS-Ordner. Bei einer Windows-Warnung klicken Sie auf <b>Weitere Informationen</b> dann <b>Trotzdem ausführen</b>. Wählen Sie anschließend die Unterhaltung für Ihr Konto.',
	conversationSmsImportPcDetailTitle: 'SMS-Export iPhone + PC: ausführliche Anleitung',
    /* --- sync 2026-06-29 --- */
    autocompleteSearch: 'Zum Suchen tippen…',
    cmsAdminListHint: 'Seiten, Panels und Übersetzungen bearbeiten. Flaggen zeigen den Übersetzungsstatus pro Sprache.',
    cmsContentDuplicateSuccess: 'CMS-Inhalt dupliziert!',
    cmsPageAdd: 'Seite hinzufügen',
    code: 'Code',
    configAdminHint: 'Anwendungseinstellungen, Affiliations, Hintergrundprozesse und Roh-Konfigurationsschlüssel.',
    console: 'Konsole',
    conversationAdminListHint: 'Alle Kundenunterhaltungen durchsuchen, filtern und verwalten. Status-Tabs zielen auf einen Funnel-Schritt.',
    conversationBackToList: 'Zurück zu meinen Unterhaltungen',
    conversationCreationDate: 'Erstellungsdatum',
    conversationCustomImportUpload: 'Generierte Datei importieren',
    conversationDownloadBackPreview: 'Zur Buchvorschau zurück',
    conversationDownloadEyebrow: 'Ihr Buch ist fertig',
    conversationDownloadHint: 'Laden Sie Ihr PDF herunter und behalten Sie eine digitale Kopie Ihrer Unterhaltung.',
    conversationDownloadLoading: 'Dateien werden vorbereitet…',
    conversationFlags: 'Flaggen',
    conversationHighlightShareImageButton: 'Bild senden',
    conversationHighlightsEmpty: 'Für Zahlen braucht diese Unterhaltung noch ein paar Nachrichten mehr.',
    conversationHighlightsLoading: 'Ihre Zahlen werden zusammengestellt.',
    conversationImages: 'Bilder',
    conversationMedias: 'Medien',
    conversationMergeSelect: 'Diese Unterhaltung auswählen',
    conversationMergeUnselect: 'Auswahl aufheben',
    conversationOrders: 'Bestellungen',
    conversationPreviewCoverEditButton: 'Cover bearbeiten',
    conversationPreviewCoverOpenLabel: 'Buch öffnen',
    conversationPreviewCustomizeClose: 'Personalisierung schließen',
    conversationPreviewCustomizeDone: 'Personalisierung abschließen',
    conversationPreviewEditionBelowHint: 'Wählen Sie Ihre Edition weiter unten',
    conversationPreviewEditionScrollLabel: 'Zur Auswahl der Edition',
    conversationPrinterMode: 'Druckermodus',
    copiedToClipboard: 'Kopiert!',
    country: 'Land',
    dateStatus: 'Statusdatum',
    dateValidation: 'Validierungsdatum',
    dates: 'Daten',
    identifier: 'Kennung',
    loadMore: 'Mehr laden…',
    orderAdminListHint: 'Bestellungen nach Status verfolgen und bearbeiten. Filter nach Land, Produkt oder Validierungsdatum.',
    orderConfirmationGuestTitle: 'Bleiben Sie informiert',
    orderConfirmationHomeCta: 'Zur Startseite',
    orderConfirmationNextStepsTitle: 'Wie geht es weiter?',
    orderConfirmationOrderNumber: 'Bestellung Nr. {code}',
    orderConfirmationPaymentWaitingHint: 'Das dauert in der Regel nur wenige Sekunden.',
    orderConfirmationStepEmail: 'Bestätigung per E-Mail',
    orderConfirmationStepEmailDesc: 'Eine Zusammenfassung wurde an {email} gesendet',
    orderConfirmationStepEmailDescNoEmail: 'Eine Zusammenfassung wird per E-Mail gesendet',
    orderConfirmationStepPreparation: 'Ihr Buch wird vorbereitet',
    orderConfirmationStepPreparationDesc: 'Wir drucken und binden Ihr Buch sorgfältig',
    orderConfirmationStepShipping: 'Versand',
    orderConfirmationStepShippingDesc: 'Sie erhalten eine E-Mail, sobald Ihr Paket versendet wird',
    orderConfirmationSummaryTitle: 'Ihre Bestellung',
    orderConfirmationViewOrderCta: 'Bestellung verfolgen',
    orderFlags: 'Flaggen',
    orderMassExportInvoiceDetails: 'Rechnungsdetails exportieren',
    orderMassSendEmail: 'E-Mail senden',
    orderMassUpdateStatus: 'Status aktualisieren',
    orderNote: 'Notiz',
    orderNoteAdmin: 'Interne Notiz (Admin)',
    orderNoteAdminAdd: 'Notiz hinzufügen',
    orderNoteAdminEmpty: 'Keine internen Notizen für diese Bestellung.',
    orderNoteAdminPlaceholder: 'Interne Notiz nur für das Team (Versand, Support…)',
    orderPaymentMethod: 'Zahlungsmethode',
    orderPublicAccess: 'Öffentlicher Zugang',
    orderSendStatusNotificationEmail: 'Benachrichtigungs-E-Mail senden',
    orderViewShort: 'Bestellung',
    ordersEditSuccess: 'Bestellungen aktualisiert!',
    product: 'Produkt',
    productAdd: 'Produkt hinzufügen',
    productAdminListHint: 'Katalog, Preise und Verfügbarkeit im Shop verwalten.',
    seoOrderViewTitle: 'Bestellung Nr. {code}',
    shippingAdd: 'Versandart hinzufügen',
    shippingAdminListHint: 'Spediteure, Länder und Preisregeln für Lieferungen konfigurieren.',
    shippingMethod: 'Versandart',
    tableDownloadNoElementError: 'Nichts zum Herunterladen!',
    tablePageSize: 'Pro Seite',
    taskAddTitle: 'Aufgabe hinzufügen',
    taskAssignSelf: 'Mir zuweisen',
    taskCountdownDate: 'Erinnerungsdatum',
    userAccountNote: 'Benutzerkontonotiz',
    userAdminListHint: 'Konten suchen, Aktivität ansehen und Profil oder Bestellungen eines Nutzers öffnen.',
    vatExempt: 'MWST.-BEFREIT',
    voucherAdd: 'Gutschein hinzufügen',
    voucherAdminListHint: 'Promo-Codes, Bedingungen und Nutzungslimits erstellen und verwalten.',

	offerErrorRequired: 'Bitte füllen Sie die Pflichtfelder aus.',
	offerErrorEmail: 'Bitte prüfen Sie Ihre E-Mail-Adresse.',
	offerErrorGiftEmail: 'Bitte prüfen Sie die E-Mail-Adresse der beschenkten Person.',
	offerErrorGiftSameEmail: 'Die E-Mail-Adresse der beschenkten Person muss sich von Ihrer unterscheiden.',
	offerErrorGeneric: 'Hoppla, das hat nicht geklappt. Bitte versuchen Sie es gleich noch einmal.',
	offerStepWhoEyebrow: 'Los geht\'s',
	offerStepWhoTitle: 'Wer wird das Buch gestalten?',
	offerStepWhoHint: 'Sie gestalten es selbst, für sich oder zum Verschenken. Eine Geschenkkarte ist für den Fall, dass die andere Person es erstellt.',
	offerWhoSelf: 'Ich werde es gestalten',
	offerWhoSelfHint: 'Für mich, oder zum Verschenken nach dem Druck',
	offerWhoGift: 'Ich verschenke eine Geschenkkarte',
	offerWhoGiftHint: 'Die Person erhält einen Link und gestaltet ihr Buch selbst',
	offerStepOccasionEyebrow: 'Der Anlass',
	offerStepOccasionHint: 'Der Moment, an den Sie denken.',
	offerStepGiftEyebrow: 'Ihr Geschenk',
	offerStepGiftTitle: 'Wem möchten Sie es schenken?',
	offerStepGiftHint: 'Wir senden das Geschenk per E-Mail, mit einem Link zum Gestalten des Buches. Nichts ausdrucken, nichts einpacken.',
	offerGiftName: 'Vorname der beschenkten Person',
	offerGiftEmail: 'E-Mail-Adresse der beschenkten Person',
	offerGiftEmailHelp: 'Das Geschenk kommt direkt nach der Zahlung in diesem Postfach an.',
	offerGiftFromName: 'Ihr Vorname',
	offerGiftFromNameHelp: 'Damit klar ist, von wem das Geschenk kommt.',
	offerGiftMessage: 'Eine kleine Nachricht (optional)',
	offerGiftMessagePlaceholder: 'Damit diese Nachrichten dir immer nah bleiben.',
	offerContinue: 'Weiter',
	offerStepMessengerEyebrow: 'Ihre Nachrichten',
	offerStepMessengerTitleGift: 'Wo sind die Nachrichten für das Buch von {name}?',
	offerStepMessengerTitle: 'Wo sind Ihre schönsten Nachrichten?',
	offerStepMessengerHint: 'Wählen Sie eine aus. Sie können das später noch ändern.',
	offerStepMessengerHintGift: 'Ihr Gespräch mit {name} oder das von {name} mit einem geliebten Menschen. Nicht sicher, welche App? {name} kann auch eine andere wählen.',
	offerStepEmailEyebrow: 'Fast geschafft',
	offerStepEmailTitle: 'Ihr Konto',
	offerStepEmailHintGift: 'Google, Apple oder Ihre E-Mail. Wir senden eine Bestätigung, danach bezahlen Sie die Geschenkkarte.',
	offerStepEmailHint: 'Google, Apple oder Ihre E-Mail. Wir senden eine Bestätigung, danach importieren Sie das Gespräch.',
	offerStepEmailHintPay: 'Google, Apple oder Ihre E-Mail. Wir senden eine Bestätigung, danach bezahlen Sie das Buch.',
	offerEmailLabel: 'E-Mail-Adresse',
	offerEmailPlaceholder: 'name@beispiel.de',
	offerEmailSubmit: 'Weiter zur Zahlung',
	offerEmailSubmitAccount: 'Konto erstellen',
	offerEmailPrivacy: 'Nur Ihr Buch. Schauen Sie auch im Spam-Ordner nach.',
	offerStepSentEyebrow: 'Schön, Sie wiederzusehen',
	offerStepSentTitle: 'Sie haben bereits ein Konto',
	offerStepSentCodeHint: 'Wir haben gerade einen 6-stelligen Code an {email} gesendet. Geben Sie ihn hier ein: Ihre Bestellung wartet auf Sie, bereit zur Zahlung. Schauen Sie auch im Spam-Ordner nach.',
	offerStepSentCodeHintAccount: 'Wir haben gerade einen 6-stelligen Code an {email} gesendet. Geben Sie ihn hier ein, um Ihr Konto zu öffnen und das Buch zu beginnen. Schauen Sie auch im Spam-Ordner nach.',
	offerStepPayEyebrow: 'Letzter Schritt',
	offerStepPayTitleGift: 'Das Buch für {name}',
	offerStepPayTitle: 'Ihr gedrucktes Buch',
	offerLoggedAs: 'Angemeldet als {email}',
	offerSwitchAccount: 'Nicht Ihr Konto?',
	offerTrustReviews: 'Über {count} Bewertungen auf Trustpilot',
	offerTrustGuarantee: 'Geld-zurück-Garantie',
	offerTrustShipping: 'Kostenloser Versand',
	offerPageTitle: 'Ihr Buch voller Nachrichten',
	offerBack: 'Zurück',
	offerItemName: 'Gedrucktes Buch zum Gestalten',
	offerPayBenefitBook: 'Ihr gedrucktes Buch, gestaltet mit Ihren Nachrichten und Fotos',
	offerPayBenefitBookGift: 'Ein echtes gedrucktes Buch, mit Nachrichten und Fotos nach Wahl',
	offerPayBenefitMedia: 'Auch Sprachnachrichten und Videos, zum Wiedererleben über gedruckte QR-Codes',
	offerPayBenefitCustom: 'Cover, Foto, Titel, Farben, Vorwort: alles lässt sich personalisieren',
	offerPayBenefitPdf: 'Das PDF gibt es gratis zum Buch dazu',
	offerPayBenefitShipping: 'Kostenloser Versand',
	offerPayTotal: 'Gesamt',
	offerPayNextGift: 'Direkt nach der Zahlung erhält {name} Ihr Geschenk per E-Mail.',
	offerPayNextSelf: 'Direkt nach der Zahlung importieren Sie das Gespräch. Das dauert nur wenige Minuten.',
	offerPayDreamSelf: 'Die Nachrichten, die Sie auf Ihrem Handy immer wieder lesen, bald in Ihren Händen. Für immer.',
	offerPayDreamGift: 'An dem Tag, an dem {name} es aufschlägt, werden all diese Nachrichten lebendig.',
	offerPayButton: '{price} bezahlen',
	offerPaySecure: 'Sichere Zahlung. Kein Abo.',
	offerConfirmStepsTitle: 'So funktioniert\'s',
	offerConfirmGiftStep1: '{name} öffnet die E-Mail und klickt auf den Link',
	offerConfirmGiftStep2: '{name} importiert das Gespräch in wenigen Minuten',
	offerConfirmGiftStep3: 'Wir drucken das Buch und liefern es aus',
	offerConfirmGiftTitle: 'An {name} verschickt!',
	offerConfirmGiftLead: '{name} hat Ihr Geschenk soeben an {email} erhalten, mit einem Link zum Gestalten des Buches. Es ist bereits bezahlt, Versand inklusive.',
	offerConfirmViewOrder: 'Meine Bestellung ansehen',
	offerConfirmGiftNote: 'Nicht angekommen? Bitten Sie die beschenkte Person, im Spam-Ordner nachzusehen, oder schreiben Sie uns.',
	offerConfirmStep1: 'Exportieren Sie Ihr Gespräch aus {messenger}',
	offerConfirmStep1Generic: 'Exportieren Sie Ihr Gespräch aus Ihrer Messenger-App',
	offerConfirmStep2: 'Importieren Sie es hier: Um das Layout kümmern wir uns',
	offerConfirmStep3: 'Geben Sie Ihr Buch frei: Wir drucken es und schicken es Ihnen zu',
	offerConfirmTitle: 'Geschafft, Ihr Buch ist bezahlt!',
	offerConfirmLead: 'Nur noch eine Sache: Importieren Sie Ihr {messenger}-Gespräch. Wir begleiten Sie Schritt für Schritt, es dauert nur wenige Minuten.',
	offerConfirmLeadGeneric: 'Nur noch eine Sache: Importieren Sie Ihr Gespräch. Wir begleiten Sie Schritt für Schritt, es dauert nur wenige Minuten.',
	offerConfirmCta: 'Mein {messenger}-Gespräch importieren',
	offerConfirmCtaGeneric: 'Mein Gespräch importieren',
	offerConfirmChangeMessenger: 'Meine Nachrichten sind in einer anderen App',
	offerConfirmEmailNote: 'Ihre Zahlungsbestätigung und Ihr Anmeldelink wurden an {email} gesendet.',
	userMagicTitle: 'Anmeldung',
	userMagicWorking: 'Sie werden angemeldet…',
	userMagicExpired: 'Dieser Link ist abgelaufen. Fordern Sie mit einem Klick einen neuen an.',
	userMagicInvalid: 'Dieser Link ist nicht mehr gültig. Fordern Sie mit einem Klick einen neuen an.',
	userMagicSent: 'Falls ein Konto mit dieser Adresse existiert, ist ein neuer Link unterwegs. Schauen Sie auch in Ihren Spam-Ordner.',
	userMagicEmailLabel: 'Ihre E-Mail-Adresse',
	userMagicSend: 'Neuen Link anfordern',
	conversationPreviewBookCreditRemaining: '+{price}',
	conversationPreviewIncluded: 'Inklusive',
	conversationPreviewCollectionPrepaidNote: '{count} Bände · {paid} bereits bezahlt',
	conversationPreviewBookCreditBannerBestof: 'Ihr Buch ist bereits bezahlt: Das Best Of ist inklusive. Lieber die Gesamtsammlung? Dann zahlen Sie nur die Differenz.',
	conversationPreviewBookCreditBanner: 'Ihr Buch ist bereits bezahlt, Standardversand inklusive. Gestalten Sie es nach Ihren Wünschen und schließen Sie dann Ihre Bestellung ab.',
	conversationOrderButtonBookCreditRemaining: 'Mein Buch abschließen · noch {price}',
	conversationOrderButtonBookCreditIncluded: 'Mein Buch abschließen · Inklusive',
	conversationPreviewBookCreditOrderHint: '{credit} bereits bezahlt · Listenpreis {fullPrice}',
	conversationOrderButtonBookCredit: 'Mein Buch abschließen',
	conversationPreviewStickyBookCredit: 'Buch bereits bezahlt',
	paymentMethodBookCreditHint: 'Ihr Buch ist bereits bezahlt',
	cartTotalsBookCredit: 'Buch bereits bezahlt',
	paymentMethodBookcredit: 'Im Voraus bezahltes Buch',
  },
};
